import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import {
  withStyles,
  Grid,
  Button,
  Box,
  Typography,
  IconButton,
  TextField,
  Snackbar,
  Switch,
  CircularProgress,
  TextareaAutosize,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Tooltip,
  Drawer,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Collapse,
  ButtonGroup,
  Grow,
  Paper,
  Popper,
  MenuList,
  Tabs,
  Tab,
  NativeSelect,
  InputBase,
  ClickAwayListener,
  Fab,
  TablePagination,
  Divider,
  Chip,
} from "@material-ui/core";
import {
  ArrowBackOutlined,
  Edit,
  ExpandMore,
  ArrowDropDown,
  Close,
  CloseOutlined,
  WarningOutlined,
  WhatsApp,
  OpenInNew,
} from "@material-ui/icons";
import Clear from "@material-ui/icons/Clear";
import GetApp from "@material-ui/icons/GetApp";
import { Autocomplete, Alert } from "@material-ui/lab";
import SyncIcon from "@material-ui/icons/Sync";
import axios from "axios";
import {
  URL,
  ADMIN_KEY,
  AISENSY_PARTNER_ID,
  APP_URL,
  CAMPAIGN_URL,
  INTEGRATION_SERVER_URL,
  CHARGEBEE_REDIRECT_URL,
  partnerURL,
  PARTNER_APP_URL,
  TENANT_ID,
  URL as CLIENT_URL,
  VYAPAAR_APP_URL,
} from "../../config/config";
import { validLimits } from "../../config/rateLimits";
import moment from "moment";
import PlanFamily from "../../commons/PlanFamily/PlanFamily";
import { isEmpty } from "lodash";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { downloadCSV } from "../../helpers/csvExport";
import { bvbpErrorMessage, bvbpSuccessMessage } from "../../helpers/bvbpHelper";
import ReactJson from "react-json-view";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { DateRangePicker } from "react-dates";
import ApplyBvbp from "./ApplyBvbp.js";
import Flows from "./Flows.js";
import DashboardLockModal from "./DashboardLockModal.js";
import {
  verifySubRouteAccess,
  isGlobalAdmin,
} from "../../helpers/accessControlHelper.js";
import ConversionEventsTable from "../../components/googleAds/ConversionEventTable.jsx";
import {
  ownerLoginMode,
  ownerLoginEndpoint,
  ownerLoginLabel,
  ownerLoginMenu,
  loginUrlCopiedMessage,
} from "../../helpers/ownerLogin.helper";

const options = [
  "Owner Login",
  // "WhiteLabel Login",
  "Partner Dashboard Login",
  "Copy Login URL",
  "Copy Vyapaar Login URL",
];

const Webhook_Topics = [
  { id: 1, label: "contact.created" },
  { id: 2, label: "contact.attribute.updated" },
  { id: 3, label: "message.created" },
  { id: 4, label: "message.status.updated" },
  { id: 5, label: "contact.tag.added" },
  { id: 6, label: "contact.tag.removed" },
  { id: 7, label: "contact.first_message.added" },
  { id: 8, label: "contact.first_message.removed" },
  { id: 9, label: "contact.chat.intervened" },
  { id: 10, label: "contact.chat.closed" },
  { id: 11, label: "contact.chat.requesting" },
  { id: 12, label: "contact.campaign.sent" },
  { id: 13, label: "contact.campaign.delivered" },
  { id: 14, label: "contact.campaign.read" },
  { id: 15, label: "message.sender.user" },
  { id: 16, label: "payment.captured" },
  { id: 17, label: "payment.refunded" },
  { id: 18, label: "order.placed" },
  { id: 19, label: "message_status" },
  { id: 20, label: "incoming_message" },
  { id: 21, label: "calls" },
  { id: 22, label: "message_template_status_update" },
  { id: 23, label: "phone_number_quality_update" },
  { id: 24, label: "phone_number_name_update" },
  { id: 25, label: "account_alerts" },
  { id: 26, label: "account_review_update" },
  { id: 27, label: "account_update" },
  { id: 28, label: "business_capability_update" },
  { id: 29, label: "message_template_quality_update" },
  { id: 30, label: "security" },
  { id: 31, label: "template_category_update" },
  { id: 32, label: "campaign_status_update" },
  { id: 33, label: "business_status_update" },
  { id: 34, label: "message.clicked" },
  { id: 36, label: "contact.first_message.updated" },
  { id: 37, label: "contact.tag.updated" },
  { id: 38, label: "contact.attribute.revised" },
  { id: 39, label: "call.connect" },
  { id: 40, label: "call.status" },
  { id: 41, label: "call.terminated" },
  { id: 42, label: "message_echoes" },
  { id: 43, label: "smb_message_echoes" },
  { id: 44, label: "smb_app_state_sync" },
  // Backend has accepted this topic since it was seeded (seedStreamTopics.js,
  // isEnabled: true) and it is in projectValidators allTopics, but it was never
  // listed here - so Ops could not select it for a project (MSG-216).
  { id: 45, label: "contact.leadstage.updated" },
  { id: 46, label: "contact.note.added" },
  { id: 47, label: "contact.note.removed" },
  { id: 48, label: "contact.note.updated" },
  // Meta page lead form submissions (emitted by webhook-server-v2).
  { id: 49, label: "lead_form.submitted" },
];

const MEDIA_CONTENT_SIZES = [
  "1GB",
  "5GB",
  "10GB",
  "15GB",
  "20GB",
  "25GB",
  "30GB",
  "35GB",
  "40GB",
  "45GB",
  "50GB",
];

const PLANS = [
  "BASIC_TRIAL",
  "BASIC_MONTHLY",
  "BASIC_DIWALI_MONTHLY",
  "PRO_MONTHLY",
  "ENTERPRISE_MONTHLY",
  "BASIC_YEARLY",
  "BASIC_DIWALI_YEARLY",
  "PRO_YEARLY",
  "ENTERPRISE_YEARLY",
  "FREE",
  "LITE",
  "PRO",
  "PLUS",
  "PREMIUM",
  "BASIC_MONTHLY_TIER_1",
  "BASIC_MONTHLY_TIER_2",
  "BASIC_MONTHLY_TIER_3",
  "BASIC_MONTHLY_TIER_4",
  "BASIC_MONTHLY_TIER_5",
  "BASIC_MONTHLY_TIER_6",
  "BASIC_MONTHLY_TIER_7",
  "BASIC_MONTHLY_TIER_8",
  "BASIC_YEARLY_TIER_1",
  "BASIC_YEARLY_TIER_2",
];

const PROJECT_STATUS = [
  "active",
  "unpaid",
  "terminated",
  "pending",
  "suspended",
  "stopped",
  "archived",
];

const Tier_Limit = [
  { name: "Tier -2 : 2", value: 2 },
  { name: "Tier -1 : 50", value: 50 },
  { name: "Tier 0 : 250", value: 250 },
  { name: "Tier 1 : 2000", value: 2000 },
  { name: "Tier 2 : 10,000", value: 10000 },
  { name: "Tier 3 : 1,00,000", value: 100000 },
  { name: "Tier 4 : 10,00,000", value: 1000000 },
];

const WHATSAPP_PAY_TYPES = [
  { name: "Native Whatsapp Gateway", value: "native_whatsapp_gateway" },
  {
    name: "Native Whatsapp Gateway , Payment Link",
    value: "native_whatsapp_gateway+payment_link",
  },
  { name: "Payment Link", value: "payment_link" },
  { name: "Native Whatsapp UPI", value: "native_whatsapp_upi" },
  {
    name: "Native Whatsapp UPI , Payment Link",
    value: "native_whatsapp_upi+payment_link",
  },
  {
    name: "Disabled",
    value: "",
  },
];

const TEMPLATE_ENABLE_BY_META_TYPES = [
  { name: "Completed", value: "COMPLETED" },
  { name: "Approved", value: "APPROVED" },
  {
    name: "Requested",
    value: "REQUESTED",
  },
  {
    name: "Disabled",
    value: "",
  },
];

const WABATPT_TIERS_THROUGHTPUT = {
  TIER_0: 20,
  TIER_1: 40,
  TIER_2: 80,
  TIER_3: 150,
  TIER_4: 250,
  TIER_5: 500,
  TIER_6: 1000,
};

const WABATPT_TIERS = Object.keys(WABATPT_TIERS_THROUGHTPUT);

// function getStatusColor() {
//   const templateStatus = "PENDING";
//   switch (templateStatus) {
//     case "PENDING":
//       return "grey";
//     case "APPROVED":
//       return "#08CF65";
//     case "REJECTED":
//       return "#ff0000";
//     default:
//       return "pink";
//   }
// }
// const ADD_ONS = [
//   {
//     name: "Single Sign On",
//     key: "SSO",
//   },
//   {
//     name: "Webhooks",
//     key: "WEBHOOKS",
//   },
//   {
//     name: "Shopify Integration",
//     key: "SHOPIFY",
//   },
//   {
//     name: "Woocommerce Integration",
//     key: "WOOCOMMERCE",
//   },
//   {
//     name: "Meta Ads",
//     key: "META_ADS",
//   },
//   {
//     name: "Flow Builder",
//     key: "FLOW_BUILDER",
//   },
// ];

const PARTNER_PLANS = [
  "BASIC_MONTHLY",
  "PRO_MONTHLY",
  "ENTERPRISE_MONTHLY",
  "BASIC_YEARLY",
  "PRO_YEARLY",
  "ENTERPRISE_YEARLY",
];

const AI_MESSAGE_PACK_QUOTAS = {
  "AI-Messages-7k": 7000,
  "AI-Messages-15k": 15000,
  "AI-Messages-30k": 30000,
  "AI-Messages-50k": 50000,
  "AI-Messages-100k": 100000,
};

const getQuotaForPackTier = (packTier) => {
  if (!packTier) return null;
  const prefix = Object.keys(AI_MESSAGE_PACK_QUOTAS).find((k) =>
    packTier.startsWith(k + "-")
  );
  return prefix ? AI_MESSAGE_PACK_QUOTAS[prefix] : null;
};

const AI_MESSAGE_PACK_TIERS = [
  "AI-Messages-7k-INR-Monthly",
  "AI-Messages-7k-INR-Every-3-months",
  "AI-Messages-7k-INR-Yearly",
  "AI-Messages-7k-USD-Monthly",
  "AI-Messages-7k-USD-Every-3-months",
  "AI-Messages-7k-USD-Yearly",
  "AI-Messages-15k-INR-Monthly",
  "AI-Messages-15k-INR-Every-3-months",
  "AI-Messages-15k-INR-Yearly",
  "AI-Messages-15k-USD-Monthly",
  "AI-Messages-15k-USD-Every-3-months",
  "AI-Messages-15k-USD-Yearly",
  "AI-Messages-30k-INR-Monthly",
  "AI-Messages-30k-INR-Every-3-months",
  "AI-Messages-30k-INR-Yearly",
  "AI-Messages-30k-USD-Monthly",
  "AI-Messages-30k-USD-Every-3-months",
  "AI-Messages-30k-USD-Yearly",
  "AI-Messages-50k-INR-Monthly",
  "AI-Messages-50k-INR-Every-3-months",
  "AI-Messages-50k-INR-Yearly",
  "AI-Messages-50k-USD-Monthly",
  "AI-Messages-50k-USD-Every-3-months",
  "AI-Messages-50k-USD-Yearly",
  "AI-Messages-100k-INR-Monthly",
  "AI-Messages-100k-INR-Every-3-months",
  "AI-Messages-100k-INR-Yearly",
  "AI-Messages-100k-USD-Monthly",
  "AI-Messages-100k-USD-Every-3-months",
  "AI-Messages-100k-USD-Yearly",
];

const WEBHOOK_NAMESPACES = [
  { value: "All", label: "All Webhook Logs" },
  { value: "ProjectWebhook", label: "Project Webhook Logs" },
  { value: "WebEngageWebhook", label: "WebEngage Webhook Logs" },
  { value: "MoEngageWebhook", label: "MoEngage Webhook Logs" },
  { value: "CleverTapWebhook", label: "CleverTap Webhook Logs" },
  { value: "DirectApiWebhook", label: "DirectApi Webhook Logs" },
  { value: "LeadsquaredWebhook", label: "LeadSquared Webhook Logs" },
  { value: "PartnerWebhook", label: "Partner Webhook Logs" },
];

const DIRECT_API_SUBTYPES = [
  { value: "status_event", label: "Status Event" },
  { value: "incoming_message", label: "Incoming Message" },
];

const WEBHOOK_NAMESPACE_FILTERS = {
  ProjectWebhook: [
    { key: "topic", label: "Topic" },
    { key: "phoneNumber", label: "Phone Number" },
    { key: "messageId", label: "Message ID" },
  ],
  WebEngageWebhook: [{ key: "toNumber", label: "To Number" }],
  MoEngageWebhook: [{ key: "msgId", label: "Msg ID" }],
  CleverTapWebhook: [{ key: "msgId", label: "Msg ID" }],
  DirectApiWebhook: {
    status_event: [
      { key: "statusId", label: "Status ID" },
      { key: "recipientId", label: "Recipient ID" },
    ],
    incoming_message: [
      { key: "messageId", label: "Message ID" },
      { key: "from", label: "From" },
    ],
  },
  LeadsquaredWebhook: [
    { key: "statusId", label: "Status ID" },
    { key: "recipientId", label: "Recipient ID" },
  ],
};

const webhookStatusLabel = (log) => {
  if (log.succededAt) return "Success";
  if (log.failedAt) return "Failed";
  return "Pending";
};

const formatDate = (v) => (v ? new Date(v).toLocaleString() : "");

// ── Autopay mandate presentation helpers (superadmin Finance tab) ───────────
// The finance view returns the currently-VALID mandate as `method`, else the most
// recent row as `latest_method` (a cancelled / revoked / expired mandate) so its
// death stays visible. These turn a method row into a plain-English status +
// colour so finance can tell at a glance whether an auto-debit can even succeed.
const rupeesFromPaise = (paise) =>
  `₹${(Number(paise || 0) / 100).toLocaleString("en-IN")}`;

// AiSensy palette tones. `chip`/`chipText` = solid status badge; `soft` /
// `softBorder` / `ink` = the light warning banner (dark readable text on a tint).
const TONE = {
  // brand green (#04cf66) with dark-teal text (#0a474c) — usable, will auto-debit
  ok: { chip: "#04cf66", chipText: "#0a474c", ink: "#0f7a3d", soft: "#e7f6ee", softBorder: "#bfe6cf" },
  // yellow — in progress / paused (dark text for contrast)
  warn: { chip: "#ffc400", chipText: "#4a3b00", ink: "#8a6d00", soft: "#fff8e1", softBorder: "#ffe082" },
  // AiSensy red — cannot be charged; collect manually
  dead: { chip: "#c62828", chipText: "#ffffff", ink: "#c62828", soft: "#fdecea", softBorder: "#f4c7c3" },
  // grey — none / neutral
  muted: { chip: "#6b7280", chipText: "#ffffff", ink: "#6b7280", soft: "#eceff1", softBorder: "#cfd8dc" },
};

// One human status + tone for a mandate method row.
const mandateStatus = (m) => {
  if (!m) return { label: "No mandate", tone: "muted" };
  const status = (m.status || "").toLowerCase();
  const token = (m.token_status || "").toLowerCase();
  const expired =
    status === "expired" ||
    (m.expires_at && new Date(m.expires_at) < new Date());

  if (status === "revoked" || token === "cancelled")
    return { label: "Cancelled / revoked", tone: "dead" };
  if (status === "invalid" || token === "rejected")
    return { label: "Rejected", tone: "dead" };
  if (expired) return { label: "Expired", tone: "dead" };
  if (status === "superseded")
    return { label: "Replaced by newer mandate", tone: "muted" };
  if (token === "paused") return { label: "Paused by customer", tone: "warn" };
  if (status === "valid") return { label: "Active", tone: "ok" };
  if (status === "pending") return { label: "Pending confirmation", tone: "warn" };
  return { label: m.status || "Unknown", tone: "muted" };
};

// A mandate that cannot currently take an auto-debit → finance must collect manually.
const mandateIsDead = (m) => mandateStatus(m).tone === "dead";

const lastDebitLabel = (s) => {
  const v = (s || "").toLowerCase();
  if (v === "success") return "Succeeded";
  if (v === "failed") return "Failed";
  if (v === "initiated") return "In progress";
  return s || "—";
};

const WEBHOOK_LOG_CSV_COLUMNS = [
  { key: "_id", label: "_id" },
  { key: "namespace", label: "Namespace" },
  { key: "url", label: "URL" },
  { key: "method", label: "Method" },
  { key: "_status", label: "Status", format: (_, row) => webhookStatusLabel(row) },
  { key: "timeTaken", label: "Time Taken (ms)" },
  { key: "receivedAt", label: "Received At", format: formatDate },
  { key: "succededAt", label: "Succeeded At", format: formatDate },
  { key: "failedAt", label: "Failed At", format: formatDate },
  { key: "createdAt", label: "Created At", format: formatDate },
  { key: "updatedAt", label: "Updated At", format: formatDate },
  { key: "groupId", label: "Group ID" },
  { key: "uniqueId", label: "Unique ID" },
  { key: "maxRetry", label: "Max Retry" },
  { key: "timeout", label: "Timeout" },
  { key: "errorMessages", label: "Error Messages" },
  { key: "headers", label: "Headers" },
  { key: "body", label: "Body" },
];

//  MSG-316 — integrations a project is connected to, with a way to disconnect
//  them. Support previously needed an engineer for this: the customer-facing
//  disconnect sits behind a plan gate in the console, so a free-forever
//  customer is told to buy a plan in order to disconnect.
//
//  Self-contained rather than class state so the fetch happens on mount, not
//  during render.
function IntegrationsPanel({ assistantId, onSnackbar }) {
  const [integrations, setIntegrations] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pendingDisconnect, setPendingDisconnect] = React.useState(null);
  const [disconnecting, setDisconnecting] = React.useState(false);

  const load = React.useCallback(() => {
    if (!assistantId) return;
    setLoading(true);
    axios
      .post(URL + "/superadmin/get-project-integrations", { assistantId })
      .then((response) => {
        setIntegrations(response?.data?.integrations || []);
      })
      .catch((error) => {
        onSnackbar?.(
          error?.response?.data?.errorMessage ||
            error?.response?.data?.message ||
            "Failed to load integrations",
          "error"
        );
      })
      .finally(() => setLoading(false));
  }, [assistantId, onSnackbar]);

  React.useEffect(() => {
    load();
  }, [load]);

  const handleDisconnect = () => {
    if (!pendingDisconnect) return;
    setDisconnecting(true);
    axios
      .post(URL + "/superadmin/disconnect-project-integration", {
        assistantId,
        type: pendingDisconnect.type,
        ...(pendingDisconnect.installedAppId && {
          installedAppId: pendingDisconnect.installedAppId,
        }),
      })
      .then((response) => {
        onSnackbar?.(response?.data?.message || "Disconnected", "success");
        //  Re-read rather than dropping the row locally: disconnect is
        //  idempotent and may answer "already disconnected", so the server's
        //  view is the only trustworthy one.
        load();
      })
      .catch((error) => {
        onSnackbar?.(
          error?.response?.data?.errorMessage ||
            error?.response?.data?.message ||
            "Failed to disconnect",
          "error"
        );
      })
      .finally(() => {
        setDisconnecting(false);
        setPendingDisconnect(null);
      });
  };

  return (
    //  The shared tab container is width:100% with a 13% left margin, so it
    //  runs wider than the viewport. Bounding this panel keeps the row's
    //  right-hand Disconnect button on screen instead of clipped off the edge.
    <Box p={2} style={{ width: "100%", maxWidth: 860, boxSizing: "border-box" }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Typography variant="h6" style={{ fontWeight: "bold" }}>
          Connected Integrations
        </Typography>
        <Button
          size="small"
          variant="outlined"
          disabled={loading}
          onClick={load}
        >
          Refresh
        </Button>
      </Box>

      <Typography variant="body2" style={{ color: "#666", marginBottom: 16 }}>
        Disconnecting here bypasses the plan gate in the customer dashboard and
        takes effect immediately for the customer.
      </Typography>

      {loading && (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress size={28} />
        </Box>
      )}

      {!loading && integrations.length === 0 && (
        <Typography variant="body1" style={{ color: "#888" }}>
          No connected integrations found for this project.
        </Typography>
      )}

      {!loading &&
        integrations.map((item) => (
          <Box
            key={`${item.type}-${item.installedAppId || item.label}`}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            style={{
              background: "white",
              border: "1px solid #e0e0e0",
              borderRadius: 8,
              padding: "12px 16px",
              marginBottom: 10,
              width: "100%",
              boxSizing: "border-box",
              gap: 12,
            }}
          >
            <Box style={{ minWidth: 0 }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                {item.label}
              </Typography>
              <Typography variant="body2" style={{ color: "#666" }}>
                {item.status}
                {item.detail ? ` \u2014 ${item.detail}` : ""}
                {item.updatedAt
                  ? ` \u2014 updated ${new Date(
                      item.updatedAt
                    ).toLocaleString()}`
                  : ""}
              </Typography>
            </Box>
            <Button
              size="small"
              variant="outlined"
              style={{
                color: "#c62828",
                borderColor: "#c62828",
                flexShrink: 0,
              }}
              onClick={() => setPendingDisconnect(item)}
            >
              Disconnect
            </Button>
          </Box>
        ))}

      <Dialog
        open={Boolean(pendingDisconnect)}
        onClose={() => !disconnecting && setPendingDisconnect(null)}
      >
        <DialogTitle>Disconnect {pendingDisconnect?.label}?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This disconnects <strong>{pendingDisconnect?.label}</strong> for
            this project straight away. The customer will have to reconnect it
            themselves.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={disconnecting}
            onClick={() => setPendingDisconnect(null)}
          >
            Cancel
          </Button>
          <Button
            color="secondary"
            variant="contained"
            disabled={disconnecting}
            onClick={handleDisconnect}
          >
            {disconnecting ? "Disconnecting..." : "Disconnect"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

function AiMessagesPanel({ assistantDetails, onSnackbar }) {
  const initial = assistantDetails?.flowConfiguration?.aiMessages || {};
  const [isEnabled, setIsEnabled] = React.useState(!!initial.isEnabled);
  const [baseQuota, setBaseQuota] = React.useState(
    Number.isFinite(initial.baseQuota) ? initial.baseQuota : 0
  );
  const [packTier, setPackTier] = React.useState(initial.packTier || "");
  const [saving, setSaving] = React.useState(false);

  const handleSave = async () => {
    if (!AI_MESSAGE_PACK_TIERS.includes(packTier)) {
      onSnackbar?.("Please select a valid Pack Tier", "error");
      return;
    }
    const baseQuotaNum = Number(baseQuota);
    if (!Number.isInteger(baseQuotaNum) || baseQuotaNum < 0) {
      onSnackbar?.("Base Quota must be a non-negative integer", "error");
      return;
    }
    setSaving(true);
    try {
      await axios.post(URL + "/superadmin/update-ai-messages", {
        assistantId: assistantDetails._id,
        isEnabled,
        baseQuota: baseQuotaNum,
        packTier,
      });
      onSnackbar?.("AI Messages settings updated", "success");
    } catch (error) {
      const msg =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Something went wrong";
      onSnackbar?.(msg, "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box py={2} px={2} my={2} style={{ background: "white", borderRadius: 8 }}>
      <Typography
        variant="body1"
        gutterBottom
        style={{ fontWeight: "bold" }}
      >
        AI Messages
      </Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={3}>
          <Typography variant="h5" paragraph noWrap={false}>
            Enabled
          </Typography>
          <Switch
            checked={isEnabled}
            onChange={(e) => setIsEnabled(e.target.checked)}
            color="primary"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography variant="h5" paragraph noWrap={false}>
            Base Quota
          </Typography>
          <TextField
            type="number"
            inputProps={{ min: 0, step: 1 }}
            value={baseQuota}
            onChange={(e) => setBaseQuota(e.target.value)}
            style={{ width: "100%", background: "white" }}
          />
        </Grid>
        <Grid item xs={12} sm={2} style={{ textAlign: "right" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={saving}
            endIcon={
              saving ? <CircularProgress size={18} color="inherit" /> : null
            }
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

class Assistant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mmliteLockStatus: null,
      wooCommerceLogs: { WooComOrderEvents: [], WooComAbandonedEvents: [] },
      open: false,
      selectedIndex: 0,
      expandedWooCommerceLogIndex: null,
      selectedWooCommerceTab: 0,
      shopifyLogs: [],
      expandedLogIndex: null,
      creditLineInfo: "",
      resubscribeWebhookDialog: false,
      resubscribeWebhookLoading: false,
      removeCreditLineDialog: false,
      creditLineAllocation: null,
      creditLineAllocationLoading: false,
      creditLineAllocationError: null,
      removeCreditLineLoading: false,
      wabaInfo: null,
      wabaInfoLoading: true,
      fbmInfoLoading: true,
      FBMname: "",
      showCode: false,
      rejectionReasons: [],
      verificationStatus: "",
      bvbpApplicationResponse: [],
      status: "PENDING",
      bvbpDialog: false,
      alert: false,
      alertMsg: "",
      alertSeverity: "",
      remainingCredit: 0,
      activePlan: this.props.template,
      whatsappNumber: "",
      appName: "",
      templateCredit: 0,
      apiKey360: "",
      cachedAssistant: null,
      cachedPartner: null,
      projectStatus: "",
      mode: "SMS",
      pin: "",
      verifyCode: "",
      password: "",
      about: "",
      messageLimit: "",
      minAllowedBalance: 0,
      qualityRating: "",
      agentLimit: 0,
      attributeLimit: 0,
      tagLimit: 0,
      providerType: "",
      fbManager: "",
      ownerName: "",
      testNumber: 0,
      displayNameVerified: "",
      assistantApiLimit: 0,
      businessId:
        this.props.templates[this.props.templateIndex]?.fbBusinessId || "",
      bvbpCount: "",
      isChatScriptingRunning: false,
      directApiWebookUrl:
        this.props.templates[this.props.templateIndex].directApiWebookUrl || "",
      directApikey:
        this.props.templates[this.props.templateIndex].directApikey || "",
      messageEncryption: {
        // "number" = legacy Message Number Encryption (single field)
        // "body"   = Request Body & Query Encryption (whole-payload envelope)
        encryptionType: "number",
        algorithm: "aes-256-cbc",
        // Secret source, not the encryption mode: "random" | "custom"
        mode: "random",
        inputFormat: "hex",
        secret: "",
        iv: "",
        skewSeconds: 300,
        showAdvanced: false,
        // Served by /project-message-encryption/capabilities so the dropdown can
        // never offer a combination the backend rejects.
        capabilities: null,
        exists: false,
        docId: null,
        existingAlgorithm: null,
        existingEncryptionType: null,
        lastGenerated: null,
      },
      customWebhookConfig: {
        exists: false,
        url: "",
        url_input: "",
        clientId: "",
        apiKey: "",
        rotateMode: false,
      },
      flowConfiguration: this.props.templates[this.props.templateIndex]
        .flowConfiguration || {
        isEnabled: false,
        flowCount: 0,
        activeFlowCount: 0,
        isTrialClaimed: true,
        removedOn: null,
        addedOn: Date.now(),
        changesScheduledAt: null,
      },
      // verifiedStatus: null,
      webhooks: false,
      wabaTpt:
        this.props.templates[this.props.templateIndex].wabaTpt || "TIER_1",
      wabaStatusTpt:
        this.props.templates[this.props.templateIndex].wabaStatusTpt ||
        "TIER_1",
      migrationNumber: null,
      srcAssistantId: null,
      partnerId: null,
      defaultPlan: "BASIC_MONTHLY",
      activationDate: null,
      migrateTemplatesTo: null,
      migrateTemplatesFrom: null,
      whatsappPaySlabs: "{}",
      editWhatsappPaySlabs: false,
      directApiCredentials: {
        username: null,
        passoword: null,
        refreshToken: null,
        accessToken: null,
      },
      privateApps: [], // [ privateAppId: "", webhooks: [{ topicsArray: [], webhookUrl: "", webhookId: "" }], apiPassword:"" ]
      isLoading: true,
      isDialogOpen: false,
      regenerateConfirmOpen: false,
      currentIndex: null,
      isDrawerOpen: false,
      isEcomDrawerOpen: false,
      logs: [],
      wabaProgressStep: 0,
      scheduleCampaignLimit: 0,
      wabaAppId: "",
      wabaNumberId: "",
      billingProcessDialog: false,
      paymentRemarks: "",
      webhookLogs: [],
      webhookLogsPage: 0,
      webhookLogsHasMore: false,
      webhookLogsLoading: false,
      webhookLogsCache: {},
      webhookNamespace: "",
      webhookSubType: "",
      //  Optional "HH:mm:ss" bounds applied to the selected date range. Blank
      //  means the whole day, which is how this filter behaved before.
      webhookStartTime: "",
      webhookEndTime: "",
      webhookFilterValues: {},
      webhookLogsFetched: false,
      webhookFiltersOpen: false,
      limit: 10,
      chargeBeeDialog: false,
      // Autopay (Razorpay mandate) — Finance tab auto-collection toggle.
      mandateView: null,
      mandateViewLoaded: false,
      mandateToggling: false,
      chargeBeeLogs: [],
      assistantNameDialog: false,
      changeAssistantName: "",
      metaAdsCredit: 0,
      nameConfirmationDialog: false,
      currencyDialog: false,
      applied: {
        createdAt: {
          startDate: null,
          endDate: null,
          focusedInput: null,
        },
        webhookDelivery: {
          startDate: null,
          endDate: null,
          focusedInput: null,
        },
      },
      birthdayCampaignEnabled:
        this.props.templates[this.props.templateIndex].specialAccess
          ?.enableBirthdayCampaign || false,
      connectFlowsEnabled:
        this.props.templates[this.props.templateIndex].specialAccess
          ?.enableConnectFlows || false,
      tabValue: 0,
      showCachedAssCode: false,
      showCachedPartnerCode: false,
      openAssistantDialog: false,
      selectedTemplateCreditAction: "ADD",
      selectedMetaCreditAction: "ADD",
      selectedAICreditAction: "ADD",
      errorCurl: { event: "", curl: null },
      specialAccessKey: "",
      specialAccessValue: "",
      existingSpecialAccess: "",
      showSpecialAccess: false,
      selectedType: "",
      transferFlowId: "",
      ctwaFunnel: {},
      campaignErrorCurl: {},
      numberMaskingScope: "project",
      accountMaskingEnabled: false,
      numberMaskingInProgress: false,
      removeAdsSetupManagerDialog: false,
      isAdsMangerSetupPresent: false,
      fbConnectedAssistantId: null,
      adsSetupDeletionInProgress: false,
      campaigns: [],
      campaignStatusChangeDialog: false,
      migrateAllProjectsDialog: false,
      allCampaignStatus: "ACTIVE",
      setCampaignStatusLoader: false,
      fetchCampaignStatusLoader: false,
      selectedMediaContentSize:
        this.props.templates[this.props.templateIndex]?.mediaContentSize,
      mediaContentSize: "",
      paymentId: "",
      paymentDetails: null,
      paymentDetailsLoading: false,
      dashboardLockModalOpen: false,
      isDashboardLocked: false,
      dashboardLockConfig: null,

      // input values
      googleAdAccountId: "",
      googleClickConversionId: "",
      googleConversationInitiatedId: "",
      widgetId: "",

      // display values
      savedGoogleAdAccountId: '',
      savedGoogleClickConversionId: '',
      savedGoogleConversationInitiatedId: '',
      savedWidgetId: '',

      // flags for apis
      googleAdsConversionSaved: false,
      googleAdsConversionFetchFailed: false,
      widgetLinkSaved: false,
      widgetLinkFetchFailed: false,

      googleAdsConfigLoading: true,

      verificationReasonDialog: false,
      pendingVerificationChecked: null,
      verificationReason: "",
      // Assign User to WABA
      businessUsers: [],
      businessUsersLoading: false,
      businessUsersError: null,
      selectedBusinessUser: null,
      assignWabaDialog: false,
      assignWabaLoading: false,

    };
    this.anchorRef = createRef(null);
  }

  toggleAssistantDialog = () => {
    this.setState({ openAssistantDialog: !this.state.openAssistantDialog });
  };

  openDashboardLockModal = () => {
    this.setState({ dashboardLockModalOpen: true });
  };

  closeDashboardLockModal = () => {
    this.setState({ dashboardLockModalOpen: false });
  };

  handleUnlockDashboard = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant?._id;

    if (!assistantId) {
      console.log("No assistantId found for unlock dashboard");
      return;
    }

    axios
      .post(
        `${URL}/superadmin/dashboard-lock/unlock`,
        { assistantId },
        {
          headers: {
            "Content-Type": "application/json",
            "x-request-source": "superadmin",
          },
        }
      )
      .then((response) => {
        console.log("Dashboard unlock response:", response.data);
        this.setState({
          isDashboardLocked: false,
          dashboardLockConfig: null,
          alert: true,
          alertMsg: "Dashboard unlocked successfully",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log("Error unlocking dashboard:", error);
        const message =
          error.response?.data?.message ||
          error.message ||
          "Failed to unlock dashboard";
        this.setState({
          alert: true,
          alertMsg: message,
          alertSeverity: "error",
        });
      });
  };

  handleDashboardLockSuccess = (config) => {
    const lock = config.dashboardLock || config; // fallback if backend ever returns bare object
    const isDashboardLocked = !!(lock && lock.active);

    this.setState({
      isDashboardLocked,
      dashboardLockConfig: lock || null,
      alert: true,
      alertMsg: "Dashboard locked successfully",
      alertSeverity: "success",
    });
  };

  handleDashboardLockError = (message) => {
    this.setState({
      alert: true,
      alertMsg: message || "Failed to save dashboard lock configuration",
      alertSeverity: "error",
    });
  };

  fetchDashboardLockStatus = (assistantId) => {
    axios
      .get(`${URL}/superadmin/dashboard-lock/${assistantId}`, {
        headers: {
          "Content-Type": "application/json",
          "x-request-source": "superadmin",
        },
      })
      .then((response) => {
        const { dashboardLock } = response.data || {};
        const isDashboardLocked = !!(dashboardLock && dashboardLock.active);

        this.setState({
          isDashboardLocked,
          dashboardLockConfig: dashboardLock || null,
        });
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          this.setState({
            isDashboardLocked: false,
            dashboardLockConfig: null,
          });
        } else {
          console.log(error);
        }
      });
  };

  openChargebeeDialog = () => {
    this.setState({ chargeBeeDialog: true });
  };
  toggleBvbpDialog = () => {
    this.setState({ bvbpDialog: !this.state.bvbpDialog });
  };

  closeChargebeeDialog = () => {
    this.setState({ chargeBeeDialog: false });
  };

  // Autopay (Razorpay mandate) — reads the customer's mandate + auto-collection
  // state from billing-services (found:false = never went through mandate flow).
  fetchMandateView = async () => {
    const assistant = this.props.templates[this.props.templateIndex];
    if (!assistant?._id) return;
    try {
      const { data } = await axios.post(URL + "/superadmin/mandate-view", {
        assistantId: assistant._id,
      });
      this.setState({ mandateView: data, mandateViewLoaded: true });
    } catch (error) {
      this.setState({ mandateView: { found: false }, mandateViewLoaded: true });
    }
  };

  toggleMandateAutoCharge = async (event) => {
    const enabled = event.target.checked;
    const assistant = this.props.templates[this.props.templateIndex];
    this.setState({ mandateToggling: true });
    try {
      await axios.post(URL + "/superadmin/mandate-auto-charge", {
        assistantId: assistant._id,
        enabled,
      });
      this.setState((prev) => ({
        mandateToggling: false,
        mandateView: { ...prev.mandateView, auto_debit_enabled: enabled },
        alert: true,
        alertMsg: `Auto collection turned ${enabled ? "ON" : "OFF"}`,
        alertSeverity: "success",
      }));
    } catch (error) {
      this.setState({
        mandateToggling: false,
        alert: true,
        alertMsg:
          error?.response?.data?.message || "Failed to update auto collection",
        alertSeverity: "error",
      });
    }
  };

  openCurrencyDialog = () => {
    this.setState({ currencyDialog: true });
  };

  closeCurrencyDialog = () => {
    this.setState({ currencyDialog: false });
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: parseInt(e.target.value) });
  };

  handleFlowConfigurationInput = (e) => {
    this.setState({
      flowConfiguration: {
        ...this.state.flowConfiguration,
        [e.target.name]: parseInt(e.target.value),
      },
    });
  };

  handleObjectKeyInput = (parentKey, e) => {
    this.setState({
      [parentKey]: {
        ...this.state[parentKey],
        [e.target.name]: e.target.value,
      },
    });
  };

  updateMediaContentSize = () => {
    let template = this.props.templates[this.props.templateIndex];
    const mediaContentSize = this.state.selectedMediaContentSize;
    template.mediaContentSize = mediaContentSize;

    this.setTemplateInDb({
      mediaContentSize: mediaContentSize,
    })
      .then((response) => {
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Media content size updated!",
          alertSeverity: "success",
          mediaContentSize: mediaContentSize,
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update media content size",
          alertSeverity: "error",
        });
      });
  };

  handlePaymentIdChange = (e) => {
    this.setState({ paymentId: e.target.value });
  };

  verifyPayment = () => {
    this.setState({ paymentDetailsLoading: true, paymentDetails: null });
    axios
      .get(
        URL +
        `/superadmin/finance/payment-details?paymentId=${this.state.paymentId}`
      )
      .then((response) => {
        this.setState({
          paymentDetails: response.data?.data,
          paymentDetailsLoading: false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          alert: true,
          alertMsg: "Failed to fetch payment details",
          alertSeverity: "error",
          paymentDetailsLoading: false,
        });
      });
  };

  openAssistantNameDialog = () => {
    this.setState({ assistantNameDialog: true });
  };

  closeAssistantNameDialog = () => {
    this.setState({ assistantNameDialog: false });
  };

  updateAssistantName = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const changeProjectName = this.state.changeAssistantName;
    axios
      .post(URL + "/superadmin/updateAssistantName", {
        changeProjectName,
        assistantId,
      })
      .then((response) => {
        assistant.assistantName = changeProjectName;
        this.props.setTemplate(assistant);
        this.setState({
          alert: true,
          alertMsg: "Project Name updated!",
          alertSeverity: "success",
          changeAssistantName: "",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: error?.response?.data || "Unable to update project name",
          alertSeverity: "error",
          changeAssistantName: "",
        });
      });
  };

  updateProjectCurrency = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant?._id;
    let templateCredit = assistant?.templateCredit;
    const currency = assistant?.currency === "USD" ? "INR" : "USD";
    currency === "USD"
      ? (templateCredit = templateCredit / 80)
      : (templateCredit = templateCredit * 80);

    axios
      .post(URL + "/superadmin/updateCurrency", {
        currency,
        assistantId,
      })
      .then((response) => {
        assistant.currency = currency;
        assistant.templateCredit = templateCredit;
        this.props.setTemplate(assistant);
        this.setState({
          alert: true,
          alertMsg: "Currency updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update project currency",
          alertSeverity: "error",
        });
      });
  };

  handleNumberInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSpecialAcessKey = (e) => {
    this.setState({ specialAccessKey: e.target.value });
  };

  handleSpecialAcessValue = (e) => {
    this.setState({ specialAccessValue: e.target.value });
  };

  addSpecialAccess = (e) => {
    let { specialAccessKey, specialAccessValue, selectedType } = this.state;
    const assistant = this.props.templates[this.props.templateIndex];
    if (selectedType === "Object") {
      specialAccessValue = JSON.parse(specialAccessValue);
    } else if (selectedType === "Boolean") {
      if (specialAccessValue === "true") {
        specialAccessValue = true;
      } else {
        specialAccessValue = false;
      }
    }
    let fields = {
      specialAccess: {
        ...(assistant?.specialAccess || null),
        [specialAccessKey]: specialAccessValue,
      },
    };
    const queryObj = {
      assistantId: assistant._id,
      fields,
      dailyTemplateLimit: assistant.dailyTemplateLimit,
    };
    axios
      .post(URL + "/superadmin/set-assistant-field", queryObj)
      .then((res) => {
        this.setState({
          alert: true,
          alertMsg: "special key added successfully!",
          alertSeverity: "success",
          specialAccessKey: "",
          specialAccessValue: "",
          selectedType: "",
        });

        // If coex is enabled, set the throughput to 20
        if (specialAccessKey === "coexistence") {
          axios
            .post(`${URL}/superadmin/update-waba-throughput`, {
              phoneId: assistant.wabaNumberId,
              throughput: specialAccessValue ? 20 : 40,
              type: "outgoing",
            })
            .catch((error) => {
              console.error("TPS Set error", error);
            });
        }
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: error || "something went wrong!",
          alertSeverity: "error",
        });
      });
  };

  updateTemplateCredit = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    // const amount = template.remainingCredit + this.state.remainingCredit*100
    // console.log({status: e.target.checked});
    let amount = this.state.templateCredit * 100000;
    if (this.state.selectedTemplateCreditAction !== "ADD") {
      amount = -1 * amount;
    }
    const totalTemplateCredit = template.templateCredit
      ? template.templateCredit + amount
      : amount;
    // Balance changes are irreversible from here - make the operator confirm
    // exactly what is about to happen (a remarks-only 0 amount is allowed and
    // changes nothing).
    const currency = template.currency || "";
    const summary =
      amount === 0
        ? `No balance change - only the remarks will be saved.`
        : `${amount > 0 ? "ADD" : "SUBTRACT"} ${currency} ${Math.abs(amount) / 100000}\n\nCurrent balance: ${currency} ${(template.templateCredit || 0) / 100000}\nNew balance: ${currency} ${totalTemplateCredit / 100000}`;
    if (
      !window.confirm(
        `Update template credit for "${template.assistantName}"?\n\n${summary}\n\nRemarks: ${this.state.paymentRemarks || "-"}`
      )
    ) {
      return false;
    }
    this.setTemplateInDb({
      templateCredit: amount,
      paymentRemarks: this.state.paymentRemarks,
    })
      .then((response) => {
        template.templateCredit = totalTemplateCredit;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Template credit updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to add template credit",
          alertSeverity: "error",
        });
      });
    return true;
  };

  updateMetaCredit = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    let amount = this.state.metaAdsCredit * 100000;
    if (this.state.selectedMetaCreditAction !== "ADD") {
      amount = -1 * amount;
    }
    const totalMetaCredit = template.metaAdsCredit
      ? template.metaAdsCredit + amount
      : amount;
    this.setTemplateInDb({
      metaAdsCredit: amount,
      metaCreditRemarks: this.state.metaCreditRemarks,
    })
      .then((response) => {
        template.metaAdsCredit = totalMetaCredit;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Meta credit updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to add Meta credit",
          alertSeverity: "error",
        });
      });
  };

  updateAICredit = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    let amount = this.state.aiCredit * 100000;
    if (this.state.selectedAICreditAction !== "ADD") {
      amount = -1 * amount;
    }
    const totalAICredit = template.aiCredit
      ? template.aiCredit + amount
      : amount;
    this.setTemplateInDb({
      aiCredit: amount,
      aiCreditRemarks: this.state.aiCreditRemarks,
    })
      .then((response) => {
        template.aiCredit = totalAICredit;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "AI credit updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to add AI credit",
          alertSeverity: "error",
        });
      });
  };

  openConfirmNameDialog = () => {
    this.setState({ nameConfirmationDialog: true });
  };

  closeConfirmNameDialog = () => {
    this.setState({ nameConfirmationDialog: false });
  };

  updateMinAllowedBalance = (e) => {
    const template = this.props.templates[this.props.templateIndex];
    const amount = this.state.minAllowedBalance * 100000;
    this.setTemplateInDb({
      minAllowedBalance: amount,
    })
      .then((response) => {
        template.minAllowedBalance = amount;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Min Balance Allowance updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update min balance allowance",
          alertSeverity: "error",
        });
      });
  };
  updateApiKey = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    // const amount = template.remainingCredit + this.state.remainingCredit*100
    const apiKey360 = this.state.apiKey360;

    this.setTemplateInDb({
      apiKey360: apiKey360,
    })
      .then((response) => {
        template.apiKey360 = apiKey360;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "API Key updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to add API Key",
          alertSeverity: "error",
        });
      });
  };
  updateVerificationStatus = (e) => {
    const checked = e.target.checked;
    this.setState({
      verificationReasonDialog: true,
      pendingVerificationChecked: checked,
      verificationReason: "",
    });
  };

  confirmVerificationStatusUpdate = () => {
    const { pendingVerificationChecked, verificationReason } = this.state;
    let template = this.props.templates[this.props.templateIndex];

    this.setTemplateInDb(
      { isWhatsappVerified: pendingVerificationChecked },
      { reason: verificationReason }
    )

      .then((response) => {
        template.isWhatsappVerified = pendingVerificationChecked;
        this.props.setTemplate(template);
        this.setState({
          verificationReasonDialog: false,
          pendingVerificationChecked: null,
          verificationReason: "",
          alert: true,
          alertMsg: "Assistant verified status updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          verificationReasonDialog: false,
          alert: true,
          alertMsg: "Unable to update verified status",
          alertSeverity: "error",
        });
      });
  };

  getMessagingLimit = () => {
    const result = Tier_Limit.filter((e) => e.name === this.state.messageLimit);
    return result[0].value;
  };

  registerWithPin = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { pin } = this.state;
    axios
      .post(URL + "/superadmin/register-with-pin", { assistantId, pin })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        const message =
          error?.response?.data?.message ||
          error.messsage ||
          "Something went wrong. Could not register";

        this.setState({
          alert: true,
          alertMsg: message,
          alertSeverity: "error",
          errorCurl: { event: "register", curl: error?.response?.data?.curl },
        });
      });
  };

  verifyCode = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { verifyCode } = this.state;
    axios
      .post(URL + "/superadmin/verify-code", { assistantId, verifyCode })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Could not verify",
          alertSeverity: "error",
        });
      });
  };

  triggerOtp = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { mode } = this.state;
    const payload = { assistantId, mode };
    axios
      .post(URL + "/superadmin/trigger-otp", payload)
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "OTP Sent",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "failed",
          alertSeverity: "error",
        });
      });
  };

  resetPassword = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { password } = this.state;
    axios
      .post(URL + "/superadmin/reset-password", { password, assistantId })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "failed",
          alertSeverity: "error",
        });
      });
  };

  resetAbout = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { about } = this.state;
    if (about.length > 139) {
      return this.setState({
        alert: true,
        alertMsg: "about length should be smaller than 135 characters",
        alertSeverity: "error",
      });
    }
    axios
      .post(URL + "/superadmin/update-about", { about, assistantId })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Failed",
          alertSeverity: "error",
        });
      });
  };

  updateMessagingLimit = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    let result;
    if (this.state.messageLimit) {
      result = this.getMessagingLimit();
    }
    axios
      .post(URL + "/superadmin/update-messaging-limit", { assistantId, result })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Failed",
          alertSeverity: "error",
        });
      });
  };

  fetchBusinessUsers = async (refresh = false) => {
    this.setState({ businessUsersLoading: true, businessUsersError: null });
    try {
      const response = await axios.get(
        `${URL}/superadmin/get-business-users`,
        {
          params: refresh ? { refresh: "true" } : {},
          headers: { "Content-Type": "application/json" },
        }
      );
      this.setState({ businessUsers: response.data.users || [] });
    } catch (error) {
      console.error("Error fetching business users:", error);
      this.setState({
        businessUsersError: "Failed to fetch business users",
        alert: true,
        alertMsg: "Failed to fetch business users",
        alertSeverity: "error",
      });
    } finally {
      this.setState({ businessUsersLoading: false });
    }
  };

  handleAssignWaba = async () => {
    const { selectedBusinessUser } = this.state;
    const template = this.props.templates[this.props.templateIndex];
    const wabaId = template?.wabaAppId;
    if (!wabaId || !selectedBusinessUser) return;

    this.setState({ assignWabaLoading: true });
    try {
      await axios.post(
        `${URL}/superadmin/assign-user-to-waba`,
        { wabaId, userId: selectedBusinessUser.id },
        { headers: { "Content-Type": "application/json" } }
      );
      this.setState({
        assignWabaDialog: false,
        selectedBusinessUser: null,
        alert: true,
        alertMsg: `Successfully assigned ${selectedBusinessUser.name} to WABA`,
        alertSeverity: "success",
      });
    } catch (error) {
      const msg =
        error.response?.data?.error || "Failed to assign user to WABA";
      this.setState({
        alert: true,
        alertMsg: msg,
        alertSeverity: "error",
      });
    } finally {
      this.setState({ assignWabaLoading: false });
    }
  };

  syncMessagingLimit = () => {
    const { templates, templateIndex, setTemplate } = this.props;
    const template = templates[templateIndex];
    const payload = {
      wabaNumberId: template.wabaNumberId,
    };
    axios
      .get(URL + "/superadmin/sync-messaging-limit", { params: payload })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Failed",
          alertSeverity: "error",
        });
      });
  };

  updateAgentLimit = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { agentLimit } = this.state;
    axios
      .post(URL + "/superadmin/update-agent-limit", { assistantId, agentLimit })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Failed",
          alertSeverity: "error",
        });
      });
  };
  updateAttributeLimit = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { attributeLimit } = this.state;
    axios
      .post(URL + "/superadmin/update-attribute-limit", {
        assistantId,
        attributeLimit,
      })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Failed",
          alertSeverity: "error",
        });
      });
  };

  updateTagLimit = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { tagLimit } = this.state;
    axios
      .post(URL + "/superadmin/update-tag-limit", { assistantId, tagLimit })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Failed",
          alertSeverity: "error",
        });
      });
  };

  updateQualtiyRating = (param) => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;

    let { qualityRating } = this.state;
    if (param == "sync") {
      const tempRating = this.state.wabaInfo?.find(
        (item) =>
          item.id ==
          this.props.templates[this.props.templateIndex]?.wabaNumberId
      )?.qualityRating;
      qualityRating = tempRating
        ? `${["Low", "FLAGGED", "RED"].includes(tempRating)
          ? "Low"
          : ["UNFLAGGED", "Medium", "RESTRICTED", "YELLOW"].includes(
            tempRating
          )
            ? "Medium"
            : "High"
        }`
        : "";
    }

    axios
      .post(URL + "/superadmin/update-quality-rating", {
        assistantId,
        qualityRating,
      })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Failed",
          alertSeverity: "error",
        });
      });
  };

  updatefbManager = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { fbManager } = this.state;
    axios
      .post(URL + "/superadmin/fbManager-status", {
        assistantId,
        fbManager,
      })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Failed",
          alertSeverity: "error",
        });
      });
  };

  testAPINumber = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { testNumber } = this.state;
    axios
      .post(URL + "/superadmin/test-api-verification", {
        assistantId,
        testNumber,
      })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Successfully verified",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "verification failed",
          alertSeverity: "error",
        });
      });
  };

  updateProviderType = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { providerType } = this.state;
    axios
      .post(URL + "/superadmin/update-provider-type", {
        assistantId,
        providerType,
      })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Failed",
          alertSeverity: "error",
        });
      });
  };

  syncChannelStatus = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    axios
      .post(URL + "/superadmin/sync-channel-status", {
        assistantId,
      })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Failed",
          alertSeverity: "error",
        });
      });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  updateWhatsAppNumber = () => {
    let template = this.props.templates[this.props.templateIndex];
    // const amount = template.remainingCredit + this.state.remainingCredit*100
    // console.log({status: e.target.checked});
    const whatsappNumber = this.state.whatsappNumber;
    template.whatsappNumber = whatsappNumber;

    this.setTemplateInDb({
      whatsappNumber,
    })
      .then((response) => {
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Whatsapp number updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update whatsapp number",
          alertSeverity: "error",
        });
      });
  };
  updateAppName = () => {
    let template = this.props.templates[this.props.templateIndex];
    // const amount = template.remainingCredit + this.state.remainingCredit*100
    // console.log({status: e.target.checked});
    const appName = this.state.appName;
    template.appName = appName;

    this.setTemplateInDb({
      appName,
    })
      .then((response) => {
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Whatsapp app name updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update whatsapp app name",
          alertSeverity: "error",
        });
      });
  };
  updateProjectStatus = () => {
    let template = this.props.templates[this.props.templateIndex];
    // const amount = template.remainingCredit + this.state.remainingCredit*100
    // console.log({status: e.target.checked});
    const projectStatus = this.state.projectStatus;
    template.status = projectStatus;

    this.setTemplateInDb({
      status: projectStatus,
    })
      .then((response) => {
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Project status updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update project status",
          alertSeverity: "error",
        });
      });
  };
  updateCredit = () => {
    let template = { ...this.props.templates[this.props.templateIndex] };
    const amount =
      template.remainingCredit + this.state.remainingCredit * 100000;
    const activePlan = this.state.activePlan || template.activePlan;
    // console.log(template.remainingCredit, this.state.remainingCredit)
    // if (this.state.activePlan) {
    const oldPlan = template.activePlan;
    console.log({ oldPlan });
    // Set plan name
    template.activePlan = activePlan;
    console.log({ oldPlan });

    // Check plan type
    if (
      [
        "BASIC_TRIAL",
        "BASIC_MONTHLY",
        "BASIC_DIWALI_MONTHLY",
        "PRO_MONTHLY",
        "ENTERPRISE_MONTHLY",
        "BASIC_YEARLY",
        "BASIC_DIWALI_YEARLY",
        "PRO_YEARLY",
        "ENTERPRISE_YEARLY",
      ].includes(activePlan)
    ) {
    } else if (activePlan.includes("BASIC_")) {
      if (!oldPlan.includes("BASIC_")) {
        template.planActivatedOn = null;
      }
      // Check if its renewal or first time
      if (template.planActivatedOn) {
        console.log(typeof template.planActivatedOn);
        console.log(template.planActivatedOn);

        template.planActivatedOn = new Date(template.planActivatedOn);
        console.log(template.planActivatedOn);
        // console.log(template.planActivatedOn);

        // template.planActivatedOn.setMonth(
        //   template.planActivatedOn.getMonth() + 8
        // );
        // console.log(template.planActivatedOn);
        // Get the current date
        const currentDate = template.planActivatedOn.getDate();
        // Set to day 1 to avoid forward
        template.planActivatedOn.setDate(1);
        // Increase month by 1
        template.planActivatedOn.setMonth(
          template.planActivatedOn.getMonth() + 1
        );
        // Get max # of days in this new month
        var daysInMonth = new Date(
          template.planActivatedOn.getYear(),
          template.planActivatedOn.getMonth() + 1,
          0
        ).getDate();
        // Set the date to the minimum of current date of days in month
        template.planActivatedOn.setDate(Math.min(currentDate, daysInMonth));
        console.log(template.planActivatedOn);
      } else {
        template.planActivatedOn = new Date();
      }
    } else {
      // v1 pricing
      template.planActivatedOn = new Date();
    }
    // }

    template.remainingCredit = amount;

    this.setTemplateInDb({
      remainingCredit: amount,
      activePlan: template.activePlan,
      planActivatedOn: template.planActivatedOn,
    })
      .then((response) => {
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Assistant status updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update template status",
          alertSeverity: "error",
        });
      });
  };
  handleAutoComplete = (fieldName, value, reason) => {
    if (reason === "select-option") {
      this.setState({ [fieldName]: value });
    }
  };
  handleMark = (mark, temp) => {
    const template = { ...temp };
    if (mark) {
      // set process to new Date()
      this.setTemplateInDb({ processed: new Date() })
        .then((response) => {
          template.processed = new Date();
          this.props.setTemplate(template);
          this.setState({
            alert: true,
            alertMsg: "Template marked processed!",
            alertSeverity: "success",
          });
        })
        .catch((error) => {
          this.setState({
            alert: true,
            alertMsg: "Unable to mark, Check your internet connection.",
            alertSeverity: "error",
          });
        });
    } else {
      this.setTemplateInDb({ processed: null })
        .then((response) => {
          template.processed = null;
          this.props.setTemplate(template);
          this.setState({
            alert: true,
            alertMsg: "Template marked un-processed!",
            alertSeverity: "success",
          });
        })
        .catch((error) => {
          this.setState({
            alert: true,
            alertMsg:
              "Unable to fulfill request, Check your internet connection.",
            alertSeverity: "error",
          });
        });
    }
  };
  setTemplateInDb = (fields, extra = {}) => {
    // try {
    const t = this.props.templates[this.props.templateIndex];
    const queryObj = {
      assistantId: t._id,
      fields,
      dailyTemplateLimit: t.dailyTemplateLimit,
      ...(t.partnerId && { partnerId: t.partnerId }),
      ...(t.wabaTpt && { currentTps: t.wabaTpt }),
      ...extra,
    };
    return axios.post(URL + "/superadmin/set-assistant-field", { ...queryObj });
  };
  closeSnackbar = () => {
    this.setState({ alert: false, alertMsg: "", alertSeverity: "" });
  };
  getAssistantDetailsFromCache = async () => {
    try {
      const { templateIndex, templates } = this.props;
      const assistant = templates[templateIndex];
      if (!assistant) {
        return;
      }
      const redisKey = "assistants/" + assistant._id;
      console.log({ redisKey });
      const { data: cachedAssistant } = await axios.post(
        URL + "/superadmin/get-credits-from-cache",
        {
          assistantId: assistant._id,
        }
      );
      console.log(cachedAssistant);
      this.setState({ cachedAssistant });
    } catch (err) {
      console.log(err);
    }
  };

  getPartnerFromCache = async () => {
    const partnerId = this.props.templates[this.props.templateIndex].partnerId;
    try {
      const cachedPartner = await axios.post(
        `${CLIENT_URL}/superadmin/update-partner-in-cache`,
        {
          partnerId,
        }
      );
      this.setState({ cachedPartner: cachedPartner });
    } catch (error) {
      console.error(error);
    }
  };

  syncTemplateMsg = async () => {
    try {
      const { templateIndex, templates } = this.props;
      const assistant = templates[templateIndex];
      if (!assistant) {
        return;
      }
      const { data: cachedAssistant } = await axios.post(
        URL + "/superadmin/sync-template-messages",
        {
          assistantId: assistant._id,
        }
      );
      console.log(cachedAssistant);
      this.setState({
        alert: true,
        alertMsg: "Template msg synched",
        alertSeverity: "success",
      });
    } catch (err) {
      console.log(err);
      this.setState({
        alert: true,
        alertMsg: "Unable update template msg",
        alertSeverity: "error",
      });
    }
  };

  migrateTemplateMsg = async () => {
    try {
      const { templateIndex, templates } = this.props;
      const assistant = templates[templateIndex];
      if (!assistant) {
        return;
      }
      const { data: cachedAssistant } = await axios.post(
        URL + "/superadmin/migrate-all-templates",
        {
          assistantId: assistant._id,
        }
      );
      console.log(cachedAssistant);
      this.setState({
        alert: true,
        alertMsg: "Template msg migrated",
        alertSeverity: "success",
      });
    } catch (err) {
      console.log(err);
      this.setState({
        alert: true,
        alertMsg: "Unable migrate template msg",
        alertSeverity: "error",
      });
    }
  };

  enableCampaignAnalytics = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      campaignAnalyticsEnabled: checked,
    })
      .then((response) => {
        template.campaignAnalyticsEnabled = checked;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "campaign analytics status updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update campaign analytics status",
          alertSeverity: "error",
        });
      });
  };
  updateMigrateStatus = (e) => {
    let template = this.props.templates[this.props.templateIndex];

    this.setTemplateInDb({
      providerType: "v3",
      wabaNumberId: "",
      wabaProgressStep: 0,
    })
      .then((response) => {
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: " Migration status updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update migration status",
          alertSeverity: "error",
        });
      });
  };
  enableClickTracking = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      clickTrackingEnabled: checked,
    })
      .then((response) => {
        template.clickTrackingEnabled = checked;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Click tracking status updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update click tracking status",
          alertSeverity: "error",
        });
      });
  };

  enableCampaignScheduling = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      campaignSchedulingEnabled: checked,
    })
      .then((response) => {
        template.campaignSchedulingEnabled = checked;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "campaign scheduling status updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update campaign scheduling status",
          alertSeverity: "error",
        });
      });
  };

  enableMetaAdvanceTargeting = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      metaAdvanceTargetingEnabled: checked,
    })
      .then((response) => {
        template.metaAdvanceTargetingEnabled = checked;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Meta Ads status updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update Meta Ads status",
          alertSeverity: "error",
        });
      });
  };

  updateWhatsappPayDetails = async (key, value) => {
    let template = this.props.templates[this.props.templateIndex];
    let { orderCheckoutDetails, _id, clientId } = template || {};

    if (isEmpty(orderCheckoutDetails)) {
      orderCheckoutDetails = {};
    }

    if (key.includes(".")) {
      const [first, sec] = key.split(".");
      if (isEmpty(orderCheckoutDetails[first])) {
        orderCheckoutDetails[first] = {};
      }
      orderCheckoutDetails[first][sec] = value;
    } else {
      orderCheckoutDetails[key] = value;
    }

    if (orderCheckoutDetails?.paymentTemplateEnabled === "APPROVED") {
      const {
        data: { token },
      } = await axios.post(
        `${URL}/superadmin/generate-any-token`,
        {
          _id: clientId,
          type: "agent",
        },
        {
          headers: {
            "x-aisensy-admin-token-key": ADMIN_KEY,
          },
        }
      );
      await axios
        .post(
          URL + "/api/get-matching-templates-with-status",
          {
            assistantId: _id,
            tag: "razorpaypaymentlink",
          },
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then(async (response) => {
          const templates = response.data || [];
          if (!isEmpty(templates)) {
            const template = templates[0];
            await axios
              .post(
                `${URL}/api/create-template`,
                {
                  assistantId: _id,
                  ...template,
                },
                {
                  headers: {
                    Authorization: token,
                  },
                }
              )
              .then(async (value) => {
                const campaign = {
                  status: "",
                  type: "API",
                  name: "Razorpay Payment Link",
                  payload: { templateName: template.name },
                };
                const url = `${CAMPAIGN_URL}/campaign/create-api-campaign`;
                const body = {
                  campaign,
                  assistantId: _id,
                  createdBy: "system_rzp",
                  skipTemplateApproval: true,
                };
                await axios
                  .post(url, body, {
                    headers: {
                      Authorization: token,
                    },
                  })
                  .then(async (value) => {
                    const url = `${INTEGRATION_SERVER_URL}/razorpay/t1/integration/event-mapping/add`;
                    const body = {
                      assistantId: _id,
                      name: "Payment link",
                      eventName: "payment_link.created",
                      templateParams: template.templateParams,
                      campaignName: "Razorpay Payment Link",
                      media: null,
                      fallbackParameters: {},
                    };
                    await axios
                      .post(url, body, {
                        headers: {
                          Authorization: token,
                        },
                      })
                      .catch((error) => {
                        console.log({ error });
                      });
                  })
                  .catch((error) => {
                    console.log({ error });
                  });
              })
              .catch((eror) => {
                this.setState({
                  alert: true,
                  alertMsg: "Unable to update Whatsapp Pay",
                  alertSeverity: "error",
                });
              });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({ err: JSON.stringify(err), isLoading: false });
        });
    }

    this.setTemplateInDb({
      orderCheckoutDetails,
    })
      .then((response) => {
        template.orderCheckoutDetails = orderCheckoutDetails;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Whatsapp Pay Updated",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update Whatsapp Pay",
          alertSeverity: "error",
        });
      });
  };

  updateAssistantRateLimit = () => {
    let template = this.props.templates[this.props.templateIndex];
    const { assistantApiLimit } = this.state;

    this.setTemplateInDb({
      apiLimit: assistantApiLimit,
    })
      .then((response) => {
        template.apiLimit = assistantApiLimit;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Rate Limit updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update Rate Limit",
          alertSeverity: "error",
        });
      });
  };

  enableEcom = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      isEcom: checked,
    })
      .then((response) => {
        template.isEcom = checked;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Ecom status updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update Ecom status",
          alertSeverity: "error",
        });
      });
  };

  enableFlowOrderFlow = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      isOrderFlowEnabled: checked,
    })
      .then((response) => {
        template.isOrderFlowEnabled = checked;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Order Flow Enabled status updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update Order Flow status",
          alertSeverity: "error",
        });
      });
  };
  updateDisplayName = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { displayNameVerified } = this.state;
    axios
      .post(URL + "/superadmin/displayname-status", {
        assistantId,
        displayNameVerified,
      })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: "Success",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Failed",
          alertSeverity: "error",
        });
      });
  };
  enableFilterFreeze = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      filterFreezeEnabled: checked,
    })
      .then((response) => {
        template.filterFreezeEnabled = checked;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "filter freeze status updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update filter freeze status",
          alertSeverity: "error",
        });
      });
  };

  enableChatSearchable = async (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;
    this.setState({ isChatScriptingRunning: true });
    await axios.post(URL + "/superadmin/chat-search-scripting", {
      assistantId: template._id,
      isSearchable: checked,
    });
    this.setTemplateInDb({
      chatSearchEnabled: checked,
    })
      .then((response) => {
        template.chatSearchEnabled = checked;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Chat Searchable status updated!",
          alertSeverity: "success",
          isChatScriptingRunning: false,
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update chat searchable status",
          alertSeverity: "error",
          isChatScriptingRunning: false,
        });
      });
  };

  enableCSVScheduleEnabled = async (event) => {
    try {
      const { templates, templateIndex, setTemplate } = this.props;
      const template = templates[templateIndex];
      const { checked } = event.target;
      await this.setTemplateInDb({ csvScheduleEnabled: checked });
      template.csvScheduleEnabled = checked;
      setTemplate(template);
      this.setState({
        alert: true,
        alertSeverity: "success",
        alertMsg: "Updated CSV Campaign Schedule",
      });
    } catch (error) {
      console.log({ error });
      this.setState({
        alert: true,
        alertSeverity: "error",
        isChatScriptingRunning: false,
        alertMsg: "failed to update CSV Campaign Schedule",
      });
    }
  };

  optReporting = async (event) => {
    try {
      const { templates, templateIndex, setTemplate } = this.props;
      const template = templates[templateIndex];
      const { checked } = event.target;
      await this.setTemplateInDb({ optReportingEnabled: checked });
      template.optReportingEnabled = checked;
      setTemplate(template);
      this.setState({
        alert: true,
        alertSeverity: "success",
        alertMsg: "Updated opt-in/out reporting status",
      });
    } catch (error) {
      console.log({ error });
      this.setState({
        alert: true,
        alertSeverity: "error",
        isChatScriptingRunning: false,
        alertMsg: "Failed to update opt-in/out reporting status",
      });
    }
  };

  skipBalanceCheck = async (event) => {
    try {
      const { templates, templateIndex, setTemplate } = this.props;
      const template = templates[templateIndex];
      const { checked } = event.target;
      await this.setTemplateInDb({ skipBalanceCheck: checked });
      template.skipBalanceCheck = checked;
      setTemplate(template);
      this.setState({
        alert: true,
        alertSeverity: "success",
        alertMsg: "Updated Balance Check!",
      });
    } catch (error) {
      console.log({ error });
      this.setState({
        alert: true,
        alertSeverity: "error",
        isChatScriptingRunning: false,
        alertMsg: "Failed to update Balance Check",
      });
    }
  };

  campaignScheduleReport = (event) => {
    const { templates, templateIndex, setTemplate } = this.props;
    const template = templates[templateIndex];
    const checked = event.target.checked;
    const updatedSpecialAccess = { ...template.specialAccess, campaignScheduleReport: checked };
    this.setTemplateInDb({ specialAccess: updatedSpecialAccess })
      .then(() => {
        setTemplate({ ...template, specialAccess: updatedSpecialAccess });
        this.setState({ alert: true, alertSeverity: "success", alertMsg: "Updated Campaign Schedule Report" });
      })
      .catch((error) => {
        this.setState({ alert: true, alertSeverity: "error", alertMsg: "Failed to update Campaign Schedule Report" });
      });
  };

  // INT-117: opt-in / opt-out sync to integrations (MoEngage). AiSensy
  // projects only; the backend ignores the flag on partner projects.
  integrationOptSync = (event) => {
    const { templates, templateIndex, setTemplate } = this.props;
    const template = templates[templateIndex];
    const checked = event.target.checked;
    const updatedSpecialAccess = { ...template.specialAccess, integrationOptSync: checked };
    this.setTemplateInDb({ specialAccess: updatedSpecialAccess })
      .then(() => {
        setTemplate({ ...template, specialAccess: updatedSpecialAccess });
        this.setState({ alert: true, alertSeverity: "success", alertMsg: "Updated Integration Opt Sync" });
      })
      .catch((error) => {
        this.setState({ alert: true, alertSeverity: "error", alertMsg: "Failed to update Integration Opt Sync" });
      });
  };

  campaignUserReport = (event) => {
    const { templates, templateIndex, setTemplate } = this.props;
    const template = templates[templateIndex];
    const checked = event.target.checked;
    const updatedSpecialAccess = { ...template.specialAccess, campaignUserReport: checked };
    this.setTemplateInDb({ specialAccess: updatedSpecialAccess })
      .then(() => {
        setTemplate({ ...template, specialAccess: updatedSpecialAccess });
        this.setState({ alert: true, alertSeverity: "success", alertMsg: "Updated Campaign User Report" });
      })
      .catch((error) => {
        this.setState({ alert: true, alertSeverity: "error", alertMsg: "Failed to update Campaign User Report" });
      });
  };

  updateWabaStep = async (event) => {
    try {
      const { templates, templateIndex, setTemplate } = this.props;
      const template = templates[templateIndex];

      await this.setTemplateInDb({
        wabaProgressStep: this.state.wabaProgressStep,
      });
      template.wabaProgressStep = this.state.wabaProgressStep;
      setTemplate(template);
      this.setState({
        alert: true,
        alertSeverity: "success",
        alertMsg: "Updated WABA Progress Step!",
      });
    } catch (error) {
      console.log({ error });
      this.setState({
        alert: true,
        alertSeverity: "error",
        alertMsg: "Failed to update WABA Progress Step!",
      });
    }
  };

  updateScheduledCampaignLimit = async (event) => {
    try {
      const { templates, templateIndex, setTemplate } = this.props;
      const template = templates[templateIndex];

      await this.setTemplateInDb({
        scheduleCampaignLimit: this.state.scheduleCampaignLimit,
      });

      template.scheduleCampaignLimit = this.state.scheduleCampaignLimit;
      setTemplate(template);
      this.setState({
        alert: true,
        alertSeverity: "success",
        alertMsg: "Updated scheduled campaign limit!",
      });
    } catch (error) {
      console.log({ error });
      this.setState({
        alert: true,
        alertSeverity: "error",
        alertMsg: "Failed to updated scheduled campaign limit!",
      });
    }
  };

  openBillingDialog = () => {
    this.setState({ billingProcessDialog: true });
  };

  closeBillingDialog = () => {
    this.setState({ billingProcessDialog: false });
  };

  setOngoingBilling = async (event) => {
    try {
      const { templates, templateIndex, setTemplate } = this.props;
      const template = templates[templateIndex];

      await this.setTemplateInDb({
        ongoingBillingProcess: null,
      });

      template.ongoingBillingProcess = null;
      setTemplate(template);
      this.setState({
        alert: true,
        alertSeverity: "success",
        alertMsg: "Billing Process set to Null",
      });
    } catch (error) {
      console.log({ error });
      this.setState({
        alert: true,
        alertSeverity: "error",
        alertMsg: "Failed to update Billing Process",
      });
    }
  };

  updateWabaNumberId = async (event) => {
    try {
      const { templates, templateIndex, setTemplate } = this.props;
      const template = templates[templateIndex];

      await this.setTemplateInDb({
        wabaNumberId: this.state.wabaNumberId,
      });
      template.wabaNumberId = this.state.wabaNumberId;
      setTemplate(template);
      this.setState({
        alert: true,
        alertSeverity: "success",
        alertMsg: "Updated WABA Number id",
      });
    } catch (error) {
      console.log({ error });
      this.setState({
        alert: true,
        alertSeverity: "error",
        alertMsg: "Failed to update WABA Number id",
      });
    }
  };

  updateWabaAppId = async (event) => {
    try {
      const { templates, templateIndex, setTemplate } = this.props;
      const template = templates[templateIndex];

      await this.setTemplateInDb({
        wabaAppId: this.state.wabaAppId,
      });
      template.wabaAppId = this.state.wabaAppId;
      setTemplate(template);
      this.setState({
        alert: true,
        alertSeverity: "success",
        alertMsg: "Updated WABA App id",
      });
    } catch (error) {
      console.log({ error });
      this.setState({
        alert: true,
        alertSeverity: "error",
        alertMsg: "Failed to update WABA App id",
      });
    }
  };

  fetchPartnerDetails = async () => {
    const partnerID = this.props.templates[this.props.templateIndex].partnerId;
    try {
      const response = await axios.get(
        URL +
        `/partner-apis/v1/partner/get-partner-details?partnerId=${partnerID}`
      );
      return response.data.whiteLabelUrl;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  handleOpenWhatsAppLink = (wabaInfo) => {
    const rawPhoneNumber =
      wabaInfo?.[0]?.phoneNumber ||
      this.props.templates[this.props.templateIndex]?.whatsappNumber;
    const cleanedPhoneNumber = rawPhoneNumber?.replace(/\D/g, "");

    if (cleanedPhoneNumber) {
      console.log(cleanedPhoneNumber);
      window.open(`https://wa.me/${cleanedPhoneNumber}`, "_blank");
    } else {
      console.error("Invalid or missing WhatsApp number.");
    }
  };

  loginAsOwner = async (value) => {
    const clientId = this.props.templates[this.props.templateIndex].clientId;
    const assistantId = this.props.templates[this.props.templateIndex]._id;
    // MSG-606: a role with only readOnlyLogin gets a read-only owner login.
    const mode = ownerLoginMode(
      this.props.permissions?.find((p) => p.label === "assistants")
    );

    try {
      const {
        data: { token },
      } = await axios.post(
        `${URL}${ownerLoginEndpoint(mode)}`,
        { _id: clientId, assistantId: assistantId, type: "agent" },
        {
          headers: {
            "x-aisensy-admin-token-key": ADMIN_KEY,
          },
        }
      );

      switch (value) {
        case "owner":
          window.open(
            `${APP_URL}/login?token=${token}&firstProjectId=${assistantId}`,
            "_blank"
          );
          break;
        case "partner": {
          const whiteLabelUrl = await this.fetchPartnerDetails();
          window.open(`${whiteLabelUrl}/login?token=${token}`, "_blank");
          break;
        }
        case "copy": {
          navigator.clipboard
            .writeText(
              `${APP_URL}/login?token=${token}&firstProjectId=${assistantId}`
            )
            .then(() => {
              window.alert(loginUrlCopiedMessage(mode));
            })
            .catch((error) => {
              console.error("Unable to copy text to clipboard:", error);
            });
          break;
        }
        case "vyapaar": {
          navigator.clipboard
            .writeText(
              `${VYAPAAR_APP_URL}/login?token=${token}&firstProjectId=${assistantId}`
            )
            .then(() => {
              window.alert(loginUrlCopiedMessage(mode));
            })
            .catch((error) => {
              console.error("Unable to copy text to clipboard:", error);
            });
          break;
        }
      }
    } catch (error) { }
  };

  loginIntoDashboard = async () => {
    const partnerId = this.props.templates[this.props.templateIndex].partnerId;
    try {
      const {
        data: { token },
      } = await axios.post(
        `${CLIENT_URL}/superadmin/generate-any-token`,
        {
          _id: partnerId,
          type: "partner",
        },
        {
          headers: {
            "x-aisensy-admin-token-key": ADMIN_KEY,
          },
        }
      );
      window.open(`${PARTNER_APP_URL}/login?token=${token}`, "_blank");
    } catch (error) { }
  };

  handleClick = () => {
    const { selectedIndex } = this.state;
    if (selectedIndex === 0) {
      this.loginAsOwner("partner");
    } else if (selectedIndex === 1) {
      this.loginIntoDashboard();
    } else if (selectedIndex === 2) {
      this.loginAsOwner("copy");
    } else if (selectedIndex === 3) {
      this.loginAsOwner("vyapaar");
    }
  };

  handleMenuItemClick = (event, index) => {
    this.setState({ selectedIndex: index, open: false }, () => {
      this.handleClick(); // Trigger the selected action immediately after selecting an option
    });
  };

  handleHoverOpen = () => {
    this.setState({ open: true });
  };

  handleHoverClose = (event) => {
    if (
      this.anchorRef.current.contains(event.target) ||
      (this.popperNode && this.popperNode.contains(event.target))
    ) {
      return;
    }
    this.setState({ open: false });
  };
  setPopperNode = (node) => {
    this.popperNode = node;
  };

  campaignReportingAllowed = async (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;
    this.setTemplateInDb({
      campaignReportingAllowed: checked,
    })
      .then((response) => {
        template.campaignReportingAllowed = checked;
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Campaign reporting status updated!",
          alertSeverity: "success",
          isChatScriptingRunning: false,
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update campaign reporting status",
          alertSeverity: "error",
          isChatScriptingRunning: false,
        });
      });
  };

  enableFlow = async (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      flowConfiguration: {
        ...template.flowConfiguration,
        isEnabled: checked,
        flowCount: template.flowConfiguration?.flowCount || 5,
        activeFlowCount: template.flowConfiguration?.flowCount || 5,
      },
    })
      .then((response) => {
        template.flowConfiguration = {
          ...template.flowConfiguration,
          isEnabled: checked,
          flowCount: template.flowConfiguration?.flowCount || 5,
          activeFlowCount: template.flowConfiguration?.flowCount || 5,
        };
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Flow status updated!",
          alertSeverity: "success",
          isChatScriptingRunning: false,
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update flow status",
          alertSeverity: "error",
          isChatScriptingRunning: false,
        });
      });
  };

  updateFlowObject = async (e) => {
    let template = this.props.templates[this.props.templateIndex];

    this.setTemplateInDb({
      flowConfiguration: {
        ...template.flowConfiguration,
        isEnabled:
          this.state?.flowConfiguration?.isEnabled ||
          template?.flowConfiguration?.isEnabled,
        flowCount: this.state?.flowConfiguration?.flowCount || 5,
        activeFlowCount: this.state?.flowConfiguration?.activeFlowCount || 5,
      },
    })
      .then((response) => {
        template.flowConfiguration = {
          ...template.flowConfiguration,
          isEnabled: this.state.flowConfiguration?.isEnabled,
          flowCount: this.state.flowConfiguration?.flowCount || 5,
          activeFlowCount: this.state.flowConfiguration?.activeFlowCount || 5,
        };
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Flow status updated!",
          alertSeverity: "success",
          isChatScriptingRunning: false,
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update flow status",
          alertSeverity: "error",
          isChatScriptingRunning: false,
        });
      });
  };

  updateWabaTpt = async () => {
    let template = this.props.templates[this.props.templateIndex];

    try {
      await this.setTemplateInDb({
        wabaTpt: this.state.wabaTpt,
      });

      await axios.post(`${URL}/superadmin/update-waba-throughput`, {
        phoneId: template.wabaNumberId,
        throughput: WABATPT_TIERS_THROUGHTPUT[this.state.wabaTpt] || 40,
        type: "outgoing",
      });

      template.wabaTpt = this.state.wabaTpt;
      this.props.setTemplate(template);
      this.setState({
        alert: true,
        alertMsg: "Waba Throughut Updated",
        alertSeverity: "success",
        isChatScriptingRunning: false,
      });
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg: "Unable to update Waba Throughut",
        alertSeverity: "error",
        isChatScriptingRunning: false,
      });
    }
  };

  updateWabaStatusTpt = async () => {
    let template = this.props.templates[this.props.templateIndex];

    try {
      await this.setTemplateInDb({
        wabaStatusTpt: this.state.wabaStatusTpt,
      });

      await axios.post(`${URL}/superadmin/update-waba-throughput`, {
        phoneId: template.wabaAppId,
        throughput: WABATPT_TIERS_THROUGHTPUT[this.state.wabaStatusTpt] || 150,
        type: "incoming",
      });

      template.wabaStatusTpt = this.state.wabaStatusTpt;
      this.props.setTemplate(template);
      this.setState({
        alert: true,
        alertMsg: "Waba Status Throughut Updated",
        alertSeverity: "success",
        isChatScriptingRunning: false,
      });
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg: "Unable to update Waba Status Throughut",
        alertSeverity: "error",
        isChatScriptingRunning: false,
      });
    }
  };

  updateWebhook = async () => {
    try {
      const response = await axios.post(
        `${URL}/superadmin/update-assistant-webhook`,
        {
          assistantId: this.props.templates[this.props.templateIndex]._id,
          webhookUrl: this.state.directApiWebookUrl,
        }
      );
      const { directApikey, directApiWebookUrl } = response.data;
      this.setState({
        directApikey,
        directApiWebookUrl,
      });
      this.setState({
        alert: true,
        alertMsg: "Webhook updated",
        alertSeverity: "success",
      });
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg: "Unable to update webhook",
        alertSeverity: "error",
      });
    }
  };

  updateWebhookAddon = async (event) => {
    // const assistant = this.props.templates[this.props.templateIndex];
    // const partnerAddons = assistant?.addons || {};
    // const newAddons = {
    //   ...partnerAddons,
    //   [event.target.name]: event.target.checked,
    // };
    // const addons = Object.keys(newAddons).filter((key) => newAddons[key]);
    // const assistantId = assistant._id;
    // const payload = {
    //   assistantId,
    //   addons,
    // };
    // axios.post(URL + "/superadmin/update-webhook", payload).then((res) => {
    //   this.setState({
    //     webhookAddon: !this.state.webhookAddon,
    //     alert: true,
    //     alertMsg: !this.state.webhookAddon
    //       ? "webhook enabled successfully"
    //       : "webhook disabled successfully",
    //     alertSeverity: "success",
    //   }).catch((error) => {
    //     this.setState({
    //       alert: true,
    //       alertMsg: !this.state.webhookAddon
    //         ? "webhook enabled failed"
    //         : "webhook disabled success",
    //       alertSeverity: "error",
    //     });
    //   });
    // });
  };

  migratePhoneNumber = async () => {
    try {
      const { migrationNumber, srcAssistantId } = this.state;
      await axios.patch(`${URL}/superadmin/migrate-project-number`, {
        phoneNumber: migrationNumber,
        srcAssistantId,
        destAssistantId: this.props.templates[this.props.templateIndex]._id,
      });
      this.setState({
        alert: true,
        alertMsg: "Migration successfull!",
        alertSeverity: "success",
      });
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.messsage ||
        "Something went wrong. Cannot migrate this number to this project";
      this.setState({
        alert: true,
        alertMsg: message,
        alertSeverity: "error",
      });
    }
  };

  migrateProjectToPartner = async () => {
    try {
      const { partnerId, defaultPlan, activationDate } = this.state;
      await axios.patch(`${URL}/superadmin/migrate-project-to-partner`, {
        projectId: this.props.templates[this.props.templateIndex]._id,
        partnerId,
        defaultPlan,
        activationDate,
        templateCredit:
          this.props.templates[this.props.templateIndex]?.templateCredit ||
          "NA", // passing for admin logs
        metaAdsCredit:
          this.props.templates[this.props.templateIndex]?.metaAdsCredit || "NA", // passing for admin logs
        partnerWhatsappCredit:
          this.props.templates[this.props.templateIndex]
            ?.partnerWhatsappCredit || "NA", // passing for admin logs
      });
      this.setState({
        alert: true,
        alertMsg: "Migration successfull!",
        alertSeverity: "success",
      });
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.messsage ||
        "Something went wrong. Cannot migrate this project to Partner";
      this.setState({
        alert: true,
        alertMsg: message,
        alertSeverity: "error",
      });
    }
  };

  migratePartnerProjectToAisensy = async (migrateAll = false) => {
    try {
      await axios.patch(
        `${URL}/superadmin/migrate-partner-project-to-aisensy`,
        {
          projectId: this.props.templates[this.props.templateIndex]._id,
          templateCredit:
            this.props.templates[this.props.templateIndex]?.templateCredit ||
            "NA", // passing for admin logs
          metaAdsCredit:
            this.props.templates[this.props.templateIndex]?.metaAdsCredit ||
            "NA", // passing for admin logs
          partnerWhatsappCredit:
            this.props.templates[this.props.templateIndex]
              ?.partnerWhatsappCredit || "NA", // passing for admin logs
          migrateAll,
        }
      );
      this.setState({
        alert: true,
        alertMsg: "Migration successfull!",
        alertSeverity: "success",
        migrateAllProjectsDialog: false,
      });
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.messsage ||
        "Something went wrong. Cannot migrate this Partner project to AiSensy!";

      // Check if error is about multiple projects
      if (message.includes("Multiple projects associated with the business")) {
        this.setState({
          migrateAllProjectsDialog: true,
        });
      } else {
        this.setState({
          alert: true,
          alertMsg: message,
          alertSeverity: "error",
        });
      }
    }
  };

  closeMigrateAllProjectsDialog = () => {
    this.setState({ migrateAllProjectsDialog: false });
  };

  handleUrlChange = (event, index, webhookIndex) => {
    const updatedApp = [...this.state.privateApps];
    updatedApp[index].webhooks[webhookIndex].webhookUrl = event.target.value;
    this.setState({ privateApps: updatedApp });
  };

  handleCheckboxChange = (index, webhookIndex, topicLabel) => {
    const updatedApp = [...this.state.privateApps];

    if (
      updatedApp[index]?.webhooks[webhookIndex]?.topicsArray?.includes(
        topicLabel
      )
    ) {
      // If yes, remove it
      updatedApp[index].webhooks[webhookIndex].topicsArray = updatedApp[
        index
      ].webhooks[webhookIndex].topicsArray.filter(
        (label) => label !== topicLabel
      );
    } else {
      // If no, add it
      updatedApp[index].webhooks[webhookIndex].topicsArray.push(topicLabel);
    }

    this.setState({ privateApps: updatedApp });
  };

  createPrivateApp = async () => {
    try {
      const { data } = await axios.post(`${URL}/superadmin/create-privateapp`, {
        assistantId: this.props.templates[this.props.templateIndex]._id,
        password: this.generateRandomPassword(),
      });

      const newPrivateApp = {
        privateAppId: data._id,
        webhooks: [{ topicsArray: [], webhookUrl: "", webhookId: "" }],
        apiPassword: "",
      };

      this.setState((prevState) => ({
        privateApps: [...prevState.privateApps, newPrivateApp],
      }));

      this.setState({
        alert: true,
        alertMsg: "Private App created",
        alertSeverity: "success",
      });
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.messsage ||
        "Something went wrong. Cannot create private app!";
      this.setState({
        alert: true,
        alertMsg: message,
        alertSeverity: "error",
      });
    }
  };

  generateRandomPassword = () => {
    const length = 21;
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        console.log("Text copied to clipboard");
      })
      .catch((err) => {
        console.error("Unable to copy text to clipboard", err);
      });
  };

  handleClickOpen = (index) => {
    this.setState({ regenerateConfirmOpen: true, currentIndex: index });
  };

  handleClose = () => {
    this.setState({ regenerateConfirmOpen: false, currentIndex: null });
  };

  reGeneratePassword = async (index) => {
    if (index === null || index === undefined || !this.state.privateApps[index]) {
      return;
    }
    try {
      const { data } = await axios.post(
        `${URL}/superadmin/re-generate-password`,
        {
          privateAppId: this.state.privateApps[index].privateAppId,
          assistantId: this.props.templates[this.props.templateIndex]._id,
        }
      );

      const updatedPrivateApps = [...this.state.privateApps];
      updatedPrivateApps[index].apiPassword = data;

      this.setState({
        alert: true,
        alertMsg: "Successfully Regenerated Password",
        alertSeverity: "success",
      });
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg: "Error while Regenerating Password",
        alertSeverity: "error",
      });
    }
  };

  handleDialogOpen = () => {
    this.setState({ isDialogOpen: true });
  };

  handleDialogClose = () => {
    this.setState({ isDialogOpen: false });
  };

  createWebhook = async (index, webhookIndex) => {
    try {
      const { data } = await axios.post(
        `${URL}/superadmin/create-or-update-webhook`,
        {
          assistantId: this.props.templates[this.props.templateIndex]._id,
          privateAppId: this.state.privateApps[index]?.privateAppId,
          topicsArr:
            this.state.privateApps[index]?.webhooks[webhookIndex]?.topicsArray,
          webhookUrl:
            this.state.privateApps[index]?.webhooks[webhookIndex]?.webhookUrl,
          webhookId:
            this.state.privateApps[index]?.webhooks[webhookIndex]?.webhookId ||
            "",
        }
      );

      const updatedPrivateApps = [...this.state.privateApps];
      if (data.created) {
        updatedPrivateApps[index].webhooks[webhookIndex].webhookId =
          data.webhookId;
        updatedPrivateApps[index].webhooks[webhookIndex].sharedSecret =
          data.sharedSecret;
      }

      this.setState({
        privateApps: updatedPrivateApps,
        alert: true,
        alertMsg:
          data.created === true ? "Webhook created!" : "Webhook updated!",
        alertSeverity: "success",
      });
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.messsage ||
        "Something went wrong. Cannot create webhook!";
      this.setState({
        alert: true,
        alertMsg: message,
        alertSeverity: "error",
      });
    }
  };

  fetchChargeBeeLogs = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;

    axios
      .post(URL + "/superadmin/fetch-chargeBee-logs", {
        assistantId,
      })

      .then((response) => {
        this.setState({
          chargeBeeLogs: response?.data?.result,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Unable to fetch chargeBee logs",
          alertSeverity: "error",
        });
      });
  };

  fetchFBMInfo = () => {
    const payload = {
      fbBusinessId:
        this.props.templates[this.props.templateIndex]?.fbBusinessId,
      wabaId:
        this.props.templates[this.props.templateIndex]?.wabaAppId,
    };
    axios
      .get(`${URL}/superadmin/fetch-fbm-meta-info`, {
        params: payload,
      })
      .then((res) => {
        this.setState({
          FBMInfo: {
            name: res?.data?.businessInfo?.name,
            status: res?.data?.businessInfo?.verification_status,
          },
          fbmInfoLoading: false,
        });
      })
      .catch((e) => {
        console.error(e);
        this.setState({
          FBMInfo: {},
          fbmInfoLoading: false,
        });
      });
  };
  fetchCreditInfo = () => {
    const payload = {
      fbBusinessId:
        this.props.templates[this.props.templateIndex]?.fbBusinessId,
      wabaAppId: this.props.templates[this.props.templateIndex]?.wabaAppId,
      assistantId: this.props.templates[this.props.templateIndex]?._id,
      allocationId:
        this.props.templates[this.props.templateIndex]?.allocationId,
    };
    axios
      .get(`${URL}/superadmin/verify-credit-line`, {
        params: payload,
      })
      .then((res) => {
        this.setState({
          creditLineInfo: res.data.message,
        });
      })
      .catch((e) => {
        console.error(e);
        this.setState({
          creditLineInfo: "",
        });
      });
  };

  //  A partner's WABA is theirs to manage, so these maintenance actions are
  //  hidden for partner-owned projects — except for full-access ("*") admins,
  //  who may still act on them. The backend applies the same exemption in
  //  loadAssistantForWabaAction; this only keeps the UI in step with it.
  isPartnerOwnedProject = () => {
    const partnerId =
      this.props.templates[this.props.templateIndex]?.partnerId;
    return Boolean(partnerId) && partnerId !== AISENSY_PARTNER_ID;
  };

  resubscribeWebhook = async () => {
    this.setState({ resubscribeWebhookLoading: true });
    try {
      const { data } = await axios.post(`${URL}/superadmin/resubscribe-webhook`, {
        assistantId: this.props.templates[this.props.templateIndex]?._id,
      });
      this.setState({
        resubscribeWebhookDialog: false,
        alert: true,
        alertMsg: data.alreadySubscribed
          ? "App is already subscribed to this WABA's webhooks"
          : "Webhook subscribed successfully",
        alertSeverity: "success",
      });
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg:
          error?.response?.data?.errorMessage ||
          error?.response?.data?.message ||
          "Failed to re-subscribe the webhook",
        alertSeverity: "error",
      });
    } finally {
      this.setState({ resubscribeWebhookLoading: false });
    }
  };

  //  Opens the revoke modal on the allocation Meta actually holds, so the
  //  operator confirms against live data rather than a stored id.
  openRemoveCreditLineDialog = async () => {
    this.setState({
      removeCreditLineDialog: true,
      creditLineAllocationLoading: true,
      creditLineAllocation: null,
      creditLineAllocationError: null,
    });
    try {
      const { data } = await axios.post(
        `${URL}/superadmin/credit-line-allocation`,
        { assistantId: this.props.templates[this.props.templateIndex]?._id }
      );
      this.setState({
        creditLineAllocation: data,
        creditLineAllocationLoading: false,
      });
    } catch (error) {
      this.setState({
        creditLineAllocationLoading: false,
        creditLineAllocationError:
          error?.response?.data?.errorMessage ||
          error?.response?.data?.message ||
          "Failed to fetch the credit line allocation",
      });
    }
  };

  removeCreditLine = async () => {
    this.setState({ removeCreditLineLoading: true });
    try {
      const { data } = await axios.post(
        `${URL}/superadmin/remove-credit-line`,
        { assistantId: this.props.templates[this.props.templateIndex]?._id }
      );
      this.setState({
        removeCreditLineDialog: false,
        creditLineAllocation: null,
        alert: true,
        alertMsg: data.alreadyDeleted
          ? "Credit line was already revoked"
          : "Credit line revoked successfully",
        alertSeverity: "success",
      });
      //  Reflect the revoke in the readout above directly: /verify-credit-line
      //  reads `receiving_credential{id}`, which a DELETED allocation no longer
      //  has, so re-fetching would blank the field instead of updating it.
      this.setState({ creditLineInfo: "Not attached" });
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg:
          error?.response?.data?.errorMessage ||
          error?.response?.data?.message ||
          "Failed to revoke the credit line",
        alertSeverity: "error",
      });
    } finally {
      this.setState({ removeCreditLineLoading: false });
    }
  };

  fetchWabaInfo = () => {
    const payload = {
      wabaAppId: this.props.templates[this.props.templateIndex]?.wabaAppId,
    };
    axios
      .get(`${URL}/superadmin/fetch-waba-meta-info`, {
        params: payload,
      })
      .then((res) => {
        const liveWabaDetails =
          res?.data?.wabaInfo?.map((data) => {
            return {
              phoneNumber: data?.display_phone_number,
              status: data?.status,
              displayName: data?.verified_name,
              qualityRating: data?.quality_rating,
              displayNameStatus: data?.name_status,
              messagingLimit: data?.messaging_limit_tier || data?.whatsapp_business_manager_messaging_limit,
              id: data?.id,
            };
          }) || [];

        this.setState({
          wabaInfo: liveWabaDetails,
          wabaInfoLoading: false,
        });
      })
      .catch((e) => {
        console.error(e);
        this.setState({
          wabaInfo: [],
          wabaInfoLoading: false,
        });
      });
  };

  fetchGoogleAdsConfig = async () => {
    const template = this.props.templates[this.props.templateIndex];
    const assistantId = template._id;

    try {
      const response = await axios.get(`${URL}/superadmin/google-ads-config/${assistantId}`);
      const { adsData, widgetData } = response.data;

      // --- Process Ads Data ---
      if (adsData.hasError) {
        this.setState({
          googleAdsConversionFetchFailed: true,
          savedGoogleAdAccountId: '-',
          savedGoogleClickConversionId: '-',
          savedGoogleConversationInitiatedId: '-',
        });
      } else if (adsData.isNotFound) {
        this.setState({
          savedGoogleAdAccountId: 'NOT-SET',
          savedGoogleClickConversionId: 'NOT-SET',
          savedGoogleConversationInitiatedId: 'NOT-SET',
        });
      } else if (adsData.data) {
        const { adAccountId, conversionEvents } = adsData.data;
        const clickConversion = conversionEvents.find(e => e.event === 'CLICK_CONVERSION');
        const conversationInitiated = conversionEvents.find(e => e.event === 'WHATSAPP_CONVERSATION');

        this.setState({
          googleAdAccountId: adAccountId || '',
          googleClickConversionId: clickConversion?.conversionId || '',
          googleConversationInitiatedId: conversationInitiated?.conversionId || '',
          savedGoogleAdAccountId: adAccountId || 'NOT-SET',
          savedGoogleClickConversionId: clickConversion?.conversionId || 'NOT-SET',
          savedGoogleConversationInitiatedId: conversationInitiated?.conversionId || 'NOT-SET',
          googleAdsConversionSaved: true,
        });
      }

      // --- Process Widget Data ---
      if (widgetData.hasError) {
        this.setState({
          widgetLinkFetchFailed: true,
          savedWidgetId: '-',
        });
      } else if (widgetData.isNotFound) {
        this.setState({ savedWidgetId: 'NOT-SET' });
      } else if (widgetData.data) {
        const fetchedWidgetId = widgetData.data.widgetId;
        this.setState({
          widgetId: fetchedWidgetId,
          savedWidgetId: fetchedWidgetId,
          widgetLinkSaved: true,
        });
      }

    } catch (error) {
      this.setState({
        googleAdsConversionFetchFailed: true,
        widgetLinkFetchFailed: true,
      });
    } finally {
      this.setState({ googleAdsConfigLoading: false });
    }
  };


  updateGoogleAdsConfig = async () => {
    const {
      googleAdAccountId,
      widgetId,
      googleClickConversionId,
      googleConversationInitiatedId,
      googleAdsConversionSaved,
      widgetLinkSaved,
    } = this.state;

    const template = this.props.templates[this.props.templateIndex];
    const assistantId = template._id;

    try {
      const response = await axios.post(
        `${URL}/superadmin/google-ads-config/${assistantId}`,
        {
          googleAdAccountId,
          widgetId,
          googleClickConversionId,
          googleConversationInitiatedId,
          updateAds: !googleAdsConversionSaved,
          updateWidget: !widgetLinkSaved
        }
      );

      const { adsResult, widgetResult } = response.data;

      // Update state if Ads was saved
      if (adsResult) {
        const adAccountId = adsResult.adAccountId;
        const clickConversionId = adsResult.conversionEvents.find(
          e => e.event === 'CLICK_CONVERSION'
        )?.conversionId;
        const conversationInitiatedId = adsResult.conversionEvents.find(
          e => e.event === 'WHATSAPP_CONVERSATION'
        )?.conversionId;

        this.setState({
          savedGoogleAdAccountId: adAccountId,
          savedGoogleClickConversionId: clickConversionId,
          savedGoogleConversationInitiatedId: conversationInitiatedId,
          googleAdsConversionSaved: true,
        });
      }

      // Update state if Widget was saved
      if (widgetResult) {
        this.setState({
          savedWidgetId: widgetResult.widgetId,
          widgetLinkSaved: true,
        });
      }

      this.setState({
        alert: true,
        alertMsg: 'Google Ads config updated successfully',
        alertSeverity: 'success',
      });

    } catch (error) {
      this.setState({
        alert: true,
        alertMsg: error?.response?.data?.error || 'Failed to update Google Ads config',
        alertSeverity: 'error',
      });
    }
  };

  componentDidMount() {
    const { permissions } = this.props;
    const assistantPermissions = permissions?.find(
      (p) => p.label === "assistants"
    );
    const subRoutes = assistantPermissions?.subroutes;
    this.fetchFBMInfo();
    this.fetchWabaInfo();
    if (!TENANT_ID && verifySubRouteAccess(subRoutes, "googleAds", "read")) {
      this.fetchGoogleAdsConfig();
    }

    this.fetchCreditInfo();
    this.fetchMandateView();
    this.checkAdsSetupManager();
    this.checkFbConnectedAssistant();
    if (
      subRoutes
        ?.find((e) => e.label === "devArea")
        ?.actions?.includes("sendMessageEncryption")
    ) {
      this.loadEncryptionCapabilities();
      this.loadMessageEncryptionConfig();
    }
    if (
      subRoutes
        ?.find((e) => e.label === "devArea")
        ?.actions?.includes("customWebhookConfig")
    ) {
      this.loadCustomWebhookConfig();
    }

    this.getAssistantDetailsFromCache();
    const partner = this.props.templates[this.props.templateIndex].partnerId
      ? this.getPartnerFromCache()
      : "";
    const assistant = this.props.templates[this.props.templateIndex];
    // const addons = assistant?.addons?.WEBHOOKS;
    // this.setState({
    //   webhookAddon: addons,
    // });
    const assistantId = assistant._id;

    this.fetchChargeBeeLogs();

    // Fetch dashboard lock status for this assistant
    const hasExtrasWriteAccess = verifySubRouteAccess(
      subRoutes,
      "extras",
      "write"
    );
    if (hasExtrasWriteAccess) {
      this.fetchDashboardLockStatus(assistantId);
    }

    if (!isEmpty(assistant?.orderCheckoutDetails?.paymentSlabs)) {
      this.setState({
        whatsappPaySlabs: JSON.stringify(
          assistant?.orderCheckoutDetails?.paymentSlabs,
          null,
          2
        ),
      });
    }

    axios
      .post(`${URL}/superadmin/view-super-admin-logs`, {
        assistantId,
      })
      .then((response) => {
        const newLogs = response.data.map((log) => {
          const newLog = { ...log };
          delete newLog.body.assistantId;
          if (Object.keys(newLog.body).length === 0) {
            return undefined;
          } else {
            return newLog;
          }
        });
        const filteredLogs = newLogs.filter((log) => log !== undefined);
        this.setState({
          logs: filteredLogs,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(URL + "/superadmin/get-client-details", {
        assistantId,
      })
      .then((response) => {
        this.setState({
          ownerName: response.data.email,
          // Owner-level flag: whether agents created from here on are auto-masked.
          accountMaskingEnabled:
            !!response.data?.specialAccess?.shouldMaskAgents,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Owner email not found",
          alertSeverity: "error",
        });
      });

    axios
      .post(URL + "/superadmin/get-private-apps", {
        assistantId,
      })
      .then((response) => {
        const data = response.data;
        this.setState({
          privateApps: data,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Unable to fetch private Apps",
          alertSeverity: "error",
        });
      });

    this.setState({
      existingSpecialAccess:
        this.props.templates[this.props.templateIndex].specialAccess || {},
    });
  }

  loadWebhookLogs = (page = 0, forceRefresh = false) => {
    const cached = this.state.webhookLogsCache[page];
    if (cached && !forceRefresh) {
      this.setState({
        webhookLogs: cached.logs,
        webhookLogsPage: page,
        webhookLogsHasMore: cached.hasMore,
      });
      return;
    }

    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const { startDate, endDate } = this.state.applied.webhookDelivery;
    const { webhookStartTime, webhookEndTime } = this.state;

    //  "HH:mm" or "HH:mm:ss" -> parts. Anything unparseable falls back to the
    //  whole-day bound, so a half-typed time can never silently narrow a search.
    const parseTime = (value) => {
      if (!value) return null;
      const parts = String(value).split(":").map((n) => Number.parseInt(n, 10));
      if (parts.some((n) => Number.isNaN(n))) return null;
      const [hour = 0, minute = 0, second = 0] = parts;
      if (hour > 23 || minute > 59 || second > 59) return null;
      return { hour, minute, second };
    };

    const startTime = parseTime(webhookStartTime) || {
      hour: 0,
      minute: 0,
      second: 0,
    };
    const endTime = parseTime(webhookEndTime) || {
      hour: 23,
      minute: 59,
      second: 59,
    };

    const normalizedStartDate = startDate
      ? moment(startDate).set({ ...startTime, millisecond: 0 })
      : null;
    //  Inclusive of the whole second the user named.
    const normalizedEndDate = endDate
      ? moment(endDate).set({ ...endTime, millisecond: 999 })
      : null;
    const { webhookNamespace, webhookSubType, webhookFilterValues } = this.state;
    const activeFilters = Object.fromEntries(
      Object.entries(webhookFilterValues).filter(([, v]) => v.trim() !== "")
    );

    this.setState({ webhookLogsLoading: true });

    axios
      .post(URL + "/superadmin/get-webhook-logs", {
        assistantId,
        page,
        limit: this.state.limit,
        ...(normalizedStartDate && { startDate: normalizedStartDate.toISOString() }),
        ...(normalizedEndDate && { endDate: normalizedEndDate.toISOString() }),
        ...(webhookNamespace && webhookNamespace !== "All" && { namespace: webhookNamespace }),
        ...(webhookSubType && { subType: webhookSubType }),
        ...(Object.keys(activeFilters).length > 0 && { filters: activeFilters }),
      })
      .then((response) => {
        const logs = response?.data?.data || [];
        const currentPage = response?.data?.currentPage || 0;
        const hasMore = logs.length >= this.state.limit;
        this.setState((prev) => ({
          webhookLogs: logs,
          webhookLogsPage: currentPage,
          webhookLogsHasMore: hasMore,
          webhookLogsLoading: false,
          webhookLogsFetched: true,
          webhookLogsCache: {
            ...prev.webhookLogsCache,
            [currentPage]: { logs, hasMore },
          },
        }));
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alert: true,
          alertMsg: "Unable to fetch webhook logs",
          alertSeverity: "error",
          webhookLogsLoading: false,
        });
      });
  };

  exportWebhookLogsToCSV = () => {
    const { webhookLogs, webhookNamespace, webhookLogsPage } = this.state;
    const ns = webhookNamespace || "all";
    const filename = `webhook-logs-${ns}-page${webhookLogsPage + 1}`;
    downloadCSV(webhookLogs, WEBHOOK_LOG_CSV_COLUMNS, filename);
  };

  resetWebhookFilters = (newNamespace) => {
    this.setState((prev) => ({
      webhookNamespace: newNamespace,
      webhookSubType: "",
      webhookStartTime: "",
      webhookEndTime: "",
      webhookFilterValues: {},
      webhookLogsCache: {},
      webhookLogs: [],
      webhookLogsPage: 0,
      webhookLogsHasMore: false,
      webhookLogsFetched: false,
      webhookFiltersOpen: false,
      applied: {
        ...prev.applied,
        webhookDelivery: { startDate: null, endDate: null, focusedInput: null },
      },
    }));
  };

  resetAllWebhookFilters = () => {
    this.setState((prev) => ({
      webhookNamespace: "",
      webhookSubType: "",
      webhookStartTime: "",
      webhookEndTime: "",
      webhookFilterValues: {},
      webhookLogsCache: {},
      webhookLogs: [],
      webhookLogsPage: 0,
      webhookLogsHasMore: false,
      webhookLogsFetched: false,
      webhookFiltersOpen: false,
      applied: {
        ...prev.applied,
        webhookDelivery: { startDate: null, endDate: null, focusedInput: null },
      },
    }));
  };

  migrateTemplates = async () => {
    try {
      const { migrateTemplatesFrom, migrateTemplatesTo } = this.state;

      if (!migrateTemplatesFrom || !migrateTemplatesTo) {
        return;
      }

      const url = `${URL}/superadmin/migrate-templates`;
      const body = {
        sourceId: migrateTemplatesFrom,
        destinationId: migrateTemplatesTo,
      };

      await axios.post(url, body);
    } catch (error) {
      console.log({ error });
    }
  };

  initiateSmartpingMigration = async (mode) => {
    try {
      const projectId =
        this.props.templates[this.props.templateIndex]?._id;

      if (!projectId) {
        return;
      }

      const url = `${URL}/superadmin/initiate-smartping-migration`;
      const body = {
        mode,
        projectIds: [projectId],
      };

      await axios.post(url, body, {
        headers: {
          "Content-Type": "application/json",
          "x-request-source": "superadmin",
        },
      });

      this.setState({
        alert: true,
        alertMsg: `Smartping migration to ${mode} initiated successfully!`,
        alertSeverity: "success",
      });
    } catch (error) {
      console.log({ error });
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error?.message ||
        error.message ||
        "Failed to initiate Smartping migration";

      this.setState({
        alert: true,
        alertMsg: message,
        alertSeverity: "error",
      });
    }
  };

  enableCtwaFunnel = async () => {
    try {
      const { affiliateId, adId } = this.state.ctwaFunnel || {};

      if (!affiliateId || !adId) {
        return;
      }

      const url = `${URL}/superadmin/wa-forms/enable-signup-form`;
      const body = {
        assistantId: this.props.templates[this.props.templateIndex]._id,
        affiliateId,
        adId,
      };

      await axios.post(url, body);
      this.setState({
        alert: true,
        alertMsg: "Flow enabled successfully!",
        alertSeverity: "success",
      });
    } catch (error) {
      console.log({ error });
      const message =
        error?.response?.data?.error?.message ||
        error.message ||
        error.errorMessage ||
        error;

      this.setState({
        alert: true,
        alertMsg: `Unable to enable CTWA Funnel: ${message}`,
        alertSeverity: "error",
      });
    }
  };

  getCampaignErrorCurl = async () => {
    try {
      const { campaignId, userNumber } = this.state.campaignErrorCurl || {};

      if (!campaignId || !userNumber) {
        return;
      }

      const url = `${URL}/superadmin/get-campaign-error-curl`;
      const body = {
        assistantId: this.props.templates[this.props.templateIndex]._id,
        campaignId,
        userNumber,
      };

      const { data } = await axios.post(url, body);
      navigator.clipboard.writeText(data.curl);
      this.setState({
        alert: true,
        alertMsg: "cURL copied to clipboard!",
        alertSeverity: "success",
      });
    } catch (error) {
      console.log({ error });
      const message =
        error?.response?.data?.error?.message ||
        error.message ||
        error.errorMessage ||
        error;

      this.setState({
        alert: true,
        alertMsg: `Unable to get cURL: ${message}`,
        alertSeverity: "error",
      });
    }
  };

  updateNumberMasking = async (enable) => {
    const fullAccount = this.state.numberMaskingScope === "account";
    const project = this.props.templates[this.props.templateIndex];
    const scopeLabel = fullAccount
      ? "the ENTIRE ACCOUNT (every project this client owns)"
      : `the project "${project.businessName || project.name || project._id}"`;

    if (
      !window.confirm(
        `${enable ? "Enable" : "Disable"} number masking for ${scopeLabel}?\n\n` +
          `This ${enable ? "hides" : "restores"} customer phone numbers and names ` +
          `for every non-owner agent in scope.` +
          (enable
            ? "\n\nNote: agents created on this account from now on will also be masked."
            : "")
      )
    ) {
      return;
    }

    this.setState({ numberMaskingInProgress: true });
    try {
      const { data } = await axios.post(`${URL}/superadmin/number-masking`, {
        projectId: project._id,
        fullAccount,
        enable,
      });

      this.setState({
        accountMaskingEnabled: enable
          ? true
          : // The server reports whether the account-wide flag survived, because a
            // project-scoped disable keeps it while any other project is masked.
            !!data?.accountMaskingEnabled,
        alert: true,
        alertMsg: data?.message || "Number masking updated successfully",
        alertSeverity: "success",
      });
    } catch (error) {
      console.log({ error });
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error?.message ||
        error.message ||
        error.errorMessage ||
        error;

      this.setState({
        alert: true,
        alertMsg: `Unable to update number masking: ${message}`,
        alertSeverity: "error",
      });
    } finally {
      this.setState({ numberMaskingInProgress: false });
    }
  };

  getMmliteLockStatusText = () => {
    const s = this.state.mmliteLockStatus;
    if (!s) return "— (click Check Status)";
    if (!s.exists) return "No active MM Lite lock.";
    const firstSeen = s.firstSeen
      ? new Date(s.firstSeen).toLocaleString()
      : "unknown";
    if (s.isBlocked)
      return `LOCKED — dashboard blocked (first seen ${firstSeen})`;
    return `Active — not yet blocking. ${s.daysLeft} day(s) left (first seen ${firstSeen})`;
  };

  checkMmliteLockStatus = async () => {
    try {
      const url = `${URL}/superadmin/get-mmlite-lock-status`;
      const body = {
        assistantId: this.props.templates[this.props.templateIndex]._id,
      };

      const { data } = await axios.post(url, body);
      this.setState({ mmliteLockStatus: data });
    } catch (error) {
      console.log({ error });
      const message =
        error?.response?.data?.error?.message ||
        error.message ||
        error.errorMessage ||
        error;

      this.setState({
        alert: true,
        alertMsg: `Unable to fetch MM Lite lock status: ${message}`,
        alertSeverity: "error",
      });
    }
  };

  resetMmliteLock = async () => {
    try {
      const url = `${URL}/superadmin/reset-mmlite-lock`;
      const body = {
        assistantId: this.props.templates[this.props.templateIndex]._id,
      };

      const { data } = await axios.post(url, body);
      this.setState({
        alert: true,
        alertMsg: data.existed
          ? "MM Lite dashboard lock reset."
          : "No active MM Lite lock was found (nothing to reset).",
        alertSeverity: "success",
      });
      this.checkMmliteLockStatus();
    } catch (error) {
      console.log({ error });
      const message =
        error?.response?.data?.error?.message ||
        error.message ||
        error.errorMessage ||
        error;

      this.setState({
        alert: true,
        alertMsg: `Unable to reset MM Lite lock: ${message}`,
        alertSeverity: "error",
      });
    }
  };

  removeAdsSetupManager = async () => {
    this.setState({ adsSetupDeletionInProgress: true });
    try {
      await axios.post(`${URL}/superadmin/delete-child-bm`, {
        projectId: this.props.templates[this.props.templateIndex]._id,
      });

      this.setState({
        alert: true,
        alertMsg: "Ads Setup Manager removed successfully!",
        alertSeverity: "success",
        isAdsMangerSetupPresent: false,
      });
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error?.message ||
        error.message ||
        error.errorMessage ||
        error;
      console.log("Error removing ads setup manager", { error }, message);

      this.setState({
        alert: true,
        alertMsg: `Unable to Remove Ads Manager Setup: ${message}`,
        alertSeverity: "error",
      });
    }
    this.setState({
      removeAdsSetupManagerDialog: false,
      adsSetupDeletionInProgress: false,
    });
  };

  checkAdsSetupManager = async () => {
    try {
      const { data } = await axios.post(
        `${URL}/superadmin/check-ads-setup-manager`,
        {
          projectId: this.props.templates[this.props.templateIndex]._id,
        }
      );

      if (data.setupExists) {
        this.setState({ isAdsMangerSetupPresent: true });
      } else {
        this.setState({ isAdsMangerSetupPresent: false });
      }
    } catch (error) {
      this.setState({ isAdsMangerSetupPresent: false });
      console.log({ error });
      const message =
        error?.response?.data?.error?.message ||
        error.message ||
        error.errorMessage ||
        error;

      this.setState({
        alert: true,
        alertMsg: `Unable Check Ads Manager Setup: ${message}`,
        alertSeverity: "error",
      });
    }
  };

  checkFbConnectedAssistant = async () => {
    try {
      const { data } = await axios.post(
        `${URL}/superadmin/check-for-connected-assistant`,
        {
          projectId: this.props.templates[this.props.templateIndex]._id,
        }
      );
      if (data.statusOk && data.setupAssistantId) {
        this.setState({ fbConnectedAssistantId: data.setupAssistantId });
      }
    } catch (error) {
      this.setState({ fbConnectedAssistantId: null });
      console.log({ error });
      const message =
        error?.response?.data?.error?.message ||
        error.message ||
        error.errorMessage ||
        error;
      this.setState({
        alert: true,
        alertMsg: `Unable Fb Connected Assistant: ${message}`,
        alertSeverity: "error",
      });
    }
  };

  checkCampaignStatus = async () => {
    this.setState({ fetchCampaignStatusLoader: true });
    try {
      const { data } = await axios.post(
        `${URL}/superadmin/check-for-active-campaigns`,
        {
          projectId: this.props.templates[this.props.templateIndex]._id,
        }
      );
      if (data.statusOk) {
        if (data.allCampaignPaused) {
          this.setState({
            pauseAllCampaignsDialog: false,
            removeAdsSetupManagerDialog: true,
            allCampaignStatus: "PAUSED",
            campaigns: data.campaigns,
          });
        } else {
          this.setState({
            pauseAllCampaignsDialog: true,
            removeAdsSetupManagerDialog: false,
            allCampaignStatus: "ACTIVE",
            campaigns: data.campaigns,
          });
        }
      }
    } catch (error) {
      this.setState({
        pauseAllCampaignsDialog: false,
        allCampaignStatus: "ACTIVE",
        campaigns: [],
      });
      console.log({ error });
      const message =
        error?.response?.data?.error?.message ||
        error.message ||
        error.errorMessage ||
        error;
      this.setState({
        alert: true,
        alertMsg: `Unable To Check Campaign Status: ${message}`,
        alertSeverity: "error",
      });
    }
    this.setState({ fetchCampaignStatusLoader: false });
  };
  setAllCampaignStatus = async () => {
    this.setState({ setCampaignStatusLoader: true });
    try {
      const desiredStatus =
        this.state.allCampaignStatus === "ACTIVE" ? "PAUSED" : "ACTIVE";
      const { data } = await axios.post(
        `${URL}/superadmin/set-all-campaign-status`,
        {
          projectId: this.props.templates[this.props.templateIndex]._id,
          desiredStatus,
        }
      );
      if (data.statusOk) {
        // this.setState({ allCampaignStatus: desiredStatus });
        await this.checkCampaignStatus();
      }
    } catch (error) {
      this.setState({
        pauseAllCampaignsDialog: false,
      });
      console.log({ error });
      const message =
        error?.response?.data?.error?.message ||
        error.message ||
        error.errorMessage ||
        error;
      this.setState({
        alert: true,
        alertMsg: `Unable Set Campaign Status: ${message}`,
        alertSeverity: "error",
      });
    }
    this.setState({ setCampaignStatusLoader: false });
  };

  disableDirectApi = async () => {
    try {
      await axios.post(`${URL}/superadmin/disable-direct-apis`, {
        projectId: this.props.templates[this.props.templateIndex]._id,
      });
      let template = this.props.templates[this.props.templateIndex];

      template.directApikey = undefined;
      this.props.setTemplate(template);
      this.setState({
        alert: true,
        alertMsg: "Direct API disable successfully!",
        alertSeverity: "success",
      });
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.messsage ||
        "Something went wrong. Cannot migrate this Partner project to AiSensy!";
      this.setState({
        alert: true,
        alertMsg: message,
        alertSeverity: "error",
      });
    }
  };

  handleDrawerOpen = async () => {
    this.setState({ isDrawerOpen: true });
  };
  handleDrawerClose = () => {
    this.setState({ isDrawerOpen: false });
  };

  fetchShopifyLogs = async (assistantId) => {
    try {
      const response = await axios.post(
        `${URL}/superadmin/latest-shopify-jobs`,
        { _id: assistantId }
      );
      if (response.status === 200 && response.data.length > 0) {
        this.setState({ shopifyLogs: response.data, isEcomDrawerOpen: true });
      } else {
        this.setState({ shopifyLogs: [], isEcomDrawerOpen: true });
      }
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg: "Failed",
        alertSeverity: "error",
        shopifyLogs: [],
        isEcomDrawerOpen: true,
      });
    }
  };

  fetchWooCommerceLogs = async (assistantId) => {
    try {
      const response = await axios.post(
        `${URL}/superadmin/latest-woocommerce-logs`,
        { assistantId }
      );
      if (
        response.status === 200 &&
        (response.data.WooComOrderEvents.length > 0 ||
          response.data.WooComAbandonedEvents.length > 0)
      ) {
        this.setState({
          wooCommerceLogs: response.data,
          isEcomDrawerOpen: true,
        });
      } else {
        this.setState({
          wooCommerceLogs: { WooComOrderEvents: [], WooComAbandonedEvents: [] },
          isEcomDrawerOpen: true,
        });
      }
    } catch (error) {
      this.setState({
        wooCommerceLogs: { WooComOrderEvents: [], WooComAbandonedEvents: [] },
        isEcomDrawerOpen: true,
        alert: true,
        alertMsg: "Failed",
        alertSeverity: "error",
      });
    }
  };

  // handleToggleCollapse = (index) => {
  //   this.setState((prevState) => ({
  //     expandedLogIndex: prevState.expandedLogIndex === index ? null : index,
  //   }));
  // };

  handleToggleCollapse = (index, type) => {
    this.setState((prevState) => ({
      [type]: prevState[type] === index ? null : index,
    }));
  };

  handleWooCommerceTabChange = (event, newValue) => {
    this.setState({ selectedWooCommerceTab: newValue });
  };

  handleEcomDrawerOpen = async (template) => {
    try {
      if (template.ecomAppStore === "shopify") {
        await this.fetchShopifyLogs(template._id);
      } else if (template.ecomAppStore === "woocommerce") {
        await this.fetchWooCommerceLogs(template._id);
      }
    } catch (error) {
      console.error("Error opening e-commerce drawer:", error);
    }
  };

  handleEcomDrawerClose = () => {
    this.setState({ isEcomDrawerOpen: false });
  };

  enableDirectApi = async (mode) => {
    try {
      const { username, password } = this.state.directApiCredentials;
      if (mode === "token" && (!username || !password)) {
        this.setState({
          alert: true,
          alertMsg:
            "Please enter username and password both if you want to generate tokens",
          alertSeverity: "error",
        });
        return;
      }

      const { data } = await axios.post(
        `${URL}/superadmin/enable-direct-apis`,
        {
          username,
          password,
          projectId: this.props.templates[this.props.templateIndex]._id,
        }
      );
      let template = this.props.templates[this.props.templateIndex];

      template.directApikey = data.accessToken;
      this.props.setTemplate(template);
      this.setState({
        alert: true,
        alertMsg: "Direct API enabled successfully!",
        alertSeverity: "success",
        directApiCredentials: { ...this.state.directApiCredentials, ...data },
      });
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.messsage ||
        "Something went wrong. Cannot migrate this Partner project to AiSensy!";
      this.setState({
        alert: true,
        alertMsg: message,
        alertSeverity: "error",
      });
    }
  };

  // Suites, envelope version and skew bounds come from the backend registry so
  // this UI can never offer something the API will reject.
  loadEncryptionCapabilities = async () => {
    try {
      const { data } = await axios.get(
        `${URL}/superadmin/project-message-encryption/capabilities`
      );
      this.setState((prev) => ({
        messageEncryption: {
          ...prev.messageEncryption,
          capabilities: data,
          skewSeconds: data?.skew?.default || prev.messageEncryption.skewSeconds,
        },
      }));
    } catch (error) {
      // Non-fatal: the selects fall back to the built-in list below.
      console.log("Failed to load encryption capabilities", error);
    }
  };

  // Algorithms available for a mode. Prefers the backend registry, falling back
  // to the legacy list if capabilities have not loaded.
  encryptionAlgorithmsFor = (encryptionType) => {
    const { capabilities } = this.state.messageEncryption;
    if (capabilities?.algorithms?.length) {
      return capabilities.algorithms
        .filter((a) => a.modes.includes(encryptionType))
        .map((a) => a.algorithm);
    }
    return encryptionType === "body"
      ? ["aes-128-cbc", "aes-192-cbc", "aes-256-cbc", "aes-128-gcm", "aes-192-gcm", "aes-256-gcm"]
      : ["aes-128-cbc", "aes-192-cbc", "aes-256-cbc", "aes-128-ecb", "aes-192-ecb", "aes-256-ecb"];
  };

  loadMessageEncryptionConfig = async () => {
    try {
      const assistantId =
        this.props.templates[this.props.templateIndex]._id;
      const { data } = await axios.get(
        `${URL}/superadmin/project-message-encryption/${assistantId}`
      );
      const existingEncryptionType = data.encryptionType || "number";
      this.setState({
        messageEncryption: {
          ...this.state.messageEncryption,
          exists: true,
          docId: data.docId,
          existingAlgorithm: data.algorithm,
          existingEncryptionType,
          // Reflect the saved config so the panel below describes what is live.
          encryptionType: existingEncryptionType,
          algorithm: data.algorithm,
          // Must be seeded from the saved config: rotate posts this value back,
          // so leaving the form default here would silently reset a customer's
          // replay window on every rotation.
          skewSeconds:
            data.skewSeconds || this.state.messageEncryption.skewSeconds,
        },
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        this.setState({
          messageEncryption: {
            ...this.state.messageEncryption,
            exists: false,
            docId: null,
            existingAlgorithm: null,
            existingEncryptionType: null,
          },
        });
      }
    }
  };

  /**
   * The create/rotate response also carries suite descriptors (suite, algByte,
   * keyBytes, tagBytes, padding, needsHkdf, …). Those are all derivable from
   * `algorithm`, so they are noise in a panel whose only job is a secure
   * handoff. Keep what the customer cannot work out for themselves.
   */
  encryptionHandoff = (data) => {
    if (!data) return data;
    const out = {
      docId: data.docId,
      encryptionType: data.encryptionType,
      algorithm: data.algorithm,
      secret: data.secret,
    };
    // Number mode ships a stored IV; body mode does not have one.
    if (data.iv) out.iv = data.iv;
    // A body-mode integration must keep its clock inside this window.
    if (data.encryptionType === "body" && data.skewSeconds) {
      out.skewSeconds = data.skewSeconds;
    }
    return out;
  };

  // Body mode never sends an IV: the client generates a fresh one per request
  // and ships it inside the envelope. Sending a stored IV would reintroduce the
  // deterministic-ciphertext weakness the per-request IV exists to remove.
  buildEncryptionRequestBody = (assistantId) => {
    const {
      encryptionType,
      algorithm,
      mode,
      inputFormat,
      secret,
      iv,
      skewSeconds,
    } = this.state.messageEncryption;

    const body = { assistantId, algorithm, encryptionType };
    if (encryptionType === "body") body.skewSeconds = Number(skewSeconds);

    if (mode === "random") {
      body.generateRandom = true;
    } else {
      body.secret = secret;
      body.inputFormat = inputFormat;
      if (encryptionType !== "body" && !algorithm.endsWith("-ecb")) {
        body.iv = iv;
      }
    }
    return body;
  };

  saveMessageEncryption = async () => {
    try {
      const assistantId =
        this.props.templates[this.props.templateIndex]._id;
      const body = this.buildEncryptionRequestBody(assistantId);
      const { data } = await axios.post(
        `${URL}/superadmin/project-message-encryption/create`,
        body
      );
      this.setState({
        alert: true,
        alertMsg: "Encryption config saved",
        alertSeverity: "success",
        messageEncryption: {
          ...this.state.messageEncryption,
          exists: true,
          docId: data.docId,
          existingAlgorithm: data.algorithm,
          existingEncryptionType: data.encryptionType || "number",
          lastGenerated: data,
          secret: "",
          iv: "",
        },
      });
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg:
          error.response?.data?.message ||
          error.message ||
          "Failed to save encryption config",
        alertSeverity: "error",
      });
    }
  };

  rotateMessageEncryption = async () => {
    // Rotation is a hard cutover: the replacement config gets a new docId, so the
    // customer's current key stops working the instant this succeeds.
    if (
      !window.confirm(
        "Rotate now?\n\nThis immediately invalidates the customer's current key and docId. Every request they send will fail until they deploy the new values.\n\nRotation needs a coordinated deploy window with the customer."
      )
    ) {
      return;
    }
    try {
      const assistantId =
        this.props.templates[this.props.templateIndex]._id;
      const body = this.buildEncryptionRequestBody(assistantId);
      const { data } = await axios.post(
        `${URL}/superadmin/project-message-encryption/rotate`,
        body
      );
      this.setState({
        alert: true,
        alertMsg: "Encryption config rotated",
        alertSeverity: "success",
        messageEncryption: {
          ...this.state.messageEncryption,
          exists: true,
          docId: data.docId,
          existingAlgorithm: data.algorithm,
          existingEncryptionType: data.encryptionType || "number",
          lastGenerated: data,
          secret: "",
          iv: "",
        },
      });
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg:
          error.response?.data?.message ||
          error.message ||
          "Failed to rotate encryption config",
        alertSeverity: "error",
      });
    }
  };

  deleteMessageEncryption = async () => {
    if (
      !window.confirm(
        "This will break customer integrations using this docId. Continue?"
      )
    ) {
      return;
    }
    try {
      const assistantId =
        this.props.templates[this.props.templateIndex]._id;
      await axios.delete(
        `${URL}/superadmin/project-message-encryption/${assistantId}`
      );
      this.setState({
        alert: true,
        alertMsg: "Encryption config deleted",
        alertSeverity: "success",
        messageEncryption: {
          ...this.state.messageEncryption,
          encryptionType: "number",
          algorithm: "aes-256-cbc",
          mode: "random",
          inputFormat: "hex",
          secret: "",
          iv: "",
          showAdvanced: false,
          exists: false,
          docId: null,
          existingAlgorithm: null,
          existingEncryptionType: null,
          lastGenerated: null,
        },
      });
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg:
          error.response?.data?.message ||
          error.message ||
          "Failed to delete encryption config",
        alertSeverity: "error",
      });
    }
  };

  loadCustomWebhookConfig = async () => {
    try {
      const assistantId = this.props.templates[this.props.templateIndex]._id;
      const { data } = await axios.get(
        `${URL}/superadmin/custom-webhook-config/${assistantId}`
      );
      this.setState({
        customWebhookConfig: {
          ...this.state.customWebhookConfig,
          exists: !!data.configured,
          url: data.url || "",
          url_input: "",
          clientId: "",
          apiKey: "",
          rotateMode: false,
        },
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        this.setState({
          customWebhookConfig: {
            ...this.state.customWebhookConfig,
            exists: false,
            url: "",
            url_input: "",
            clientId: "",
            apiKey: "",
            rotateMode: false,
          },
        });
      }
    }
  };

  saveCustomWebhookConfig = async () => {
    const { url_input, clientId, apiKey } = this.state.customWebhookConfig;
    if (
      !url_input ||
      !/^https?:\/\//i.test(url_input) ||
      !clientId ||
      !apiKey
    ) {
      this.setState({
        alert: true,
        alertMsg: "URL (http/https), Client ID, and API Key are required",
        alertSeverity: "error",
      });
      return;
    }
    try {
      const assistantId = this.props.templates[this.props.templateIndex]._id;
      const { data } = await axios.post(
        `${URL}/superadmin/custom-webhook-config/create`,
        { assistantId, url: url_input, clientId, apiKey }
      );
      this.setState({
        alert: true,
        alertMsg: "Custom webhook config saved",
        alertSeverity: "success",
        customWebhookConfig: {
          exists: true,
          url: data.url,
          url_input: "",
          clientId: "",
          apiKey: "",
          rotateMode: false,
        },
      });
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg:
          error.response?.data?.message ||
          error.message ||
          "Failed to save custom webhook config",
        alertSeverity: "error",
      });
    }
  };

  rotateCustomWebhookConfig = async () => {
    if (
      !window.confirm(
        "Rotating will replace the current credentials. Continue?"
      )
    ) {
      return;
    }
    const { url_input, clientId, apiKey } = this.state.customWebhookConfig;
    if (
      !url_input ||
      !/^https?:\/\//i.test(url_input) ||
      !clientId ||
      !apiKey
    ) {
      this.setState({
        alert: true,
        alertMsg: "URL (http/https), Client ID, and API Key are required",
        alertSeverity: "error",
      });
      return;
    }
    try {
      const assistantId = this.props.templates[this.props.templateIndex]._id;
      const { data } = await axios.post(
        `${URL}/superadmin/custom-webhook-config/rotate`,
        { assistantId, url: url_input, clientId, apiKey }
      );
      this.setState({
        alert: true,
        alertMsg: "Custom webhook config rotated",
        alertSeverity: "success",
        customWebhookConfig: {
          exists: true,
          url: data.url,
          url_input: "",
          clientId: "",
          apiKey: "",
          rotateMode: false,
        },
      });
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg:
          error.response?.data?.message ||
          error.message ||
          "Failed to rotate custom webhook config",
        alertSeverity: "error",
      });
    }
  };

  deleteCustomWebhookConfig = async () => {
    if (
      !window.confirm(
        "This will disable the custom webhook integration for this assistant. Continue?"
      )
    ) {
      return;
    }
    try {
      const assistantId = this.props.templates[this.props.templateIndex]._id;
      await axios.delete(
        `${URL}/superadmin/custom-webhook-config/${assistantId}`
      );
      this.setState({
        alert: true,
        alertMsg: "Custom webhook config deleted",
        alertSeverity: "success",
        customWebhookConfig: {
          exists: false,
          url: "",
          url_input: "",
          clientId: "",
          apiKey: "",
          rotateMode: false,
        },
      });
    } catch (error) {
      this.setState({
        alert: true,
        alertMsg:
          error.response?.data?.message ||
          error.message ||
          "Failed to delete custom webhook config",
        alertSeverity: "error",
      });
    }
  };

  verifyJSON = (value) => {
    let vl = null;
    try {
      vl = JSON.parse(value);
    } catch (error) {
      vl = null;
    }

    return vl;
  };

  updatePaymentSlabs = () => {
    const { whatsappPaySlabs } = this.state || {};

    const vl = this.verifyJSON(whatsappPaySlabs);
    if (vl) {
      this.updateWhatsappPayDetails("paymentSlabs", vl);
    }
  };

  openChargebee = () => {
    const assistantId = this.props.templates[this.props.templateIndex]._id;
    const clientId = this.props.templates[this.props.templateIndex].clientId;

    const ChargebeeId = clientId + "_" + assistantId;

    window.open(`${CHARGEBEE_REDIRECT_URL}/${ChargebeeId}`, "_blank");
  };

  getReport = () => {
    const startDate = this.state.applied["createdAt"].startDate;
    const endDate = this.state.applied["createdAt"].endDate;
    const { templateIndex, templates } = this.props;
    const template = templates[templateIndex];
    const currency = template?.currency;
    const assistantId = template._id;
    const name = template.assistantName;

    axios
      .post(
        `${URL}/superadmin/view-super-admin-logs`,
        { assistantId, startDate, endDate },
        { responseType: "stream" }
      )

      .then((res) => {
        const newLogs = res.data.filter(
          (log) => log?.body?.fields?.templateCredit
        );

        const headers = {
          templateCredit: "Recharge Amount",
          paymentRemarks: "Remarks",
          displayName: "Added By",
          createdAt: "Date",
        };

        const items = [...newLogs];
        const replacer = (key, value) => (value === null ? "" : value);
        const header = Object.keys(headers);
        let csv = items.map((row) =>
          header
            .map((fieldName) => {
              let value = row?.body?.fields[fieldName]
                ? row.body.fields[fieldName]
                : row[fieldName]
                  ? row[fieldName]
                  : null;
              if (fieldName === "createdAt") {
                value = value
                  ? new Date(value).toLocaleDateString([], {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                  })
                  : null;
              }

              if (fieldName === "templateCredit") {
                value = value
                  ? `${currency} ${(value / 100000).toFixed(2)}`
                  : null;
              }

              return JSON.stringify(value, replacer);
            })
            .join(",")
        );
        csv.unshift(Object.values(headers).join(","));
        csv = csv.join("\r\n");

        //Download the file as CSV
        var downloadLink = document.createElement("a");
        const blob = new Blob([csv], { type: "text/csv" });
        var url = window.URL.createObjectURL(blob);
        downloadLink.href = url;

        let filename = name
          ? `${name}_template_credit_report`
          : "template_credit_report";

        if (startDate && endDate) {
          const formattedStartDate = new Date(startDate).toLocaleDateString(
            "en-GB"
          );
          const formattedEndDate = new Date(endDate).toLocaleDateString(
            "en-GB"
          );
          filename += `_${formattedStartDate}_to_${formattedEndDate}`;
        }

        downloadLink.download = filename;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        this.setState({
          alert: true,
          alertMsg: "Report downloaded successfully!",
          alertSeverity: "success",
        });
      })

      .catch((error) => {
        const message =
          error.response?.data?.message ||
          error.messsage ||
          "Unable to download the report :(";
        this.setState({
          alert: true,
          alertMsg: message,
          alertSeverity: "error",
        });
      });
  };

  clearDate = (filterKey = "createdAt") => {
    const applied = { ...this.state.applied };
    applied[filterKey].startDate = null;
    applied[filterKey].endDate = null;
    this.setState({ applied });
  };

  checkDateInput = (filterKey) => {
    const applied = { ...this.state.applied };
    const s = applied[filterKey];
    if (s.startDate && s.endDate) {
      return;
    } else {
      this.clearDate(filterKey);
    }
  };

  setFocus = (filterKey, focusedInput) => {
    const applied = { ...this.state.applied };
    applied[filterKey].focusedInput = focusedInput;
    this.setState({ applied });
  };

  setDate = (filterKey, startDate, endDate) => {
    const applied = { ...this.state.applied };
    applied[filterKey].startDate = startDate;
    applied[filterKey].endDate = endDate;
    this.setState({ applied });
  };

  onBvbpHandler = async (data) => {
    this.setState({ businessId: data.get("end_business_id") });
    const assistantId = this.props.templates[this.props.templateIndex]?._id;

    axios
      .post(`${URL}/superadmin/bvbp-apply`, data, {
        params: { assistantId },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            alert: true,
            alertMsg: bvbpSuccessMessage(response.data),
            alertSeverity: "success",
          });
          this.getApplicationStatusHandler();
          this.toggleBvbpDialog();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({
          alert: true,
          alertMsg: bvbpErrorMessage(error),
          alertSeverity: "error",
        });
      });
  };

  getApplicationStatusHandler = () => {
    const payload = {
      end_business_id: this.state.businessId,
    };
    if (this.state.businessId) {
      axios
        .get(`${URL}/superadmin/get-bvbp-status`, {
          params: payload,
        })
        .then((response) => {
          const lastAttempt = response.data?.data?.length;
          if (lastAttempt === 0) {
            this.setState({
              verificationStatus: "Not submitted Yet",
            });
          } else {
            const latestStatus = response.data.data.reduce((latest, record) => {
              return new Date(latest.update_time) > new Date(record.update_time)
                ? latest
                : record;
            });

            this.setState({
              verificationStatus: latestStatus.verification_status,
              rejectionReasons: latestStatus.rejection_reasons,
              bvbpCount: lastAttempt,
              bvbpApplicationResponse: response.data.data,
            });
          }
        })
        .catch((error) => {
          console.error("Error", error);
          this.setState({
            verificationStatus: "",
            alert: true,
            alertMsg: `${error.response.status == 400 ? "Bad Request" : error.message
              }`,
            alertSeverity: "error",
          });
        });
    }
  };

  enableBirthdayCampaign = () => {
    let obj = null;
    if (this.state.connectFlowsEnabled)
      obj = {
        enableConnectFlows: true,
      };
    this.setTemplateInDb({
      specialAccess: {
        ...obj,
        enableBirthdayCampaign: !this.state.birthdayCampaignEnabled,
      },
    });
    this.setState({
      birthdayCampaignEnabled: !this.state.birthdayCampaignEnabled,
      alert: true,
      alertMsg: "Birthday campaign status updated!",
      alertSeverity: "success",
    });
  };

  enableConnectFlows = () => {
    let obj = null;
    if (this.state.birthdayCampaignEnabled)
      obj = {
        enableBirthdayCampaign: true,
      };
    this.setTemplateInDb({
      specialAccess: {
        ...obj,
        enableConnectFlows: !this.state.connectFlowsEnabled,
      },
    });
    this.setState({
      connectFlowsEnabled: !this.state.connectFlowsEnabled,
      alert: true,
      alertMsg: "Connect Flows status updated!",
      alertSeverity: "success",
    });
  };

  togglePreVerifiedAccess = () => {
    const assistant = this.props.templates[this.props.templateIndex];
    const virtualNumberConfig = assistant.virtualNumberConfig || {};
    this.setTemplateInDb({
      virtualNumberConfig: {
        ...virtualNumberConfig,
        showPreVerified: !virtualNumberConfig.showPreVerified,
      },
    });
    this.setState({
      alert: true,
      alertMsg: "Updated!",
      alertSeverity: "success",
    });
  };

  handleTabs = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  handleFlowTransfer = async (deletePreviousFlow) => {
    const assistant = this.props.templates[this.props.templateIndex];
    const assistantId = assistant._id;
    const clientId = assistant.clientId;

    await axios
      .post(URL + "/superadmin/flow_transfer", {
        flowId: this.state.transferFlowId,
        assistantId,
        deletePreviousFlow,
        clientId,
      })
      .then((response) => {
        this.setState({
          alert: true,
          alertMsg: deletePreviousFlow
            ? "Flow transferred successfully!"
            : "Flow copied successfully",
          alertSeverity: "success",
          transferFlowId: "",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg:
            error.message || error.errorMessage || "Something Went Wrong!",
          alertSeverity: "error",
        });
      });
  };

  handleFlowTransferId = (event) => {
    this.setState({ transferFlowId: event.target.value });
  };

  handleDelayEnabled = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      flowConfiguration: {
        ...template.flowConfiguration,
        delayEnabled: checked,
      },
    })
      .then((response) => {
        template.flowConfiguration = {
          ...template.flowConfiguration,
          delayEnabled: checked,
        };
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: checked ? "Delay enabled" : "Delay disabled",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to enable delay!",
          alertSeverity: "error",
        });
      });
  };

  handleNonMultiAisensyAds = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      flowConfiguration: {
        ...template.flowConfiguration,
        multiNonAisensyAds: checked,
      },
    })
      .then((response) => {
        template.flowConfiguration = {
          ...template.flowConfiguration,
          multiNonAisensyAds: checked,
        };
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Multi Non Aisensy Ads successfully updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update multi non aisensy ads!",
          alertSeverity: "error",
        });
      });
  };

  handleSkipDefaultOrderFlow = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      flowConfiguration: {
        ...template.flowConfiguration,
        skipDefaultOrderFlow: checked,
      },
    })
      .then((response) => {
        template.flowConfiguration = {
          ...template.flowConfiguration,
          skipDefaultOrderFlow: checked,
        };
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: checked
            ? "Shopify default link disabled"
            : "Shopify default link enabled",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update Shopify default link!",
          alertSeverity: "error",
        });
      });
  };

  handleTimeoutEnabled = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      flowConfiguration: {
        ...template.flowConfiguration,
        timeoutEnabled: checked,
      },
    })
      .then((response) => {
        template.flowConfiguration = {
          ...template.flowConfiguration,
          timeoutEnabled: checked,
        };
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "Timeout successfully updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to update timeout!",
          alertSeverity: "error",
        });
      });
  };

  handleIsTrialClaimed = (e) => {
    let template = this.props.templates[this.props.templateIndex];
    const checked = e.target.checked;

    this.setTemplateInDb({
      flowConfiguration: {
        ...template.flowConfiguration,
        isTrialClaimed: checked,
      },
    })
      .then((response) => {
        template.flowConfiguration = {
          ...template.flowConfiguration,
          isTrialClaimed: checked,
        };
        this.props.setTemplate(template);
        this.setState({
          alert: true,
          alertMsg: "trial successfully updated!",
          alertSeverity: "success",
        });
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertMsg: "Unable to claim trial!",
          alertSeverity: "error",
        });
      });
  };

  render() {
    const {
      classes,
      toggleDialog,
      templateIndex,
      templates,
      tenantDetails,
      permissions,
    } = this.props;
    const {
      tabValue,
      shopifyLogs,
      isEcomDrawerOpen,
      expandedLogIndex,
      wooCommerceLogs,
      expandedWooCommerceLogIndex,
      selectedWooCommerceTab,
      open,
      selectedIndex,
    } = this.state;

    const template = templates[templateIndex];
    const currency = template?.currency;
    let isTenant = !!Object.keys(tenantDetails).length;

    const displayActivePlan =
      template.planDuration < 28 && template.activePlan === "PRO_MONTHLY"
        ? "TRIAL"
        : template.activePlan;

    const assistantPermissions = permissions?.find(
      (p) => p.label === "assistants"
    );
    const subRoutes = assistantPermissions?.subroutes;
    const hasWriteAccess = assistantPermissions?.write;
    // MSG-606: "full", "readOnly" or null — login wins over readOnlyLogin.
    const ownerLogin = ownerLoginMode(assistantPermissions);
    const hasLoginAccess = Boolean(ownerLogin);
    const hasViewLogsAccess =
      assistantPermissions?.actions?.includes("viewLogs");
    console.log("here", subRoutes?.find(
      (p) => p.label === "fbManager"
    ))
    const hasAssignAssetAccess = subRoutes?.find(
      (p) => p.label === "fbManager"
    )?.actions?.includes("assignAsset")

    const tabConfigs = [
      {
        label: "Waba",
        key: "waba",
        render: () => {
          const hasWriteAccess = verifySubRouteAccess(
            subRoutes,
            "waba",
            "write"
          );
          return (
            <Box py={2} px={2} my={2} className={classes.outerContainer}>
              <Box
                py={2}
                px={2}
                my={2}
                className={classes.container}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Typography variant="h5">
                  <b>Project ID :</b> {templates[templateIndex]._id}
                </Typography>
                <IconButton
                  onClick={() => {
                    navigator.clipboard.writeText(templates[templateIndex]._id);
                    this.setState({
                      alert: true,
                      alertMsg: "Project ID copied successfully",
                      alertSeverity: "success",
                    });
                  }}
                  size="small"
                  style={{
                    marginLeft: 8,
                    backgroundColor: "#d6d6d6",
                  }}
                >
                  <FileCopyIcon
                    style={{
                      fontSize: "15px",
                    }}
                  />
                </IconButton>
                <Typography variant="h5" style={{ marginLeft: 24 }}>
                  <b>Client ID :</b> {template.clientId}
                </Typography>
                <IconButton
                  onClick={() => {
                    navigator.clipboard.writeText(template.clientId);
                    this.setState({
                      alert: true,
                      alertMsg: "Client ID copied successfully",
                      alertSeverity: "success",
                    });
                  }}
                  size="small"
                  style={{
                    marginLeft: 8,
                    backgroundColor: "#d6d6d6",
                  }}
                >
                  <FileCopyIcon
                    style={{
                      fontSize: "15px",
                    }}
                  />
                </IconButton>
                {template.wabaAppId && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<OpenInNew style={{ fontSize: 14 }} />}
                    onClick={() => {
                      window.open(
                        `https://business.facebook.com/latest/whatsapp_manager/overview/?asset_id=${template.wabaAppId}`,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                    style={{
                      marginLeft: 16,
                      textTransform: "none",
                      padding: "4px 10px",
                      fontSize: 13,
                      lineHeight: 1.5,
                    }}
                  >
                    WABA Manager
                  </Button>
                )}
              </Box>
              <fieldset
                disabled={!hasWriteAccess}
                style={{ border: "none", padding: 0, margin: 0 }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Box px={2} className={classes.container}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        WhatsApp Verification Status
                      </Typography>
                      <Box my={2}>
                        <Switch
                          checked={template.isWhatsappVerified}
                          onChange={this.updateVerificationStatus}
                          name="checkedA"
                          inputProps={{
                            "aria-label": "secondary checkbox",
                          }}
                        />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{
                        marginLeft: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      Coexistence :
                    </Typography>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{
                        marginLeft: "16px",
                        fontWeight: "bold",
                        color: template?.coexistence?.activatedOn
                          ? "green"
                          : "grey",
                      }}
                    >
                      {`${template?.coexistence?.activatedOn ? "True" : "False"
                        }`}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{
                        marginLeft: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      MM Lite Enabled :
                    </Typography>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{
                        marginLeft: "16px",
                        fontWeight: "bold",
                        color: template?.mmLiteConfig?.enabled
                          ? "green"
                          : "grey",
                      }}
                    >
                      {`${template?.mmLiteConfig?.enabled ? "True" : "False"}`}
                    </Typography>
                  </Grid>
                  {template?.wabaProgressStep === 9 &&
                    !this.state.wabaInfoLoading &&
                    !this.state.fbmInfoLoading && (
                      <>
                        {(!this.state.wabaInfo?.length ||
                          (template?.wabaAppStatus?.waba_ban_state !==
                            "DISABLE" &&
                            template?.wabaDeleted === false)) && (
                            <>
                              {(!this.state.wabaInfo?.length ||
                                template?.wabaAppStatus?.waba_ban_state ===
                                "DISABLE") && (
                                  <Grid item xs={4}>
                                    <Typography
                                      variant="body1"
                                      gutterBottom
                                      style={{
                                        marginLeft: "16px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      WABA App Status:
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      gutterBottom
                                      style={{
                                        marginLeft: "16px",
                                        fontWeight: "bold",
                                        color: "red",
                                      }}
                                    >
                                      Disabled
                                    </Typography>
                                  </Grid>
                                )}
                              {(!this.state.FBMInfo?.name ||
                                template?.wabaDeleted === true) && (
                                  <Grid item xs={4}>
                                    <Typography
                                      variant="body1"
                                      gutterBottom
                                      style={{
                                        marginLeft: "16px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      WABA Deleted:
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      gutterBottom
                                      style={{
                                        marginLeft: "16px",
                                        fontWeight: "bold",
                                        color: "red",
                                      }}
                                    >
                                      True
                                    </Typography>
                                  </Grid>
                                )}
                            </>
                          )}
                      </>
                    )}
                </Grid>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Send test message to check API verification
                  </Typography>
                  {/* <Typography variant="body1" gutterBottom>
            Tag Limit - {template.tagLimit}
          </Typography> */}
                  <Grid container>
                    <Grid item xs={3} alignItems="center">
                      <TextField
                        type="number"
                        placeholder="Enter Tag Limit"
                        name="testNumber"
                        onChange={this.handleChange}
                        value={this.state.testNumber}
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 10,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.testAPINumber}
                        >
                          Test API Verification
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update WABA Number ID
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <pre>wabaNumberId - {template.wabaNumberId}</pre>
                  </Typography>
                  <Grid container>
                    <Grid item xs={3} alignItems="center">
                      <TextField
                        placeholder="Enter wabaNumberId"
                        name="wabaNumberId"
                        onChange={this.handleChange}
                        value={this.state.wabaNumberId}
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 10,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateWabaNumberId}
                        >
                          Update wabaNumberId
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update WABA App ID
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <pre>wabaAppId - {template.wabaAppId}</pre>
                  </Typography>
                  <Grid container>
                    <Grid item xs={3} alignItems="center">
                      <TextField
                        placeholder="Enter wabaAppId"
                        name="wabaAppId"
                        onChange={this.handleChange}
                        value={this.state.wabaAppId}
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 10,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateWabaAppId}
                        >
                          Update wabaAppId
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update WABA progress step
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Current Step -{" "}
                    {template.wabaProgressStep
                      ? template.wabaProgressStep
                      : null}
                  </Typography>
                  <Grid container>
                    <Grid item xs={3} alignItems="center">
                      <TextField
                        type="number"
                        placeholder="Enter step"
                        name="wabaProgressStep"
                        onChange={this.handleChange}
                        value={this.state.wabaProgressStep}
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 10,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateWabaStep}
                        >
                          Update WABA Step
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    form to re-register
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <pre>WABA PIN - {template.wabaPin}</pre>
                  </Typography>
                  <Grid container>
                    <Grid item>
                      <TextField
                        placeholder="enter pin"
                        name="pin"
                        onChange={this.handleChange}
                        value={this.state.pin}
                        style={{
                          padding: "8px 20px",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 3,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <>
                          <Button
                            style={{ marginRight: 3, marginLeft: 3 }}
                            color="primary"
                            variant="contained"
                            onClick={this.registerWithPin}
                          >
                            Register
                          </Button>

                          {this.state.errorCurl?.event === "register" && (
                            <Button
                              style={{ marginRight: 3, marginLeft: 3 }}
                              color="primary"
                              variant="contained"
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  this.state.errorCurl?.curl
                                );
                                this.setState({
                                  alert: true,
                                  alertMsg: "cURL copied successfully",
                                  alertSeverity: "success",
                                });
                              }}
                            >
                              Copy cURL
                            </Button>
                          )}
                        </>
                      </Typography>
                    </Grid>
                    <Grid item xs={3} alignItems="center">
                      <Autocomplete
                        disableClearable
                        value={this.state.mode}
                        options={["SMS", "VOICE"]}
                        onChange={(e, value, reason) =>
                          this.setState({
                            mode: value,
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{
                              padding: "8px 20px",
                              border: "1px solid ",
                              background: "white",
                              marginRight: 3,
                              marginLeft: 5,
                            }}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Verification Mode"
                            name="Verification Mode"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Tooltip
                          title="Whatsapp is not verified"
                          disableHoverListener={template.isWhatsappVerified}
                        >
                          <span>
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={this.triggerOtp}
                              style={{ marginLeft: 10 }}
                              disabled={!template.isWhatsappVerified}
                            >
                              Trigger OTP
                            </Button>
                          </span>
                        </Tooltip>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    form to verify
                  </Typography>
                  <Grid container>
                    <Grid item>
                      <TextField
                        placeholder="enter code"
                        name="verifyCode"
                        onChange={this.handleChange}
                        value={this.state.verifyCode}
                        style={{
                          padding: "8px 20px",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 3,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Tooltip
                          title="WhatsApp is not verified"
                          disableHoverListener={template.isWhatsappVerified}
                        >
                          <span>
                            <Button
                              style={{ marginRight: 3, marginLeft: 3 }}
                              color="primary"
                              variant="contained"
                              onClick={this.verifyCode}
                              disabled={!template.isWhatsappVerified}
                            >
                              Verify
                            </Button>
                          </span>
                        </Tooltip>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    WABA Information
                  </Typography>
                  <Grid
                    container
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <Typography
                      variant="h5"
                      gutterBottom
                      style={{ fontWeight: "600", marginBottom: "10px" }}
                    >
                      <>
                        App id -{" "}
                        {this.props.templates[this.props.templateIndex]
                          ?.wabaAppId || ""}
                      </>
                    </Typography>
                    {this.state.wabaInfo?.map((waba, i) => (
                      <>
                        <Grid item md={12} xs={12} className={classes.wabaInfo}>
                          <Typography
                            variant="h5"
                            gutterBottom
                            style={{
                              fontWeight: "600",
                              marginBottom: "10px",
                            }}
                          >
                            {`Account ${i + 1}`}
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            <>Display name - {waba?.displayName || ""}</>
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            <>
                              Display name status -{" "}
                              {waba?.displayNameStatus || ""}
                            </>
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            Phone number - {waba?.phoneNumber || ""}
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            Waba number id - {waba?.id || ""}
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            Messaging Limit - {waba?.messagingLimit || ""}
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            <>Account status - {waba?.status || ""}</>
                          </Typography>

                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            <>
                              Quality rating -{" "}
                              {waba?.qualityRating
                                ? `${["Low", "FLAGGED", "RED"].includes(
                                  waba?.qualityRating
                                )
                                  ? "Low"
                                  : [
                                    "UNFLAGGED",
                                    "Medium",
                                    "RESTRICTED",
                                    "YELLOW",
                                  ].includes(waba?.qualityRating)
                                    ? "Medium"
                                    : "High"
                                }`
                                : ""}
                            </>
                          </Typography>
                        </Grid>
                      </>
                    ))}{" "}
                  </Grid>
                </Box>
              </fieldset>
            </Box>
          );
        },
      },
      {
        label: "FB Manager",
        key: "fbManager",
        render: () => {
          const hasWriteAccess = verifySubRouteAccess(
            subRoutes,
            "fbManager",
            "write"
          );
          return (
            <Box py={2} px={2} my={2} className={classes.outerContainer}>
              <fieldset
                disabled={!hasWriteAccess}
                style={{ border: "none", padding: 0, margin: 0 }}
              >
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Facebook Business Manager Information
                  </Typography>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontSize: "14px" }}
                  >
                    <>Name - {this.state.FBMInfo?.name || ""}</>
                  </Typography>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontSize: "14px" }}
                  >
                    <>Status - {this.state.FBMInfo?.status || ""}</>
                  </Typography>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontSize: "14px" }}
                  >
                    <>Credit Line - {this.state.creditLineInfo || ""}</>
                  </Typography>
                </Box>

                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    WABA Maintenance
                  </Typography>

                  {this.isPartnerOwnedProject() &&
                  !isGlobalAdmin(this.props.agent?.permissions) ? (
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ color: "#b26a00" }}
                    >
                      This project belongs to a partner
                      {" "}({template.partnerId}). Webhook re-subscribe and
                      credit line removal are disabled for partner-owned
                      projects.
                    </Typography>
                  ) : (
                    <>
                      {/* Full-access admins may act on a partner's WABA — the
                          backend applies the same exemption. Keep the ownership
                          visible so it stays a deliberate act, not a surprise. */}
                      {this.isPartnerOwnedProject() && (
                        <Typography
                          variant="body2"
                          gutterBottom
                          style={{ color: "#b26a00" }}
                        >
                          This project belongs to a partner
                          {" "}({template.partnerId}). These actions change the
                          partner's WABA — only proceed if the partner has asked
                          for it.
                        </Typography>
                      )}
                      <Typography
                        variant="body2"
                        gutterBottom
                        style={{ fontSize: "14px" }}
                      >
                        Re-subscribe the app to this WABA's webhooks
                        {isGlobalAdmin(this.props.agent?.permissions)
                          ? ", or revoke the BSP credit line shared with this business."
                          : "."}
                      </Typography>

                      <Grid item xs={12} style={{ marginTop: "1rem" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={() =>
                              this.setState({ resubscribeWebhookDialog: true })
                            }
                            disabled={
                              !template?.wabaAppId ||
                              this.state.resubscribeWebhookLoading
                            }
                          >
                            Re-subscribe Webhook
                          </Button>

                          {/* Revoking a credit line is restricted to
                              full-access admins — the backend enforces the
                              same check on /remove-credit-line. */}
                          {isGlobalAdmin(this.props.agent?.permissions) && (
                            <Button
                              color="secondary"
                              variant="contained"
                              style={{ marginLeft: "1rem" }}
                              onClick={this.openRemoveCreditLineDialog}
                              disabled={this.state.removeCreditLineLoading}
                            >
                              Remove Credit Line
                            </Button>
                          )}

                          {(this.state.resubscribeWebhookLoading ||
                            this.state.removeCreditLineLoading) && (
                            <CircularProgress
                              size={24}
                              style={{ marginLeft: 16 }}
                            />
                          )}
                        </div>
                      </Grid>

                      <Dialog
                        open={this.state.resubscribeWebhookDialog}
                        onClose={() =>
                          this.setState({ resubscribeWebhookDialog: false })
                        }
                      >
                        <DialogTitle>Re-subscribe Webhook</DialogTitle>
                        <DialogContent>
                          <DialogContentText>
                            This checks whether the app is subscribed to WABA
                            {" "}{template?.wabaAppId} and subscribes it if it
                            is not. Continue?
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() =>
                              this.setState({ resubscribeWebhookDialog: false })
                            }
                            color="primary"
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={this.resubscribeWebhook}
                            color="primary"
                            autoFocus
                            disabled={this.state.resubscribeWebhookLoading}
                          >
                            {this.state.resubscribeWebhookLoading
                              ? "Subscribing..."
                              : "Confirm"}
                          </Button>
                        </DialogActions>
                      </Dialog>

                      <Dialog
                        open={this.state.removeCreditLineDialog}
                        onClose={() =>
                          this.setState({ removeCreditLineDialog: false })
                        }
                      >
                        <DialogTitle>Remove Credit Line</DialogTitle>
                        <DialogContent>
                          {this.state.creditLineAllocationLoading && (
                            <DialogContentText>
                              Fetching the credit line allocation...
                            </DialogContentText>
                          )}

                          {this.state.creditLineAllocationError && (
                            <DialogContentText style={{ color: "#c62828" }}>
                              {this.state.creditLineAllocationError}
                            </DialogContentText>
                          )}

                          {this.state.creditLineAllocation && (
                            <>
                              <DialogContentText component="div">
                                <div>
                                  Allocation ID -{" "}
                                  {this.state.creditLineAllocation.allocation?.id}
                                </div>
                                <div>
                                  Receiving Business -{" "}
                                  {
                                    this.state.creditLineAllocation.allocation
                                      ?.receiving_business?.name
                                  }{" "}
                                  (
                                  {
                                    this.state.creditLineAllocation.allocation
                                      ?.receiving_business?.id
                                  }
                                  )
                                </div>
                                <div>
                                  Request Status -{" "}
                                  {
                                    this.state.creditLineAllocation.allocation
                                      ?.request_status
                                  }
                                </div>
                              </DialogContentText>

                              {this.state.creditLineAllocation
                                .businessMatches ? (
                                <DialogContentText
                                  style={{ color: "#c62828", marginTop: 12 }}
                                >
                                  Verify the receiving business above. Revoking
                                  the credit line cannot be undone.
                                </DialogContentText>
                              ) : (
                                <DialogContentText
                                  style={{ color: "#c62828", marginTop: 12 }}
                                >
                                  This allocation belongs to a different
                                  business than the project
                                  {" "}({template?.fbBusinessId}). Removal is
                                  blocked.
                                </DialogContentText>
                              )}
                            </>
                          )}
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() =>
                              this.setState({ removeCreditLineDialog: false })
                            }
                            color="primary"
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={this.removeCreditLine}
                            color="secondary"
                            disabled={
                              this.state.removeCreditLineLoading ||
                              !this.state.creditLineAllocation
                                ?.businessMatches ||
                              this.state.creditLineAllocation?.allocation
                                ?.request_status === "DELETED"
                            }
                          >
                            {this.state.removeCreditLineLoading
                              ? "Removing..."
                              : "Remove Credit Line"}
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </>
                  )}
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update Messaging Tier Limit
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Messaging Tier Limit - {template.dailyTemplateLimit}
                  </Typography>
                  <Grid container>
                    <Grid item xs={5} alignItems="center">
                      <Autocomplete
                        value={this.state.messageLimit}
                        options={Tier_Limit.map((option) => option.name)}
                        onChange={(e, value, reason) =>
                          this.setState({
                            messageLimit: value,
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{
                              border: "1px solid ",
                              background: "white",
                              marginRight: 10,
                            }}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select Limit"
                            name="messageLimit"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateMessagingLimit}
                        >
                          Update Message Limit
                        </Button>
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.syncMessagingLimit}
                        >
                          Sync
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    WABA Information
                  </Typography>
                  <Grid
                    container
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <Typography
                      variant="h5"
                      gutterBottom
                      style={{ fontWeight: "600", marginBottom: "10px" }}
                    >
                      <>
                        App id -{" "}
                        {this.props.templates[this.props.templateIndex]
                          ?.wabaAppId || ""}
                      </>
                    </Typography>
                    {this.state.wabaInfo?.map((waba, i) => (
                      <>
                        <Grid item md={12} xs={12} className={classes.wabaInfo}>
                          <Typography
                            variant="h5"
                            gutterBottom
                            style={{
                              fontWeight: "600",
                              marginBottom: "10px",
                            }}
                          >
                            {`Account ${i + 1}`}
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            <>Display name - {waba?.displayName || ""}</>
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            <>
                              Display name status -{" "}
                              {waba?.displayNameStatus || ""}
                            </>
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            Phone number - {waba?.phoneNumber || ""}
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            Waba number id - {waba?.id || ""}
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            Messaging Limit - {waba?.messagingLimit || ""}
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            <>Account status - {waba?.status || ""}</>
                          </Typography>

                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontSize: "12px" }}
                          >
                            <>
                              Quality rating -{" "}
                              {waba?.qualityRating
                                ? `${["Low", "FLAGGED", "RED"].includes(
                                  waba?.qualityRating
                                )
                                  ? "Low"
                                  : [
                                    "UNFLAGGED",
                                    "Medium",
                                    "RESTRICTED",
                                    "YELLOW",
                                  ].includes(waba?.qualityRating)
                                    ? "Medium"
                                    : "High"
                                }`
                                : ""}
                            </>
                          </Typography>
                        </Grid>
                      </>
                    ))}{" "}
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    BVBP
                  </Typography>

                  <Grid container>
                    <Grid item xs={3} alignItems="center">
                      <TextField
                        placeholder="Enter BusinessID"
                        name="BusinessID"
                        onChange={(e) =>
                          this.setState({ businessId: e.target.value })
                        }
                        value={this.state.businessId}
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 10,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          disabled={!this.state.businessId}
                          onClick={this.getApplicationStatusHandler}
                        >
                          Check Status
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>

                  <Box>
                    <Grid container>
                      {this.state.bvbpCount != "" && (
                        <Grid
                          md={12}
                          xs={12}
                          style={{
                            marginTop: "5px",
                          }}
                        >
                          <Grid container md={12}>
                            <Typography variant="body1">
                              Bvbp apply count : {`${this.state.bvbpCount}`}
                            </Typography>
                          </Grid>
                        </Grid>
                      )}

                      {this.state.verificationStatus && (
                        <Grid container md={12}>
                          <Typography variant="body1">
                            Bvbp apply status : {this.state.verificationStatus}
                          </Typography>
                        </Grid>
                      )}
                      {this.state.bvbpApplicationResponse.length > 0 &&
                        this.state.bvbpApplicationResponse.map((data) => (
                          <Grid container xl={6} md={4} sm={6}>
                            <pre style={{ fontSize: "9px" }}>
                              {JSON.stringify(data, null, 2)}
                            </pre>
                          </Grid>
                        ))}

                      <Grid container style={{ marginTop: "5px" }}>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={this.toggleBvbpDialog}
                        >
                          Apply
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                  <ApplyBvbp
                    toggleBvbpDialog={this.toggleBvbpDialog}
                    bvbpDialog={this.state.bvbpDialog}
                    onBvbpSave={this.onBvbpHandler}
                    defaultData={{}}
                    wabaId={
                      this.props.templates[this.props.templateIndex]?.wabaAppId
                    }
                    wabaNumberId={
                      this.props.templates[this.props.templateIndex]
                        ?.wabaNumberId
                    }
                    hasWriteAccess={hasWriteAccess}
                  />
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update Provider Type
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Provider Type - {template.providerType || "V1"}
                  </Typography>
                  <Grid container>
                    <Grid item xs={5} alignItems="center">
                      <Autocomplete
                        value={this.state.providerType}
                        options={["v1", "v2", "v3"]}
                        onChange={(e, value, reason) =>
                          this.setState({
                            providerType: value,
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{
                              border: "1px solid ",
                              background: "white",
                              marginRight: 10,
                            }}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select Provider Type"
                            name="providerType"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateProviderType}
                        >
                          Update Provider Type
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </fieldset>
              {/* Outside the fieldset: gated by the assignAsset action, not fbManager write */}
                {
                  hasAssignAssetAccess && (
                  <Box py={2} px={2} my={2} className={classes.container}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ fontWeight: "bold" }}
                    >
                      Assign User to WABA
                    </Typography>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ fontSize: "13px", color: "#555", marginBottom: 8 }}
                    >
                      WABA App ID:{" "}
                      <strong>
                        {this.props.templates[this.props.templateIndex]
                          ?.wabaAppId || "—"}
                      </strong>
                    </Typography>
                    <Grid container alignItems="center" spacing={1}>
                      <Grid item xs={5}>
                        <Autocomplete
                          options={this.state.businessUsers}
                          getOptionLabel={(option) =>
                            `${option.email || option.name} — ${option.name} (${option.role})`
                          }
                          value={this.state.selectedBusinessUser}
                          onChange={(e, value) =>
                            this.setState({ selectedBusinessUser: value })
                          }
                          onOpen={() => {
                            if (this.state.businessUsers.length === 0) {
                              this.fetchBusinessUsers(false);
                            }
                          }}
                          loading={this.state.businessUsersLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search user…"
                              style={{
                                border: "1px solid",
                                background: "white",
                              }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {this.state.businessUsersLoading ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={16}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item>
                        <Button
                          style={{ marginLeft: 8 }}
                          color="primary"
                          variant="contained"
                          disabled={!this.state.selectedBusinessUser}
                          onClick={() =>
                            this.setState({ assignWabaDialog: true })
                          }
                        >
                          Assign User
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          style={{ marginLeft: 4 }}
                          variant="outlined"
                          onClick={() => this.fetchBusinessUsers(true)}
                          disabled={this.state.businessUsersLoading}
                        >
                          {this.state.businessUsersLoading ? (
                            <CircularProgress size={16} />
                          ) : (
                            "Refresh Users"
                          )}
                        </Button>
                      </Grid>
                    </Grid>

                    {/* Confirmation Dialog */}
                    <Dialog
                      open={this.state.assignWabaDialog}
                      onClose={() =>
                        !this.state.assignWabaLoading &&
                        this.setState({ assignWabaDialog: false })
                      }
                      maxWidth="sm"
                      fullWidth
                      PaperProps={{
                        style: { borderRadius: 16, padding: "8px 0" },
                      }}
                    >
                      {/* Header */}
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ padding: "12px 24px 12px" }}
                      >
                        <Typography
                          variant="h6"
                          style={{ fontWeight: 700, fontSize: 18, color: "#111" }}
                        >
                          Confirm WABA Assignment
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => this.setState({ assignWabaDialog: false })}
                          disabled={this.state.assignWabaLoading}
                          style={{ padding: 4 }}
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      </Box>

                      <Divider/>

                      <DialogContent style={{ padding: "12px 24px 16px" }}>
                        {/* WABA DETAILS section */}
                        <Box display="flex" alignItems="center" mb={1} style={{ gap: 6 }}>
                          <Typography
                            variant="caption"
                            style={{
                              color: "#aaa",
                              fontWeight: 700,
                              letterSpacing: "0.08em",
                              textTransform: "uppercase",
                              fontSize: 10,
                            }}
                          >
                            WABA Details
                          </Typography>
                        </Box>

                        <Box
                          style={{
                            background: "#f5f5f5",
                            borderRadius: 10,
                            padding: "14px 16px",
                            marginBottom: 20,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="caption"
                              style={{ color: "#888", display: "block", marginBottom: 2 }}
                            >
                              WABA ID
                            </Typography>
                            <Typography
                              variant="body1"
                              style={{
                                fontWeight: 700,
                                fontSize: 15,
                                fontFamily: "monospace",
                                color: "#111",
                              }}
                            >
                              {this.props.templates[this.props.templateIndex]
                                ?.wabaAppId || "—"}
                            </Typography>
                          </Box>
                        </Box>

                        {/* USER INFORMATION section */}
                        <Box display="flex" alignItems="center" mb={1} style={{ gap: 6 }}>
                          <Typography
                            variant="caption"
                            style={{
                              color: "#aaa",
                              fontWeight: 700,
                              letterSpacing: "0.08em",
                              textTransform: "uppercase",
                              fontSize: 10,
                            }}
                          >
                            User Information
                          </Typography>
                        </Box>

                        <Box
                          style={{
                            background: "#f5f5f5",
                            borderRadius: 10,
                            padding: "14px 16px",
                            marginBottom: 16,
                          }}
                        >
                          {/* Row 1: Full Name + Email */}
                          <Box
                            display="flex"
                            style={{ gap: 16, marginBottom: 14 }}
                          >
                            <Box style={{ flex: 1 }}>
                              <Typography
                                variant="caption"
                                style={{ color: "#888", display: "block", marginBottom: 2 }}
                              >
                                Full Name
                              </Typography>
                              <Typography
                                variant="body2"
                                style={{ fontWeight: 700, color: "#111", fontSize: 15 }}
                              >
                                {this.state.selectedBusinessUser?.name || "—"}
                              </Typography>
                              <Typography
                                variant="caption"
                                style={{ color: "#aaa" }}
                              >
                                ID: {this.state.selectedBusinessUser?.id || "—"}
                              </Typography>
                            </Box>
                            <Box style={{ flex: 1 }}>
                              <Typography
                                variant="caption"
                                style={{ color: "#888", display: "block", marginBottom: 2 }}
                              >
                                Email Address
                              </Typography>
                              <Typography
                                variant="body2"
                                style={{ fontWeight: 600, color: "#111", wordBreak: "break-all", fontSize: 15 }}
                              >
                                {this.state.selectedBusinessUser?.email || "—"}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>

                        {/* Info note */}
                        <Box
                          display="flex"
                          style={{
                            gap: 8,
                            background: "#f5f5f5",
                            borderRadius: 10,
                            padding: "12px 14px",
                          }}
                        >
                          <Typography variant="caption" style={{ color: "#555", lineHeight: 1.6 }}>
                            The user will be granted full{" "}
                            <strong>MANAGE</strong> permissions for this WABA
                            account. This action will be logged for security
                            auditing.
                          </Typography>
                        </Box>
                      </DialogContent>

                      <Divider/>

                      <DialogActions style={{ padding: "16px 24px 12px", gap: 8, justifyContent: "space-between" }}>
                        <Button
                          onClick={() => this.setState({ assignWabaDialog: false })}
                          disabled={this.state.assignWabaLoading}
                          style={{
                            color: "#555",
                            fontWeight: 600,
                            textTransform: "none",
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={this.handleAssignWaba}
                          color="primary"
                          variant="contained"
                          disabled={this.state.assignWabaLoading}
                          style={{
                            fontWeight: 700,
                            textTransform: "none",
                            borderRadius: 8,
                            padding: "8px 22px",
                            fontSize: 14,
                          }}
                        >
                          {this.state.assignWabaLoading ? (
                            <CircularProgress size={16} color="inherit" style={{ marginRight: 8 }} />
                          ) : null}
                          {this.state.assignWabaLoading ? "Assigning…" : "Confirm Assignment"}
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </Box>
                )}
            </Box>
          );
        },
      },
      {
        label: "Finance",
        key: "finance",
        render: () => {
          const hasWriteAccess = verifySubRouteAccess(
            subRoutes,
            "finance",
            "write"
          );
          return (
            <fieldset
              disabled={!hasWriteAccess}
              style={{ border: "none", padding: 0, margin: 0 }}
            >
              <Box py={2} px={2} my={2} className={classes.outerContainer}>
                <Grid style={{ display: "flex", flexDirection: "row" }}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={this.openChargebeeDialog}
                    style={{
                      marginRight: "10px",
                      marginLeft: "15px",
                      marginTop: "20px",
                    }}
                  >
                    View Chargebee Logs
                  </Button>
                  <Dialog
                    open={this.state.chargeBeeDialog}
                    onClose={this.closeChargebeeDialog}
                    maxWidth="lg"
                    PaperProps={{
                      style: { width: "75%", height: "100%" },
                    }}
                  >
                    <DialogContent>
                      <div
                        style={{
                          overflow: "auto",
                          maxHeight: "calc(100vh - 150px)",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                            background: "#fff",
                            height: "30px",
                            display: "flex",
                            justifyContent: "space-around",
                            alignItems: "center",
                            padding: "10px",
                          }}
                        >
                          <strong>Previous Object</strong>
                          <strong>Modified Object</strong>
                        </div>
                        {this.state.chargeBeeLogs.length === 0 ? (
                          <div
                            style={{
                              textAlign: "center",
                              width: "100%",
                              marginTop: "20%",
                            }}
                          >
                            No ChargeBee Logs Found :(
                          </div>
                        ) : (
                          this.state.chargeBeeLogs.map((item, index) => (
                            <Grid
                              container
                              spacing={2}
                              key={index}
                              style={{
                                display: "flex",
                                padding: "10px",
                              }}
                            >
                              <Grid
                                item
                                xs={6}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <div
                                  style={{
                                    marginTop: "10px",
                                    color: "#1b6d92",
                                  }}
                                >
                                  Date:{" "}
                                  {new Date(item.createdAt).toLocaleString()}
                                </div>
                                <div
                                  style={{
                                    borderBottom: "1px solid #ccc",
                                    flex: 1,
                                  }}
                                >
                                  <pre>
                                    {JSON.stringify(
                                      item.previousObject,
                                      null,
                                      2
                                    )}
                                  </pre>
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <div
                                  style={{
                                    borderBottom: "1px solid #ccc",
                                    flex: 1,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div
                                      style={{
                                        marginTop: "10px",
                                        color: "#1b6d92",
                                      }}
                                    >
                                      Date:{" "}
                                      {new Date(
                                        item.createdAt
                                      ).toLocaleString()}
                                    </div>
                                    {item.invoiceNo ? (
                                      <div
                                        style={{
                                          marginTop: "10px",
                                          color: "#1b6d92",
                                        }}
                                      >
                                        Invoice No: {item.invoiceNo}
                                      </div>
                                    ) : null}
                                  </div>
                                  <pre>
                                    {JSON.stringify(
                                      item.modifiedObject,
                                      null,
                                      2
                                    )}
                                  </pre>
                                </div>
                              </Grid>
                            </Grid>
                          ))
                        )}
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={this.closeChargebeeDialog}
                        color="primary"
                      >
                        Close
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Grid item>
                    <>
                      {!TENANT_ID ? (
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ marginTop: "20px" }}
                          onClick={this.openChargebee}
                        >
                          Open Chargebee
                        </Button>
                      ) : (
                        <></>
                      )}
                    </>
                  </Grid>
                </Grid>

                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Template Credit (v2 & v3) - Enter amount in +/-
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Current Balance - {`${template.currency} `}
                    {template.templateCredit
                      ? template.templateCredit / 100000
                      : 0}
                  </Typography>
                  <Box my={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          style={{
                            width: "48%",
                            border: "1px solid ",
                            background: "white",
                            marginRight: 10,
                          }}
                          name="templateCredit"
                          type="number"
                          onChange={this.handleInput}
                          value={this.state.templateCredit}
                        />
                        <TextField
                          style={{
                            width: "48%",
                            border: "1px solid ",
                            background: "white",
                          }}
                          name="paymentRemarks"
                          onChange={this.handleNumberInput}
                          placeholder="Enter Remarks"
                          value={this.state.paymentRemarks}
                          required
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <NativeSelect
                          fullWidth
                          value={this.state.selectedTemplateCreditAction}
                          onChange={(e) =>
                            this.setState({
                              selectedTemplateCreditAction: e.target.value,
                            })
                          }
                          input={
                            <InputBase
                              classes={{
                                input: classes.selectFieldInput,
                              }}
                            />
                          }
                        >
                          <option value="ADD">ADD</option>
                          <option value="SUBTRACT">SUBTRACT</option>
                        </NativeSelect>
                      </Grid>
                      <Grid item>
                        <Tooltip
                          title={
                            !this.state.paymentRemarks
                              ? "Please enter payment remarks"
                              : ""
                          }
                        >
                          <span>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                if (this.updateTemplateCredit()) {
                                  this.setState({
                                    paymentRemarks: undefined,
                                  });
                                }
                              }}
                              disabled={!this.state.paymentRemarks}
                            >
                              Update Template Credit
                            </Button>
                          </span>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Box>
                  <Grid
                    container
                    spacing={8}
                    style={{
                      padding: "20px 30px 25px 30px",
                      marginTop: "10px",
                    }}
                  >
                    <Grid xs={12}>
                      <Grid
                        xs={8}
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <Typography
                          variant="h4"
                          style={{ marginBottom: "15px", fontSize: "15px" }}
                        >
                          {"Download Template Credit Report"}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      xs={12}
                      style={{
                        display:
                          window.innerWidth <= 850 ? "inline-block" : "flex",
                        alignItems: "center",
                        marginBottom: "15px",
                      }}
                    >
                      <DateFilter
                        filterKey="createdAt"
                        filterName="Created At"
                        classes={classes}
                        applied={this.state.applied}
                        setDate={this.setDate}
                        setFocus={this.setFocus}
                        checkDateInput={this.checkDateInput}
                        clearDate={this.clearDate}
                      />
                      <Tooltip title="Clear filter">
                        <IconButton
                          onClick={this.clearDate}
                          size="small"
                          style={{
                            marginLeft: 8,
                            backgroundColor: "#d6d6d6",
                          }}
                        >
                          <Clear />
                        </IconButton>
                      </Tooltip>
                      <Button
                        color="primary"
                        variant="contained"
                        style={{
                          marginLeft: 8,
                          height: 30,
                        }}
                        onClick={() => {
                          this.getReport();
                        }}
                      >
                        Download
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Meta Ads Credit (v2 & v3) - Enter amount in +/-
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Current Balance - {`${template.currency} `}
                    {template.metaAdsCredit
                      ? template.metaAdsCredit / 100000
                      : 0}
                  </Typography>
                  <Box my={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          style={{
                            width: "48%",
                            border: "1px solid ",
                            background: "white",
                            marginRight: 10,
                          }}
                          name="metaAdsCredit"
                          type="number"
                          onChange={this.handleInput}
                          value={this.state.metaAdsCredit}
                        />
                        <TextField
                          style={{
                            width: "48%",
                            border: "1px solid ",
                            background: "white",
                          }}
                          name="metaCreditRemarks"
                          onChange={this.handleNumberInput}
                          placeholder="Enter Remarks"
                          value={this.state.metaCreditRemarks}
                          required
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <NativeSelect
                          fullWidth
                          value={this.state.selectedMetaCreditAction}
                          onChange={(e) =>
                            this.setState({
                              selectedMetaCreditAction: e.target.value,
                            })
                          }
                          input={
                            <InputBase
                              classes={{
                                input: classes.selectFieldInput,
                              }}
                            />
                          }
                        >
                          <option value="ADD">ADD</option>
                          <option value="SUBTRACT">SUBTRACT</option>
                        </NativeSelect>
                      </Grid>
                      <Grid item>
                        <Tooltip
                          title={
                            !this.state.metaCreditRemarks
                              ? "Please enter payment remarks"
                              : ""
                          }
                        >
                          <span>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                this.updateMetaCredit();
                                this.setState({
                                  metaCreditRemarks: undefined,
                                });
                              }}
                              disabled={!this.state.metaCreditRemarks}
                            >
                              Update Meta Credit
                            </Button>
                          </span>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
               
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Grid>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ fontWeight: "bold" }}
                    >
                      Reset Ongoing Billing Process
                    </Typography>
                    <div>
                      <Typography variant="body1" gutterBottom>
                        <pre>
                          Process Type: {template.ongoingBillingProcess?.type}
                        </pre>
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        <pre>
                          Plan Name: {template.ongoingBillingProcess?.planName}
                        </pre>
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={this.openBillingDialog}
                        >
                          Set Null
                        </Button>
                      </Typography>
                    </div>
                    <Dialog
                      open={this.state.billingProcessDialog}
                      onClose={this.closeBillingDialog}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          Are you sure you want to reset the ongoing billing
                          process?
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={this.closeBillingDialog}
                          color="primary"
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={() => {
                            this.setOngoingBilling();
                            this.closeBillingDialog();
                          }}
                          color="primary"
                        >
                          Yes
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Suspend/Activate Project
                  </Typography>
                  <Grid container>
                    <Grid item xs={5} alignItems="center">
                      <Autocomplete
                        options={PROJECT_STATUS.map((option) => option)}
                        onChange={(e, value, reason) =>
                          this.handleAutoComplete(
                            "projectStatus",
                            value,
                            reason
                          )
                        }
                        value={template.status}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className={classes.textField}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select Status"
                            style={{
                              border: "1px solid ",
                              background: "white",
                              marginRight: 10,
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={this.updateProjectStatus}
                        >
                          Update Status
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Verify Payment
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Enter payment id to verify
                  </Typography>
                  <Box display="flex" alignItems="center" my={2}>
                    <TextField
                      style={{
                        width: "30%",
                        border: "1px solid ",
                        background: "white",
                        marginRight: 10,
                      }}
                      name="pgId"
                      placeholder="Enter payment id"
                      value={this.state.paymentId}
                      onChange={this.handlePaymentIdChange}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.verifyPayment}
                      disabled={
                        this.state.paymentDetailsLoading ||
                        !this.state.paymentId
                      }
                    >
                      {this.state.paymentDetailsLoading
                        ? "Verifying..."
                        : "Verify"}
                    </Button>
                  </Box>

                  {this.state.paymentDetails && (
                    <Box
                      p={2}
                      border={1}
                      borderColor="grey.300"
                      borderRadius={4}
                      bgcolor="background.paper"
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="textSecondary">
                            Project Id
                          </Typography>
                          <Typography
                            variant="body1"
                            style={{
                              color:
                                this.state.paymentDetails.projectId ==
                                  template._id
                                  ? "green"
                                  : "red",
                              fontWeight: "bold",
                            }}
                          >
                            {this.state.paymentDetails.projectId}
                          </Typography>
                          {this.state.paymentDetails.projectId !==
                            template._id && (
                              <Typography
                                variant="body2"
                                style={{ color: "red", fontSize: "0.75rem" }}
                              >
                                Project ID does not match
                              </Typography>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="textSecondary">
                            Payment Status
                          </Typography>
                          <Typography variant="body1">
                            {this.state.paymentDetails.status}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="textSecondary">
                            Payment Mode
                          </Typography>
                          <Typography variant="body1">
                            {this.state.paymentDetails.payment_method}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="textSecondary">
                            Txn Id
                          </Typography>
                          <a
                            href={`${CHARGEBEE_REDIRECT_URL.replace(
                              "/d/customers",
                              ""
                            )}/d/transactions/${this.state.paymentDetails.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "fit-content",
                            }}
                          >
                            {this.state.paymentDetails.id}
                            <OpenInNew
                              style={{ fontSize: 16, marginLeft: 5 }}
                            />
                          </a>
                        </Grid>
                        {this.state.paymentDetails.linked_invoices &&
                          this.state.paymentDetails.linked_invoices.length >
                          0 && (
                            <Grid item xs={12} sm={6}>
                              <Typography variant="body2" color="textSecondary">
                                Invoice Id
                              </Typography>
                              {this.state.paymentDetails.linked_invoices.map(
                                (invoice, index) => (
                                  <div key={invoice.invoice_id}>
                                    <a
                                      href={`${CHARGEBEE_REDIRECT_URL.replace(
                                        "/d/customers",
                                        ""
                                      )}/d/invoices/${invoice.invoice_id}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "fit-content",
                                      }}
                                    >
                                      {invoice.invoice_id}
                                      <OpenInNew
                                        style={{ fontSize: 16, marginLeft: 5 }}
                                      />
                                    </a>
                                  </div>
                                )
                              )}
                            </Grid>
                          )}
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="textSecondary">
                            Amount
                          </Typography>
                          <Typography variant="body1">
                            {this.state.paymentDetails.amount / 100}{" "}
                            {this.state.paymentDetails.currency_code}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                </Box>
              </Box>
              {(() => {
                const mv = this.state.mandateView;
                // The mandate to show: the live one if valid, else the most
                // recent (cancelled / paused / expired) so its state still shows.
                const shownMethod = mv?.method || mv?.latest_method || null;
                const st = mandateStatus(shownMethod);
                // When the mandate last changed state, so finance can line it up
                // against the last-payment time (e.g. cancelled 6:30 am → the 7:30
                // am debit failed because it was already cancelled). Only reliable
                // stored timestamps are shown.
                const statusChange = (() => {
                  const m = shownMethod;
                  if (!m) return null;
                  const s = (m.status || "").toLowerCase();
                  const t = (m.token_status || "").toLowerCase();
                  if (m.revoked_at && (s === "revoked" || t === "cancelled"))
                    return { label: "Cancelled on", at: m.revoked_at };
                  const expired =
                    s === "expired" ||
                    (m.expires_at && new Date(m.expires_at) < new Date());
                  if (expired && m.expires_at)
                    return { label: "Expired on", at: m.expires_at };
                  return null;
                })();
                const inFlight = Array.isArray(mv?.in_flight) ? mv.in_flight : [];
                const dead = mandateIsDead(shownMethod);
                const autoBlocked =
                  mv?.auto_debit_enabled && (dead || st.tone === "warn");
                const blockTone = dead ? "dead" : "warn";
                const lastStatus = (
                  shownMethod?.last_debit_status || ""
                ).toLowerCase();
                const lastTone =
                  lastStatus === "failed"
                    ? "dead"
                    : lastStatus === "success"
                    ? "ok"
                    : "warn";

                // Plain date, no seconds: "20 Sep 2026, 11:04 AM".
                const dt = (v) =>
                  v
                    ? new Date(v).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "";

                const sectionHead = {
                  fontWeight: 600,
                  marginBottom: 6,
                };
                const row = (label, value, mono) => (
                  <Box display="flex" style={{ margin: "3px 0" }}>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      style={{ minWidth: 110, flexShrink: 0 }}
                    >
                      {label}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{
                        fontFamily: mono ? "monospace" : "inherit",
                        wordBreak: "break-all",
                      }}
                    >
                      {value}
                    </Typography>
                  </Box>
                );

                return (
                  <Box py={2} px={3} my={2} className={classes.outerContainer}>
                    <Typography variant="h5" style={{ marginBottom: 16 }}>
                      Auto Collection
                    </Typography>
                    {!this.state.mandateViewLoaded ? (
                      <Typography variant="body2" color="textSecondary">
                        Loading...
                      </Typography>
                    ) : mv?.found ? (
                      <Box>
                        {/* Auto collection toggle */}
                        <Box display="flex" alignItems="center">
                          <Switch
                            edge="start"
                            color="primary"
                            checked={!!mv.auto_debit_enabled}
                            disabled={this.state.mandateToggling}
                            onChange={this.toggleMandateAutoCharge}
                          />
                          <Typography
                            variant="subtitle1"
                            style={{ fontWeight: 600, marginLeft: 8 }}
                          >
                            {mv.auto_debit_enabled
                              ? "Auto collection is ON"
                              : "Auto collection is OFF"}
                          </Typography>
                        </Box>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          style={{ marginTop: 2 }}
                        >
                          {mv.auto_debit_enabled
                            ? "Invoices are collected automatically. Turn off to collect manually."
                            : "Invoices are not collected automatically — collect them manually."}
                        </Typography>

                        <Divider style={{ margin: "16px 0" }} />

                        {/* Mandate status */}
                        <Box display="flex" alignItems="center">
                          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                            Mandate status
                          </Typography>
                          <Chip
                            size="small"
                            label={st.label}
                            style={{
                              backgroundColor: TONE[st.tone].chip,
                              color: TONE[st.tone].chipText,
                              fontWeight: 600,
                              marginLeft: 10,
                            }}
                          />
                        </Box>
                        {statusChange ? (
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            style={{ marginTop: 4 }}
                          >
                            {statusChange.label} {dt(statusChange.at)}
                          </Typography>
                        ) : null}
                        {autoBlocked ? (
                          <Box
                            style={{
                              background: TONE[blockTone].soft,
                              border: `1px solid ${TONE[blockTone].softBorder}`,
                              borderRadius: 6,
                              padding: "10px 12px",
                              marginTop: 10,
                            }}
                          >
                            <Typography
                              variant="body2"
                              style={{
                                color: TONE[blockTone].ink,
                                fontWeight: 600,
                              }}
                            >
                              Auto collection is ON, but this mandate is{" "}
                              {st.label.toLowerCase()}. Payments cannot be
                              collected automatically
                              {blockTone === "dead"
                                ? " — please collect manually."
                                : " right now."}
                            </Typography>
                          </Box>
                        ) : null}

                        <Divider style={{ margin: "16px 0" }} />

                        {/* Payment in progress */}
                        <Typography variant="subtitle1" style={sectionHead}>
                          Payment in progress
                        </Typography>
                        {inFlight.length ? (
                          <>
                            <Typography
                              variant="body2"
                              color="textSecondary"
                              style={{ marginBottom: 8 }}
                            >
                              A payment is being collected right now. Please wait
                              for it before collecting manually.
                            </Typography>
                            {inFlight.map((f) => (
                              <Box
                                key={`${f.invoice_id}_${f.attempt_no}`}
                                style={{
                                  border: "1px solid #e0e0e0",
                                  borderRadius: 6,
                                  padding: "12px",
                                  marginTop: 8,
                                }}
                              >
                                <Chip
                                  size="small"
                                  label="In progress"
                                  style={{
                                    backgroundColor: TONE.warn.chip,
                                    color: TONE.warn.chipText,
                                    fontWeight: 600,
                                    marginBottom: 10,
                                  }}
                                />
                                {row("Invoice", f.invoice_id, true)}
                                {row("Amount", rupeesFromPaise(f.amount))}
                                {row("Payment ID", f.pg_payment_id || "—", true)}
                                {row("Started", dt(f.triggered_at))}
                              </Box>
                            ))}
                          </>
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            No payment being collected right now.
                          </Typography>
                        )}

                        <Divider style={{ margin: "16px 0" }} />

                        {/* Last payment */}
                        <Typography variant="subtitle1" style={sectionHead}>
                          Last payment
                        </Typography>
                        {shownMethod?.last_debit_at ? (
                          <Box>
                            <Box display="flex" alignItems="center">
                              <Chip
                                size="small"
                                label={lastDebitLabel(
                                  shownMethod.last_debit_status
                                )}
                                style={{
                                  backgroundColor: TONE[lastTone].chip,
                                  color: TONE[lastTone].chipText,
                                  fontWeight: 600,
                                  marginRight: 10,
                                }}
                              />
                              <Typography variant="body2" color="textSecondary">
                                {dt(shownMethod.last_debit_at)}
                              </Typography>
                            </Box>
                            {lastStatus === "failed" &&
                            shownMethod.last_debit_failure_reason ? (
                              <Typography
                                variant="body2"
                                style={{ color: TONE.dead.ink, marginTop: 8 }}
                              >
                                Reason: {shownMethod.last_debit_failure_reason}
                              </Typography>
                            ) : null}
                            {shownMethod.last_debit_payment_id ? (
                              <Box style={{ marginTop: 6 }}>
                                {row(
                                  "Payment ID",
                                  shownMethod.last_debit_payment_id,
                                  true
                                )}
                              </Box>
                            ) : null}
                          </Box>
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            No payment attempted yet.
                          </Typography>
                        )}
                      </Box>
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        No auto collection set up for this project.
                      </Typography>
                    )}
                  </Box>
                );
              })()}
            </fieldset>
          );
        },
      },
      {
        label: "Platform Config",
        key: "platformConfig",
        render: () => {
          const hasWriteAccess = verifySubRouteAccess(
            subRoutes,
            "platformConfig",
            "write"
          );
          return (
            <fieldset
              disabled={!hasWriteAccess}
              style={{ border: "none", padding: 0, margin: 0 }}
            >
              <Box py={2} px={2} my={2} className={classes.outerContainer}>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update Messaging Tier Limit
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Messaging Tier Limit - {template.dailyTemplateLimit}
                  </Typography>
                  <Grid container>
                    <Grid item xs={5} alignItems="center">
                      <Autocomplete
                        value={this.state.messageLimit}
                        options={Tier_Limit.map((option) => option.name)}
                        onChange={(e, value, reason) =>
                          this.setState({
                            messageLimit: value,
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{
                              border: "1px solid ",
                              background: "white",
                              marginRight: 10,
                            }}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select Limit"
                            name="messageLimit"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateMessagingLimit}
                        >
                          Update Message Limit
                        </Button>
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.syncMessagingLimit}
                        >
                          Sync
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Media Content Size Update
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Current Media Content Size -{" "}
                    {typeof template.mediaContentSize === "string"
                      ? template.mediaContentSize
                      : typeof template.mediaContentSize === "number"
                        ? `${template.mediaContentSize / (1024 * 1024 * 1024)} GB`
                        : "N/A"}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item>
                      <Autocomplete
                        disabled={!hasWriteAccess}
                        options={MEDIA_CONTENT_SIZES.map((option) => option)}
                        onChange={(e, value, reason) =>
                          this.handleAutoComplete(
                            "selectedMediaContentSize",
                            value,
                            reason
                          )
                        }
                        value={this.state.selectedMediaContentSize}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className={classes.textField}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select Media Content Size"
                            style={{
                              border: "1px solid ",
                              background: "white",
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item>
                      {hasWriteAccess ? (
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={this.updateMediaContentSize}
                        >
                          Update Media Content Size
                        </Button>
                      ) : (
                        <></>
                      )}
                    </Grid>
                  </Grid>
                </Box>

                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Whatsapp Business Throughput Tier
                  </Typography>
                  <Box my={2}>
                    <Grid container spacing={2}>
                      <Grid item>
                        <Autocomplete
                          options={WABATPT_TIERS.map((option) => option)}
                          onChange={(e, value, reason) =>
                            this.handleAutoComplete("wabaTpt", value, reason)
                          }
                          value={template.wabaTpt}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className={classes.textField}
                              InputProps={{ ...params.InputProps }}
                              placeholder="Select Throughput"
                              style={{
                                border: "1px solid ",
                                background: "white",
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.updateWabaTpt}
                        >
                          Update Throughput
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box my={2}>
                    <Grid container spacing={2}>
                      <Grid item>
                        <Autocomplete
                          options={WABATPT_TIERS.map((option) => option)}
                          onChange={(e, value, reason) =>
                            this.handleAutoComplete(
                              "wabaStatusTpt",
                              value,
                              reason
                            )
                          }
                          value={template.wabaStatusTpt}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className={classes.textField}
                              InputProps={{ ...params.InputProps }}
                              placeholder="Select Status Throughput"
                              style={{
                                border: "1px solid ",
                                background: "white",
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.updateWabaStatusTpt}
                        >
                          Update Status Throughput
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>

                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    For GS only - WhatsApp Number - Enter number with dial code
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Number in use - {template.whatsappNumber}
                  </Typography>
                  <Box my={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          style={{
                            width: "100%",
                            border: "1px solid ",
                            background: "white",
                            marginRight: 10,
                          }}
                          name="whatsappNumber"
                          onChange={this.handleNumberInput}
                          value={this.state.whatsappNumber}
                        />
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.updateWhatsAppNumber}
                        >
                          Update Number
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>

                {/* <Box py={2} px={2} my={2} className={classes.container}>
          <Typography
            variant="body1"
            gutterBottom
            style={{ fontWeight: "bold" }}
          >
            Waba details
          </Typography>
          <Typography variant="body1" gutterBottom>
            <div>
              <pre>wabaNumberId - {template.wabaNumberId}</pre>
              <pre>wabaAppId - {template.wabaAppId}</pre>
            </div>
          </Typography>
        </Box> */}

                <Box py={2} px={2} my={2} className={classes.wabaBilling}>
                  <Box py={2} px={2} my={2}>
                    <Grid>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Reset Ongoing Billing Process
                      </Typography>
                      <div>
                        <Typography variant="body1" gutterBottom>
                          <pre>
                            Process Type: {template.ongoingBillingProcess?.type}
                          </pre>
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                          <pre>
                            Plan Name:{" "}
                            {template.ongoingBillingProcess?.planName}
                          </pre>
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={this.openBillingDialog}
                          >
                            Set Null
                          </Button>
                        </Typography>
                      </div>
                      <Dialog
                        open={this.state.billingProcessDialog}
                        onClose={this.closeBillingDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <DialogContent>
                          <DialogContentText id="alert-dialog-description">
                            Are you sure you want to reset the ongoing billing
                            process?
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={this.closeBillingDialog}
                            color="primary"
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              this.setOngoingBilling();
                              this.closeBillingDialog();
                            }}
                            color="primary"
                          >
                            Yes
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Grid>
                  </Box>
                  <Box py={2} px={2} my={2}>
                    <Grid>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Reset waba deleted status
                      </Typography>
                      <Box>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={() =>
                            this.setTemplateInDb({
                              wabaDeleted: false,
                            })
                          }
                        >
                          Set Null
                        </Button>
                      </Box>
                    </Grid>
                  </Box>
                  <Box py={2} px={2} my={2}>
                    <Grid>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Reset waba disabled status
                      </Typography>
                      <Box>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={() =>
                            this.setTemplateInDb({
                              wabaAppStatus: null,
                            })
                          }
                        >
                          Set Null
                        </Button>
                      </Box>
                    </Grid>
                  </Box>
                </Box>

                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Migration
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.updateMigrateStatus}
                    >
                      Migrate User
                    </Button>
                  </Typography>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Suspend/Activate Project
                  </Typography>
                  <Grid container>
                    <Grid item xs={5} alignItems="center">
                      <Autocomplete
                        options={PROJECT_STATUS.map((option) => option)}
                        onChange={(e, value, reason) =>
                          this.handleAutoComplete(
                            "projectStatus",
                            value,
                            reason
                          )
                        }
                        value={template.status}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className={classes.textField}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select Status"
                            style={{
                              border: "1px solid ",
                              background: "white",
                              marginRight: 10,
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={this.updateProjectStatus}
                        >
                          Update Status
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Reset owner password
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Owner Email - {this.state.ownerName}
                  </Typography>
                  <Grid container>
                    <Grid item>
                      <TextField
                        placeholder="Enter Password"
                        name="password"
                        onChange={this.handleChange}
                        value={this.state.password}
                        style={{
                          border: "1px solid ",
                          background: "white",
                          marginRight: 10,
                        }}
                      />
                    </Grid>
                    <Grid>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={this.resetPassword}
                        >
                          Reset Password
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update About
                  </Typography>
                  <Grid container>
                    <Grid item>
                      <TextField
                        placeholder="Enter About"
                        name="about"
                        onChange={this.handleChange}
                        value={this.state.about}
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 10,
                        }}
                      />
                    </Grid>
                    <Grid>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={this.resetAbout}
                          style={{ marginLeft: "10px" }}
                        >
                          Update About
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update Quality Rating
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Quality Rating -{" "}
                    {template.qualityRating ? template.qualityRating : "N/A"}
                  </Typography>
                  <Grid container>
                    <Grid item xs={5} alignItems="center">
                      <Autocomplete
                        value={this.state.qualityRating}
                        options={["Low", "Medium", "High"]}
                        onChange={(e, value, reason) =>
                          this.setState({
                            qualityRating: value,
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{
                              border: "1px solid ",
                              background: "white",
                              marginRight: 10,
                            }}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select Rating"
                            name="qualityRating"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateQualtiyRating}
                        >
                          Update Quality Rating
                        </Button>
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={() => this.updateQualtiyRating("sync")}
                        >
                          Sync
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update Agents Limit
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Agents Limit -{" "}
                    {template.maxAgents ? template.maxAgents : "5"}
                  </Typography>
                  <Grid container>
                    <Grid item xs={3} alignItems="center">
                      <TextField
                        type="number"
                        placeholder="Enter Agent Limit"
                        name="agentLimit"
                        onChange={this.handleChange}
                        value={this.state.agentLimit}
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 10,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateAgentLimit}
                        >
                          Update Agents
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update Attribute Limit
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Attribute Limit -{" "}
                    {template.attributeLimit ? template.attributeLimit : "20"}
                  </Typography>
                  <Grid container>
                    <Grid item xs={3} alignItems="center">
                      <TextField
                        type="number"
                        placeholder="Enter Attribute Limit"
                        name="attributeLimit"
                        onChange={this.handleChange}
                        value={this.state.attributeLimit}
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 10,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateAttributeLimit}
                        >
                          Update Attribute Limit
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update Tag Limit
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Tag Limit - {template.tagLimit ? template.tagLimit : "100"}
                  </Typography>
                  <Grid container>
                    <Grid item xs={3} alignItems="center">
                      <TextField
                        type="number"
                        placeholder="Enter Tag Limit"
                        name="tagLimit"
                        onChange={this.handleChange}
                        value={this.state.tagLimit}
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 10,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateTagLimit}
                        >
                          Update Tag Limit
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update Schedule Campaign Limit
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Current Limit -{" "}
                    {template.scheduleCampaignLimit
                      ? template.scheduleCampaignLimit
                      : 100}
                  </Typography>
                  <Grid container>
                    <Grid item xs={3} alignItems="center">
                      <TextField
                        type="number"
                        placeholder="Enter Limit"
                        name="scheduleCampaignLimit"
                        onChange={this.handleChange}
                        value={this.state.scheduleCampaignLimit}
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 10,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateScheduledCampaignLimit}
                        >
                          Update Limit
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography variant="body1" gutterBottom>
                    <strong> FB Business ID - </strong>
                    {template.fbBusinessId ? template.fbBusinessId : "null"} -
                  </Typography>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    FB manager Status
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    FB manager Status - {template.fbManagerVerified || "N/A"}
                  </Typography>
                  <Grid container>
                    <Grid item xs={5} alignItems="center">
                      <Autocomplete
                        value={this.state.fbManager}
                        options={["VERIFIED", "UNVERIFIED"]}
                        onChange={(e, value, reason) =>
                          this.setState({
                            fbManager: value,
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{
                              border: "1px solid ",
                              background: "white",
                              marginRight: 10,
                            }}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select Status"
                            name="fbManager"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updatefbManager}
                        >
                          Update fbManager status
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Display Name Status
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Display Name Status -{" "}
                    {template.displayNameVerified || "N/A"}
                  </Typography>
                  <Grid container>
                    <Grid item xs={5} alignItems="center">
                      <Autocomplete
                        value={this.state.displayNameVerified}
                        options={[
                          "ready",
                          "verified",
                          "APPROVED",
                          "DEFERRED",
                          "UNVERIFIED",
                          "NONE",
                        ]}
                        onChange={(e, value, reason) =>
                          this.setState({
                            displayNameVerified: value,
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{
                              border: "1px solid ",
                              background: "white",
                              marginRight: 10,
                            }}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select display name status"
                            name="displayNameVerified"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateDisplayName}
                        >
                          Update Display Name status
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Assistant Rate Limit
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {`Assistant Rate Limit - ${template.apiLimit || 100}/sec`}
                  </Typography>
                  <Grid container>
                    <Grid item xs={5} alignItems="center">
                      <Autocomplete
                        disableClearable
                        value={this.state.assistantApiLimit}
                        options={validLimits}
                        getOptionLabel={(option) => option.toString()}
                        onChange={(e, value, reason) =>
                          this.setState({
                            assistantApiLimit: value,
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{
                              border: "1px solid ",
                              background: "white",
                              marginRight: 10,
                            }}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select assistant rate limit"
                            name="assistantApiLimit"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateAssistantRateLimit}
                        >
                          Update Assistant Rate Limit
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Whatsapp Pay Update
                  </Typography>
                  <Grid container spacing={1}>
                    <Grid item md={4} alignItems="center">
                      <Typography variant="h5" paragraph noWrap={false}>
                        Select Pay Type
                      </Typography>
                      <Autocomplete
                        value={WHATSAPP_PAY_TYPES.find(
                          (lk) =>
                            lk.value ===
                            template?.orderCheckoutDetails?.whatsappPayType
                        )}
                        options={WHATSAPP_PAY_TYPES}
                        getOptionLabel={(op) => op.name}
                        onChange={(e, value, reason) =>
                          this.updateWhatsappPayDetails(
                            "whatsappPayType",
                            value.value
                          )
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{
                              border: "1px solid ",
                              background: "white",
                              marginRight: 10,
                            }}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select Whatsapp Pay Type"
                            name="whatsapp_pay_type"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Verify Whatsapp Pay Gateway
                      </Typography>
                      <Switch
                        checked={
                          template?.orderCheckoutDetails?.paymentOptions
                            ?.native_whatsapp_gateway === "approved"
                        }
                        onChange={(e, c) => {
                          const val = c ? "approved" : "rejected";
                          this.updateWhatsappPayDetails(
                            "paymentOptions.native_whatsapp_gateway",
                            val
                          );
                        }}
                        name="native_whatsapp_pay_gateway_approver"
                      />
                    </Grid>
                    {template?.partnerReferralId && (
                      <Grid item md={3}>
                        <Typography variant="h5" paragraph noWrap={false}>
                          Payment Template Enabled By Meta
                        </Typography>
                        <Autocomplete
                          value={TEMPLATE_ENABLE_BY_META_TYPES.find(
                            (lk) =>
                              lk.value ===
                              template?.orderCheckoutDetails
                                ?.paymentTemplateEnabled
                          )}
                          options={TEMPLATE_ENABLE_BY_META_TYPES}
                          getOptionLabel={(op) => op.name}
                          onChange={(e, value, reason) =>
                            this.updateWhatsappPayDetails(
                              "paymentTemplateEnabled",
                              value.value
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              style={{
                                border: "1px solid ",
                                background: "white",
                                marginRight: 10,
                              }}
                              InputProps={{ ...params.InputProps }}
                              placeholder="Select Template Enbale Step"
                              name="payment_template_enabled"
                            />
                          )}
                        />
                      </Grid>
                    )}
                    <Grid item md={5}>
                      <Button
                        variant="contained"
                        style={{ marginRight: "2em" }}
                        color="primary"
                        onClick={() => {
                          if (this.state.editWhatsappPaySlabs) {
                            const vl = this.verifyJSON(
                              this.state.whatsappPaySlabs
                            );
                            if (vl)
                              this.setState({
                                editWhatsappPaySlabs: false,
                              });
                          } else {
                            this.setState({
                              editWhatsappPaySlabs: true,
                            });
                          }
                        }}
                      >
                        {this.state.editWhatsappPaySlabs ? "Verify" : "Edit"}
                      </Button>
                      <Button
                        onClick={this.updatePaymentSlabs}
                        variant="contained"
                        color="primary"
                      >
                        Update
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Min Allowed Balance
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Current Allowance - {`${template.currency} `}
                    {template.minAllowedBalance
                      ? template.minAllowedBalance / 100000
                      : 0}
                  </Typography>
                  <Box my={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          style={{
                            width: "100%",
                            border: "1px solid ",
                            background: "white",
                            marginRight: 10,
                          }}
                          name="minAllowedBalance"
                          type="number"
                          onChange={this.handleInput}
                          value={this.state.minAllowedBalance}
                        />
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.updateMinAllowedBalance}
                        >
                          Update Min Allowed Balance
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Box>
            </fieldset>
          );
        },
      },
      {
        label: "Plan Management",
        key: "planManagement",
        render: () => {
          const hasWriteAccess = verifySubRouteAccess(
            subRoutes,
            "planManagement",
            "write"
          );
          return (
            <Box py={2} px={2} my={2} className={classes.outerContainer}>
              <Box py={2} px={2} my={2} className={classes.container}>
                <PlanFamily
                  agent={this.props.agent}
                  assistant={template}
                  hasWriteAccess={hasWriteAccess}
                  showSuccessMessage={(alertMsg) =>
                    this.setState({
                      alert: true,
                      alertMsg,
                      alertSeverity: "success",
                    })
                  }
                  showErrorMessage={(alertMsg) =>
                    this.setState({
                      alert: true,
                      alertMsg,
                      alertSeverity: "error",
                    })
                  }
                />
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Box py={2} px={2} my={2} className={classes.container}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Active Plan
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {displayActivePlan}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box py={2} px={2} my={2} className={classes.container}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Plan Duration
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {template.planDuration}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          );
        },
      },
      {
        label: "Flows",
        key: "flows",
        render: () => {
          const hasWriteAccess = verifySubRouteAccess(
            subRoutes,
            "flows",
            "write"
          );
          return (
            <fieldset
              disabled={!hasWriteAccess}
              style={{ border: "none", padding: 0, margin: 0 }}
            >
              <Box py={2} px={2} my={2} className={classes.outerContainer}>
                <Box
                  py={2}
                  px={2}
                  my={2}
                  className={classes.container}
                  style={{ display: "flex" }}
                >
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Flow Update
                  </Typography>
                  <Box
                    my={2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Grid item xs={2}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Change Flow Status
                      </Typography>

                      <Switch
                        checked={template?.flowConfiguration?.isEnabled}
                        onChange={this.enableFlow}
                        name="flowEnabled"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Enable Order Flow
                      </Typography>

                      <Switch
                        checked={template?.isOrderFlowEnabled}
                        onChange={this.enableFlowOrderFlow}
                        name="flowEnabled"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        No. of flow will be created
                      </Typography>
                      <TextField
                        name="flowCount"
                        value={this.state?.flowConfiguration?.flowCount ?? 0}
                        onChange={this.handleFlowConfigurationInput}
                        type="number"
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                        }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        No. of active flow at a time
                      </Typography>
                      <TextField
                        name="activeFlowCount"
                        value={
                          this.state?.flowConfiguration?.activeFlowCount ?? 0
                        }
                        onChange={this.handleFlowConfigurationInput}
                        type="number"
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                        }}
                      />
                    </Grid>
                  </Box>
                  <Grid item xs={12}>
                    <Button
                      onClick={this.updateFlowObject}
                      variant="contained"
                      color="primary"
                    >
                      Update
                    </Button>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Flow Transfer
                  </Typography>
                  <TextField
                    style={{
                      width: "30%",
                      border: "1px solid ",
                      background: "white",
                      marginRight: "8px",
                    }}
                    disabled={!template?.flowConfiguration?.isEnabled}
                    name="flowId"
                    onChange={this.handleFlowTransferId}
                    placeholder="Enter FlowId"
                    value={this.state.transferFlowId}
                    required
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!this.state.transferFlowId}
                    onClick={() => this.handleFlowTransfer(false)}
                    style={{
                      marginRight: "8px",
                    }}
                  >
                    Copy flow
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!this.state.transferFlowId}
                    onClick={() => this.handleFlowTransfer(true)}
                  >
                    Transfer flow
                  </Button>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Box
                    my={2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Grid item xs={2}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Enable Delay
                      </Typography>

                      <Switch
                        checked={template?.flowConfiguration?.delayEnabled}
                        onChange={this.handleDelayEnabled}
                        name="delayEnabled"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Trial claimed
                      </Typography>

                      <Switch
                        checked={template?.flowConfiguration?.isTrialClaimed}
                        onChange={this.handleIsTrialClaimed}
                        name="trialClaimed"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Enable TimeOut
                      </Typography>

                      <Switch
                        checked={template?.flowConfiguration?.timeoutEnabled}
                        onChange={this.handleTimeoutEnabled}
                        name="enableTimeout"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Enable Multi Non Aisensy Ads
                      </Typography>

                      <Switch
                        checked={
                          template?.flowConfiguration?.multiNonAisensyAds
                        }
                        onChange={this.handleNonMultiAisensyAds}
                        name="enableTimeout"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Disable Shopify Default Link
                      </Typography>

                      <Switch
                        checked={
                          !!template?.flowConfiguration?.skipDefaultOrderFlow
                        }
                        onChange={this.handleSkipDefaultOrderFlow}
                        name="skipDefaultOrderFlow"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Grid>
                  </Box>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <AiMessagesPanel
                    assistantDetails={template}
                    onSnackbar={(msg, severity) =>
                      this.setState({
                        alert: true,
                        alertMsg: msg,
                        alertSeverity: severity,
                      })
                    }
                  />
                </Box>
              </Box>
            </fieldset>
          );
        },
      },
      {
        label: "Dev Area",
        key: "devArea",
        render: () => {
          const hasWriteAccess = verifySubRouteAccess(
            subRoutes,
            "devArea",
            "write"
          );
          const hasMessageEncryptionAccess = !!subRoutes
            ?.find((e) => e.label === "devArea")
            ?.actions?.includes("sendMessageEncryption");
          const hasCustomWebhookConfigAccess = !!subRoutes
            ?.find((e) => e.label === "devArea")
            ?.actions?.includes("customWebhookConfig");
          return (
            <Box py={2} px={2} my={2} className={classes.outerContainer}>
              <fieldset
                disabled={!hasWriteAccess}
                style={{ border: "none", padding: 0, margin: 0 }}
              >
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Direct API -{" "}
                    {template?.directApikey ? "Enabled" : "Disabled"}
                  </Typography>

                  <Switch
                    checked={!!template?.directApikey}
                    onChange={
                      template?.directApikey
                        ? this.disableDirectApi
                        : this.enableDirectApi
                    }
                    inputProps={{ "aria-label": "secondary checkbox" }}
                  />

                  <Typography variant="body2" gutterBottom>
                    To enable direct APIs for Project for testing purpose, click
                    on "Toggle" button above.
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    To generate Refresh token and Access Token, fill the fields
                    below and click on "Generate Refresh and Access Token"
                    button.
                  </Typography>

                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={3}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Username
                      </Typography>
                      <TextField
                        name="username"
                        value={this.state?.directApiCredentials?.username}
                        onChange={(e) =>
                          this.setState({
                            directApiCredentials: {
                              ...this.state.directApiCredentials,
                              username: e.target.value,
                            },
                          })
                        }
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                        }}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Password
                      </Typography>
                      <TextField
                        name="password"
                        type="password"
                        value={this.state?.directApiCredentials?.passoword}
                        onChange={(e) =>
                          this.setState({
                            directApiCredentials: {
                              ...this.state.directApiCredentials,
                              password: e.target.value,
                            },
                          })
                        }
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Box mt={4}>
                        <Button
                          onClick={() => this.enableDirectApi("token")}
                          variant="contained"
                          color="primary"
                        >
                          Generate Refresh & Access Token
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>

                  {this.state.directApiCredentials?.refreshToken && (
                    <Grid item xs={12}>
                      <pre
                        style={{
                          background: "rgb(240, 240, 240)",
                          padding: 16,
                          borderRadius: 8,
                          marginTop: 16,
                          "overflow-x": "scroll",
                        }}
                      >
                        {JSON.stringify(
                          {
                            refreshToken:
                              this.state.directApiCredentials.refreshToken,
                            accessToken:
                              this.state.directApiCredentials.accessToken,
                          },
                          null,
                          2
                        )}
                      </pre>
                    </Grid>
                  )}
                </Box>
              </fieldset>
              {hasMessageEncryptionAccess && (
              <fieldset
                disabled={!hasWriteAccess}
                style={{ border: "none", padding: 0, margin: 0 }}
              >
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Project API Encryption
                    {this.state.messageEncryption.exists
                      ? ` — Configured (${
                          this.state.messageEncryption
                            .existingEncryptionType === "body"
                            ? "Request Body & Query"
                            : "Message Number"
                        } / docId: ${
                          this.state.messageEncryption.docId
                        } / ${this.state.messageEncryption.existingAlgorithm})`
                      : " — Not configured"}
                  </Typography>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Encryption Mode
                      </Typography>
                      {[
                        {
                          value: "number",
                          label: "Message Number",
                          detail: "number field only",
                        },
                        {
                          value: "body",
                          label: "Request Body & Query",
                          detail: "whole payload, encrypted response",
                        },
                      ].map((opt) => (
                        <label
                          key={opt.value}
                          style={{ marginRight: 20, display: "inline-block" }}
                        >
                          <input
                            type="radio"
                            name="projectEncryptionType"
                            disabled={this.state.messageEncryption.exists}
                            checked={
                              this.state.messageEncryption.encryptionType ===
                              opt.value
                            }
                            onChange={() =>
                              this.setState({
                                messageEncryption: {
                                  ...this.state.messageEncryption,
                                  encryptionType: opt.value,
                                  // Reset the algorithm: the two modes have
                                  // different valid sets, so a stale value here
                                  // would be rejected by the API.
                                  algorithm:
                                    opt.value === "body"
                                      ? "aes-256-gcm"
                                      : "aes-256-cbc",
                                  iv: "",
                                },
                              })
                            }
                          />{" "}
                          <strong>{opt.label}</strong> — {opt.detail}
                        </label>
                      ))}
                      {this.state.messageEncryption.exists && (
                        <Typography
                          variant="body2"
                          style={{ color: "#666", marginTop: 4 }}
                        >
                          Delete this config to switch modes.
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={3}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Algorithm
                      </Typography>
                      <select
                        value={this.state.messageEncryption.algorithm}
                        onChange={(e) =>
                          this.setState({
                            messageEncryption: {
                              ...this.state.messageEncryption,
                              algorithm: e.target.value,
                              iv: e.target.value.endsWith("-ecb")
                                ? ""
                                : this.state.messageEncryption.iv,
                            },
                          })
                        }
                        style={{ width: "100%", padding: 8 }}
                      >
                        {this.encryptionAlgorithmsFor(
                          this.state.messageEncryption.encryptionType
                        ).map((alg) => (
                          <option key={alg} value={alg}>
                            {alg}
                            {alg.includes("-gcm") ? " · recommended" : ""}
                          </option>
                        ))}
                      </select>
                    </Grid>
                    <Grid item xs={9}>
                      <label style={{ marginRight: 16 }}>
                        <input
                          type="radio"
                          name="messageEncryptionMode"
                          checked={
                            this.state.messageEncryption.mode === "custom"
                          }
                          onChange={() =>
                            this.setState({
                              messageEncryption: {
                                ...this.state.messageEncryption,
                                mode: "custom",
                              },
                            })
                          }
                        />
                        {/* Body mode stores no IV — the client sends a fresh one
                            in every request — so only number mode takes one. */}
                        {this.state.messageEncryption.encryptionType === "body"
                          ? "Provide custom secret"
                          : "Provide custom IV & secret"}
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="messageEncryptionMode"
                          checked={
                            this.state.messageEncryption.mode === "random"
                          }
                          onChange={() =>
                            this.setState({
                              messageEncryption: {
                                ...this.state.messageEncryption,
                                mode: "random",
                              },
                            })
                          }
                        />
                        Generate random
                      </label>
                    </Grid>
                  </Grid>

                  {this.state.messageEncryption.mode === "custom" && (
                    <>
                      <Box mt={1}>
                        <label style={{ marginRight: 16 }}>
                          <input
                            type="radio"
                            name="messageEncryptionInputFormat"
                            checked={
                              this.state.messageEncryption.inputFormat === "hex"
                            }
                            onChange={() =>
                              this.setState({
                                messageEncryption: {
                                  ...this.state.messageEncryption,
                                  inputFormat: "hex",
                                },
                              })
                            }
                          />
                          Hex
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="messageEncryptionInputFormat"
                            checked={
                              this.state.messageEncryption.inputFormat === "utf8"
                            }
                            onChange={() =>
                              this.setState({
                                messageEncryption: {
                                  ...this.state.messageEncryption,
                                  inputFormat: "utf8",
                                },
                              })
                            }
                          />
                          Raw / UTF-8 string (Java-style)
                        </label>
                      </Box>
                      <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        style={{ marginTop: 8 }}
                      >
                        <Grid item xs={6}>
                          <Typography variant="h5" paragraph noWrap={false}>
                            {this.state.messageEncryption.inputFormat === "utf8"
                              ? "Secret (raw bytes)"
                              : "Secret (hex)"}
                          </Typography>
                          <TextField
                            value={this.state.messageEncryption.secret}
                            placeholder={(() => {
                              const keyBytes =
                                this.state.messageEncryption.algorithm.includes(
                                  "128"
                                )
                                  ? 16
                                  : this.state.messageEncryption.algorithm.includes(
                                        "192"
                                      )
                                    ? 24
                                    : 32;
                              return this.state.messageEncryption.inputFormat ===
                                "utf8"
                                ? `${keyBytes} chars (raw bytes)`
                                : `${keyBytes * 2} hex chars`;
                            })()}
                            onChange={(e) =>
                              this.setState({
                                messageEncryption: {
                                  ...this.state.messageEncryption,
                                  secret: e.target.value,
                                },
                              })
                            }
                            style={{
                              width: "100%",
                              border: "1px solid",
                              background: "white",
                            }}
                          />
                        </Grid>
                        {this.state.messageEncryption.encryptionType !==
                          "body" &&
                          !this.state.messageEncryption.algorithm.endsWith(
                            "-ecb"
                          ) && (
                          <Grid item xs={6}>
                            <Typography variant="h5" paragraph noWrap={false}>
                              {this.state.messageEncryption.inputFormat ===
                              "utf8"
                                ? "IV (raw bytes)"
                                : "IV (hex)"}
                            </Typography>
                            <TextField
                              value={this.state.messageEncryption.iv}
                              placeholder={
                                this.state.messageEncryption.inputFormat ===
                                "utf8"
                                  ? "16 chars (raw bytes)"
                                  : "32 hex chars"
                              }
                              onChange={(e) =>
                                this.setState({
                                  messageEncryption: {
                                    ...this.state.messageEncryption,
                                    iv: e.target.value,
                                  },
                                })
                              }
                              style={{
                                width: "100%",
                                border: "1px solid",
                                background: "white",
                              }}
                            />
                          </Grid>
                        )}
                      </Grid>
                    </>
                  )}

                  {this.state.messageEncryption.encryptionType === "body" && (
                    <>
                      <Box mt={1}>
                        <Typography
                          variant="body2"
                          style={{ color: "#1976d2", cursor: "pointer" }}
                          onClick={() =>
                            this.setState({
                              messageEncryption: {
                                ...this.state.messageEncryption,
                                showAdvanced:
                                  !this.state.messageEncryption.showAdvanced,
                              },
                            })
                          }
                        >
                          {this.state.messageEncryption.showAdvanced
                            ? "▾"
                            : "▸"}{" "}
                          Advanced
                        </Typography>
                        {this.state.messageEncryption.showAdvanced && (
                          <Box mt={1}>
                            <Typography variant="body2">
                              Replay window (seconds)
                            </Typography>
                            <TextField
                              type="number"
                              value={this.state.messageEncryption.skewSeconds}
                              inputProps={{
                                min:
                                  this.state.messageEncryption.capabilities?.skew
                                    ?.min || 60,
                                max:
                                  this.state.messageEncryption.capabilities?.skew
                                    ?.max || 600,
                              }}
                              onChange={(e) =>
                                this.setState({
                                  messageEncryption: {
                                    ...this.state.messageEncryption,
                                    // Digits only: the number input still lets a
                                    // minus sign through, and a negative window
                                    // is meaningless.
                                    skewSeconds: e.target.value.replace(
                                      /[^0-9]/g,
                                      ""
                                    ),
                                  },
                                })
                              }
                              style={{
                                width: 120,
                                border: "1px solid",
                                background: "white",
                              }}
                            />
                            <Typography
                              variant="body2"
                              style={{ color: "#666", marginTop: 4 }}
                            >
                              {this.state.messageEncryption.capabilities?.skew
                                ?.min || 60}
                              –
                              {this.state.messageEncryption.capabilities?.skew
                                ?.max || 600}
                              s. Widen only for drifting clocks.
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </>
                  )}

                  <Box mt={2}>
                    {!this.state.messageEncryption.exists && (
                      <Button
                        onClick={this.saveMessageEncryption}
                        variant="contained"
                        color="primary"
                        style={{ marginRight: 8 }}
                      >
                        Save Configuration
                      </Button>
                    )}
                    {this.state.messageEncryption.exists && (
                      <>
                        <Button
                          onClick={this.rotateMessageEncryption}
                          variant="contained"
                          color="primary"
                          style={{ marginRight: 8 }}
                        >
                          Rotate
                        </Button>
                        <Button
                          onClick={this.deleteMessageEncryption}
                          variant="contained"
                          color="secondary"
                        >
                          Delete
                        </Button>
                      </>
                    )}
                  </Box>

                  {this.state.messageEncryption.lastGenerated && (
                    <>
                      <Typography
                        variant="body2"
                        style={{
                          color: "#c62828",
                          marginTop: 16,
                          fontWeight: "bold",
                        }}
                      >
                        ⚠ Shown once. Copy and hand over through a secure
                        channel — these cannot be retrieved again, only rotated.
                      </Typography>
                      <pre
                        style={{
                          background: "rgb(240, 240, 240)",
                          padding: 16,
                          borderRadius: 8,
                          marginTop: 8,
                          overflowX: "scroll",
                        }}
                      >
                        {JSON.stringify(
                          this.encryptionHandoff(
                            this.state.messageEncryption.lastGenerated
                          ),
                          null,
                          2
                        )}
                      </pre>
                    </>
                  )}
                </Box>
              </fieldset>
              )}
              {!this.isPartnerOwnedProject() && (
              <fieldset
                disabled={!hasWriteAccess}
                style={{ border: "none", padding: 0, margin: 0 }}
              >
                <Box py={2} px={2} my={2} className={classes.itemBox}>
                  <Box className={classes.itemContent}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ fontWeight: "bold" }}
                    >
                      Integration Opt-in / Opt-out Sync
                    </Typography>
                    <Switch
                      name="integrationOptSync"
                      checked={!!template?.specialAccess?.integrationOptSync}
                      onChange={this.integrationOptSync}
                      inputProps={{ "aria-label": "integration opt sync" }}
                    />
                  </Box>
                  <Typography variant="body2" color="textSecondary">
                    Lets the project sync contact opt-in / opt-out to MoEngage
                    from the MoEngage integration settings page.
                  </Typography>
                </Box>
              </fieldset>
              )}
              {hasCustomWebhookConfigAccess && (
              <fieldset
                disabled={!hasWriteAccess}
                style={{ border: "none", padding: 0, margin: 0 }}
              >
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Custom Webhook Config
                  </Typography>
                  {this.state.customWebhookConfig.exists &&
                  !this.state.customWebhookConfig.rotateMode ? (
                    <Box mt={1}>
                      <Typography variant="body2" gutterBottom>
                        Status: ● Configured ({this.state.customWebhookConfig.url})
                      </Typography>
                      <Box mt={1} display="flex" style={{ gap: 8 }}>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() =>
                            this.setState({
                              customWebhookConfig: {
                                ...this.state.customWebhookConfig,
                                rotateMode: true,
                              },
                            })
                          }
                        >
                          Rotate
                        </Button>
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={this.deleteCustomWebhookConfig}
                        >
                          Delete
                        </Button>
                      </Box>
                    </Box>
                  ) : (
                    <Box mt={1}>
                      <Typography variant="body2" gutterBottom>
                        Status: ○{" "}
                        {this.state.customWebhookConfig.exists
                          ? "Configured (rotating)"
                          : "Not configured"}
                      </Typography>
                      <TextField
                        type="text"
                        placeholder="URL"
                        value={this.state.customWebhookConfig.url_input}
                        onChange={(e) =>
                          this.setState({
                            customWebhookConfig: {
                              ...this.state.customWebhookConfig,
                              url_input: e.target.value,
                            },
                          })
                        }
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginTop: 8,
                        }}
                      />
                      <TextField
                        type="text"
                        placeholder="Client ID"
                        value={this.state.customWebhookConfig.clientId}
                        onChange={(e) =>
                          this.setState({
                            customWebhookConfig: {
                              ...this.state.customWebhookConfig,
                              clientId: e.target.value,
                            },
                          })
                        }
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginTop: 8,
                        }}
                      />
                      <TextField
                        type="password"
                        placeholder="API Key"
                        value={this.state.customWebhookConfig.apiKey}
                        onChange={(e) =>
                          this.setState({
                            customWebhookConfig: {
                              ...this.state.customWebhookConfig,
                              apiKey: e.target.value,
                            },
                          })
                        }
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginTop: 8,
                        }}
                      />
                      <Box mt={2} display="flex" style={{ gap: 8 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={
                            this.state.customWebhookConfig.rotateMode
                              ? this.rotateCustomWebhookConfig
                              : this.saveCustomWebhookConfig
                          }
                        >
                          {this.state.customWebhookConfig.rotateMode
                            ? "Save (Rotate)"
                            : "Save"}
                        </Button>
                        {this.state.customWebhookConfig.rotateMode && (
                          <Button
                            variant="outlined"
                            onClick={() =>
                              this.setState({
                                customWebhookConfig: {
                                  ...this.state.customWebhookConfig,
                                  rotateMode: false,
                                  url_input: "",
                                  clientId: "",
                                  apiKey: "",
                                },
                              })
                            }
                          >
                            Cancel
                          </Button>
                        )}
                      </Box>
                    </Box>
                  )}
                </Box>
              </fieldset>
              )}
              <fieldset
                disabled={!hasWriteAccess}
                style={{ border: "none", padding: 0, margin: 0 }}
              >
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update Direct API Webhook URL
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    Please note that after updating the webhook URL, PLATFORM
                    will not save any information related to this assistant,
                    i.e: Messages, Templates
                  </Typography>
                  <Typography
                    variant="body2"
                    gutterBottom
                    style={{
                      fontFamily: "monospace",
                    }}
                  >
                    Events: Message Status, Template Status, etc.
                  </Typography>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                      <TextField
                        type="text"
                        placeholder="Enter Webhook URL"
                        name="directApiWebookUrl"
                        onChange={this.handleChange}
                        value={this.state.directApiWebookUrl}
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                          marginRight: 10,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={this.updateWebhook}
                        >
                          Update Webhook
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </fieldset>
              <fieldset
                disabled={!hasWriteAccess}
                style={{ border: "none", padding: 0, margin: 0 }}
              >
                <Box
                  py={2}
                  px={2}
                  my={2}
                  className={classes.container}
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                  }}
                >
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Update click tracking
                      </Typography>

                      <Switch
                        checked={template?.clickTrackingEnabled}
                        onChange={this.enableClickTracking}
                        name="checkedA"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  {template?.partnerId &&
                    template?.partnerId !== "627ea4876340e14cf7081778" && (
                      <Box py={2} px={2} my={2} className={classes.itemBox}>
                        <Box className={classes.itemContent}>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ fontWeight: "bold" }}
                          >
                            Update webhook for partner project
                          </Typography>
                          <Switch
                            checked={this.state?.webhookAddon}
                            onChange={this.updateWebhookAddon}
                            name="webhooks"
                            inputProps={{
                              "aria-label": "secondary checkbox",
                            }}
                          />
                        </Box>
                      </Box>
                    )}
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Update download report
                      </Typography>
                      <Switch
                        checked={template?.campaignReportingAllowed}
                        onChange={this.campaignReportingAllowed}
                        name="checkedA"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Update Campaign analytics
                      </Typography>
                      <Switch
                        checked={this.state.webhookAddon}
                        onChange={this.enableCampaignAnalytics}
                        name="campaignAnalytics"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Update Campaign scheduling
                      </Typography>
                      <Switch
                        checked={template?.campaignSchedulingEnabled}
                        onChange={this.enableCampaignScheduling}
                        name="campaignScheduling"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Ecom update
                      </Typography>
                      <Switch
                        checked={template?.isEcom}
                        onChange={this.enableEcom}
                        name="isEcom"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Enable Meta Ads Advance Targetting
                      </Typography>
                      <Switch
                        checked={template?.metaAdvanceTargetingEnabled}
                        onChange={this.enableMetaAdvanceTargeting}
                        name="metaAdvanceTargetingEnabled"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Update Filter Freeze
                      </Typography>
                      <Switch
                        checked={template?.filterFreezeEnabled}
                        onChange={this.enableFilterFreeze}
                        name="filterFreeze"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Update Chat Searchable
                      </Typography>
                      <Switch
                        checked={template?.chatSearchEnabled}
                        onChange={this.enableChatSearchable}
                        name="chatSearchable"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                      {/* {this.state.isChatScriptingRunning && (
                <CircularProgress
                  size={20}
                  style={{ marginRight: "10px" }}
                />
              )} */}
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Update CSV Schedule Campaign
                      </Typography>
                      <Switch
                        name="csvScheduleEnabled"
                        checked={template?.csvScheduleEnabled}
                        onChange={this.enableCSVScheduleEnabled}
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Update Opt-in/out download report
                      </Typography>
                      <Switch
                        name="optReportingEnabled"
                        checked={template?.optReportingEnabled}
                        onChange={this.optReporting}
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Campaign Schedule Report
                      </Typography>
                      <Switch
                        name="campaignScheduleReport"
                        checked={template?.specialAccess?.campaignScheduleReport}
                        onChange={this.campaignScheduleReport}
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Campaign User Report
                      </Typography>
                      <Switch
                        name="campaignUserReport"
                        checked={template?.specialAccess?.campaignUserReport}
                        onChange={this.campaignUserReport}
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Enable Birthday Campaign
                      </Typography>
                      <Switch
                        checked={this.state.birthdayCampaignEnabled}
                        onChange={this.enableBirthdayCampaign}
                        name="filterFreeze"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Enable Connect Flows
                      </Typography>
                      <Switch
                        checked={this.state.connectFlowsEnabled}
                        onChange={this.enableConnectFlows}
                        name="filterFreeze"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Skip user balance check before sending campaign
                      </Typography>
                      <Box
                        my={2}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Switch
                          name="skipBalanceCheck"
                          checked={template?.skipBalanceCheck}
                          onChange={this.skipBalanceCheck}
                          inputProps={{
                            "aria-label": "secondary checkbox",
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>
                  <Box py={2} px={2} my={2} className={classes.itemBox}>
                    <Box className={classes.itemContent}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Show Pre-verified numbers in ES
                      </Typography>
                      <Switch
                        checked={template?.virtualNumberConfig?.showPreVerified}
                        onChange={this.togglePreVerifiedAccess}
                        name="showPreVerified"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </Box>
                  </Box>
                </Box>
              </fieldset>
              <fieldset
                disabled={!hasWriteAccess}
                style={{ border: "none", padding: 0, margin: 0 }}
              >
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold", marginBottom: "8px" }}
                  >
                    Add Special Access
                  </Typography>
                  <Grid item xs={5} alignItems="center">
                    <Autocomplete
                      value={this.state.selectedType}
                      options={["String", "Object", "Boolean"]}
                      onChange={(event, newValue) =>
                        this.setState({ selectedType: newValue })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          style={{
                            border: "1px solid ",
                            background: "white",
                            marginRight: 10,
                            width: "365px",
                            marginBottom: "8px",
                          }}
                          InputProps={{ ...params.InputProps }}
                          placeholder="Select value type"
                          name="valueType"
                        />
                      )}
                    />
                  </Grid>
                  <TextField
                    style={{
                      width: "30%",
                      border: "1px solid ",
                      background: "white",
                      marginRight: "8px",
                    }}
                    name="paymentRemarks"
                    onChange={this.handleSpecialAcessKey}
                    placeholder="Enter key"
                    value={this.state.specialAccessKey}
                    required
                  />
                  <TextField
                    style={{
                      width: "30%",
                      border: "1px solid ",
                      background: "white",
                      marginRight: "8px",
                    }}
                    name="paymentRemarks"
                    onChange={this.handleSpecialAcessValue}
                    placeholder="Enter value"
                    value={this.state.specialAccessValue}
                    required
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={
                      !this.state.specialAccessKey ||
                      !this.state.specialAccessValue
                    }
                    onClick={this.addSpecialAccess}
                  >
                    Add
                  </Button>
                </Box>
              </fieldset>
              <Box py={2} px={2} my={2} className={classes.container}>
                <Box>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Existing Special Access
                  </Typography>
                  <Grid container justifyContent="center">
                    <Grid item>
                      <Button
                        color="primary"
                        onClick={() =>
                          this.setState({
                            showSpecialAccess: !this.state.showSpecialAccess,
                          })
                        }
                      >
                        {this.state.showSpecialAccess ? "Hide" : "Show"}{" "}
                      </Button>
                    </Grid>
                  </Grid>
                  <Collapse in={this.state.showSpecialAccess}>
                    <pre contentEditable={true} className={classes.codeBox}>
                      {this.state.existingSpecialAccess
                        ? JSON.stringify(
                          this.state.existingSpecialAccess,
                          null,
                          2
                        )
                        : ""}
                    </pre>
                  </Collapse>
                </Box>
              </Box>
              <fieldset
                disabled={!hasWriteAccess}
                style={{ border: "none", padding: 0, margin: 0 }}
              >
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{
                      fontWeight: "bold",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    Private App
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleDialogOpen}
                    >
                      Create Private App
                    </Button>
                  </Typography>
                  <Dialog
                    open={this.state.isDialogOpen}
                    onClose={this.handleDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Are you sure you want to create a private app for this
                        assistant?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.handleDialogClose} color="primary">
                        Cancel
                      </Button>
                      <Button
                        onClick={() => {
                          this.handleDialogClose();
                          this.createPrivateApp();
                        }}
                        color="primary"
                      >
                        Yes
                      </Button>
                    </DialogActions>
                  </Dialog>

                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    <ul>
                      <li>
                        Ensure there is only one private app per project Id.
                      </li>
                      <li>
                        Click Update Webhook to create a new webhook if none
                        exists. If a webhook already exists, it will be updated.
                      </li>
                      <li>
                        Before clicking Update Webhook, ensure you've entered
                        the webhook URL and selected the desired webhook topics.
                      </li>
                      <li>
                        Webhooks the client configured themselves from the
                        Developer Hub are listed in the "Dev Hub Webhooks"
                        block. They have no private app, but the URL and topics
                        can be updated from here just like any other webhook.
                      </li>
                    </ul>
                  </Typography>
                  {this.state.isLoading ? (
                    <CircularProgress />
                  ) : (
                    <div>
                      {this.state.privateApps.map((privateApp, index) => (
                        <div
                          key={index}
                          style={{
                            backgroundColor: "white",
                            padding: "16px",
                            marginBottom: "16px",
                            borderRadius: "8px",
                          }}
                        >
                          {privateApp.isDevHub ? (
                            <Typography
                              variant="body1"
                              style={{ marginBottom: "20px" }}
                            >
                              Dev Hub Webhooks — configured by the client from
                              the dashboard, not linked to any private app
                            </Typography>
                          ) : (
                            <>
                              <Typography
                                variant="body1"
                                style={{ marginBottom: "20px" }}
                              >
                                Private App Id: {privateApp.privateAppId}
                              </Typography>

                              <Typography variant="body2" gutterBottom>
                                ** API Key shown here will be lost after page
                                refresh **
                              </Typography>
                              <Grid
                                container
                                spacing={2}
                                alignItems="center"
                                style={{ marginBottom: "10px" }}
                              >
                                <Grid item xs={6}>
                                  <TextField
                                    disabled={true}
                                    type="text"
                                    placeholder="Click Regenerate to get a new key"
                                    fullWidth
                                    value={privateApp.apiPassword}
                                    InputProps={{
                                      endAdornment: (
                                        <Tooltip title="Click to copy API Key">
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              this.copyToClipboard(
                                                privateApp.apiPassword
                                              )
                                            }
                                          >
                                            <FileCopyIcon fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                      ),
                                    }}
                                  />
                                </Grid>
                                <Grid item>
                                  <div>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      onClick={() => this.handleClickOpen(index)}
                                    >
                                      Regenerate
                                    </Button>
                                    <Dialog
                                      open={
                                        this.state.regenerateConfirmOpen &&
                                        this.state.currentIndex === index
                                      }
                                      onClose={this.handleClose}
                                      aria-labelledby="alert-dialog-title"
                                      aria-describedby="alert-dialog-description"
                                    >
                                      <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                          Doing this will Regenerate the API
                                          key. Are you sure you want to
                                          continue?
                                        </DialogContentText>
                                      </DialogContent>
                                      <DialogActions>
                                        <Button
                                          onClick={this.handleClose}
                                          color="primary"
                                        >
                                          Cancel
                                        </Button>
                                        <Button
                                          onClick={() => {
                                            this.reGeneratePassword(
                                              this.state.currentIndex
                                            );
                                            this.handleClose();
                                          }}
                                          color="primary"
                                        >
                                          Yes
                                        </Button>
                                      </DialogActions>
                                    </Dialog>
                                  </div>
                                </Grid>
                              </Grid>
                            </>
                          )}
                          {privateApp.webhooks.map((webhook, webhookIndex) => (
                            <div
                              key={webhookIndex}
                              style={{
                                backgroundColor: "#f0f0f0",
                                padding: "16px",
                                marginBottom: "10px",
                                borderRadius: "8px",
                              }}
                            >
                              {webhook.sharedSecret && (
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  gap="12px"
                                  marginBottom="8px"
                                >
                                  <Typography variant="body1">
                                    Shared Secret: {webhook.sharedSecret}
                                  </Typography>
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      this.copyToClipboard(webhook.sharedSecret)
                                    }
                                    style={{
                                      padding: "6px",
                                    }}
                                  >
                                    <FileCopyIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              )}
                              {webhook.disabled && (
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  style={{
                                    marginBottom: "16px",
                                    gap: "8px",
                                    backgroundColor: "#F5B7BB",
                                    padding: "8px",
                                    borderRadius: "6px",
                                    width: "fit-content",
                                  }}
                                >
                                  <CloseOutlined color="#C82333" />
                                  <Typography variant="body1">
                                    This Webhook is disabled
                                    {webhook.disabledReason
                                      ? ` (${webhook.disabledReason})`
                                      : ""}
                                  </Typography>
                                </Box>
                              )}
                              {webhook.archived && (
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  style={{
                                    marginBottom: "16px",
                                    gap: "8px",
                                    backgroundColor: "#FFE680",
                                    padding: "8px",
                                    borderRadius: "6px",
                                    width: "fit-content",
                                  }}
                                >
                                  <WarningOutlined color="#E0A800" />
                                  <Typography variant="body1">
                                    This Webhook is archived
                                  </Typography>
                                </Box>
                              )}
                              {webhook.name && (
                                <Typography
                                  variant="body1"
                                  style={{ marginBottom: "8px" }}
                                >
                                  Name: {webhook.name}
                                </Typography>
                              )}
                              <Grid
                                container
                                spacing={2}
                                alignItems="center"
                                style={{ marginBottom: "10px" }}
                              >
                                <Grid item xs={6}>
                                  <TextField
                                    placeholder="Enter Webhook URL"
                                    type="text"
                                    fullWidth
                                    value={webhook.webhookUrl}
                                    onChange={(event) =>
                                      this.handleUrlChange(
                                        event,
                                        index,
                                        webhookIndex
                                      )
                                    }
                                    style={{
                                      border: "1px solid ",
                                      backgroundColor: "white",
                                    }}
                                  />
                                </Grid>
                                <Grid item>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={!webhook.webhookUrl}
                                    onClick={() =>
                                      this.createWebhook(index, webhookIndex)
                                    }
                                  >
                                    Update Webhook
                                  </Button>
                                </Grid>
                              </Grid>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  justifyContent: "space-between",
                                }}
                              >
                                {Webhook_Topics.map((topic) => (
                                  <FormControlLabel
                                    key={topic.id}
                                    control={
                                      <Checkbox
                                        checked={webhook.topicsArray.includes(
                                          topic.label
                                        )}
                                        onChange={() =>
                                          this.handleCheckboxChange(
                                            index,
                                            webhookIndex,
                                            topic.label
                                          )
                                        }
                                        color="primary"
                                      />
                                    }
                                    label={topic.label}
                                    style={{
                                      width: "30%",
                                      marginBottom: "5px",
                                    }}
                                  />
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  )}
                </Box>
              </fieldset>
              <Box py={2} px={2} my={2} className={classes.container}>
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ fontWeight: "bold" }}
                >
                  Assistant full details
                </Typography>
                <Grid container justifyContent="center">
                  <Grid item>
                    <Button
                      color="primary"
                      onClick={() =>
                        this.setState({
                          showCode: !this.state.showCode,
                        })
                      }
                    >
                      {this.state.showCode ? "Hide" : "Show"} Code
                    </Button>
                  </Grid>
                </Grid>
                <Collapse in={this.state.showCode}>
                  <pre contentEditable={true} className={classes.codeBox}>
                    {JSON.stringify(template, null, 2)}
                  </pre>
                </Collapse>
              </Box>
              <Box py={2} px={2} my={2} className={classes.container}>
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ fontWeight: "bold" }}
                >
                  Cached Assistant
                </Typography>
                <Grid container justifyContent="center">
                  <Grid item>
                    <Button
                      color="primary"
                      onClick={() =>
                        this.setState({
                          showCachedAssCode: !this.state.showCachedAssCode,
                        })
                      }
                    >
                      {this.state.showCachedAssCode ? "Hide" : "Show"} Code
                    </Button>
                  </Grid>
                </Grid>
                <Collapse in={this.state.showCachedAssCode}>
                  <pre contentEditable={true} className={classes.codeBox}>
                    {this.state.cachedAssistant
                      ? JSON.stringify(this.state.cachedAssistant, null, 2)
                      : ""}
                  </pre>
                </Collapse>
              </Box>
              {this.props.templates[this.props.templateIndex].partnerId ? (
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Cached Partner
                  </Typography>
                  <Grid container justifyContent="center">
                    <Grid item>
                      <Button
                        color="primary"
                        onClick={() =>
                          this.setState({
                            showCachedPartnerCode:
                              !this.state.showCachedPartnerCode,
                          })
                        }
                      >
                        {this.state.showCachedPartnerCode ? "Hide" : "Show"}{" "}
                        Code
                      </Button>
                    </Grid>
                  </Grid>
                  <Collapse in={this.state.showCachedPartnerCode}>
                    <pre contentEditable={true} className={classes.codeBox}>
                      {this.state.cachedPartner
                        ? JSON.stringify(this.state.cachedPartner, null, 2)
                        : ""}
                    </pre>
                  </Collapse>
                </Box>
              ) : (
                ""
              )}
            </Box>
          );
        },
      },
      {
        label: "Extras",
        key: "extras",
        render: () => {
          const hasWriteAccess = verifySubRouteAccess(
            subRoutes,
            "extras",
            "write"
          );
          return (
            <fieldset
              disabled={!hasWriteAccess}
              style={{ border: "none", padding: 0, margin: 0 }}
            >
              <Box py={2} px={2} my={2} className={classes.outerContainer}>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Grid container>
                    <Grid item xs={6}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Remaining Credit
                        <ul>
                          <li>
                            For v3, Keep the excessMac reading as New Plan will
                            reset it
                          </li>
                          <li>
                            Default currency in INR for Dollar Billing contact
                            developers
                          </li>
                          <li>Max Agents 5 for v3 pricing</li>
                          <li>35p template msg pricing for v3 pricing</li>
                          <li>
                            v3 monthly pricing & renewal can be done from here
                          </li>
                          <li>
                            v3 yearly plan can be added but can't be renewed
                            from here
                          </li>
                          <li>To upgrade monthly to yearly - Contact devs</li>
                        </ul>
                      </Typography>
                      <Typography variant="h5" paragraph noWrap={false}>
                        {template.remainingCredit / 100000}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} container spacing={2}>
                      <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          style={{ fontWeight: "bold" }}
                        >
                          Add Credit
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          name="remainingCredit"
                          value={this.state.remainingCredit}
                          onChange={this.handleInput}
                          type="number"
                          style={{
                            width: "100%",
                            border: "1px solid ",
                            background: "white",
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          style={{ fontWeight: "bold" }}
                        >
                          Change Plan
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Autocomplete
                          options={PLANS.map((option) => option)}
                          onChange={(e, value, reason) =>
                            this.handleAutoComplete("activePlan", value, reason)
                          }
                          value={template.activePlan}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className={classes.textField}
                              InputProps={{ ...params.InputProps }}
                              placeholder="Select plan"
                              style={{
                                border: "1px solid ",
                                background: "white",
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          onClick={this.updateCredit}
                          variant="contained"
                          color="primary"
                          disabled={template.partnerId}
                        >
                          Update
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    WhatsApp App Name - Enter name (default to{" "}
                    {isTenant ? tenantDetails.name : "AiSensy"})
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Number in use - {template.appName}
                  </Typography>
                  <Box my={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          style={{
                            width: "100%",
                            border: "1px solid ",
                            background: "white",
                            marginRight: 10,
                          }}
                          name="appName"
                          onChange={this.handleNumberInput}
                          value={this.state.appName}
                        />
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.updateAppName}
                        >
                          Update App Name
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    360 API Key (Do this at the end)
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    API Key in use - {template.apiKey360}
                  </Typography>
                  <Box my={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          style={{
                            width: "100%",
                            border: "1px solid ",
                            background: "white",
                            marginRight: 10,
                          }}
                          name="apiKey360"
                          onChange={this.handleNumberInput}
                          value={this.state.apiKey360}
                        />
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.updateApiKey}
                        >
                          Update Key
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Sync Template Msg ( for migration from GS to 360D only)
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.syncTemplateMsg}
                    >
                      Sync Template Messages
                    </Button>
                  </Typography>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Migrate Template Msg ( for migration of new clients only)
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.migrateTemplateMsg}
                    >
                      Migrate Template Messages
                    </Button>
                  </Typography>
                </Box>

                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Migrate Phone Number
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Mention the number to be migrated to this project
                  </Typography>
                  <Box
                    my={2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Grid item xs={5}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Phone Number - eg: 919419112345
                      </Typography>
                      <TextField
                        name="migrationNumber"
                        value={this.state.migrationNumber}
                        onChange={this.handleChange}
                        type="number"
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                        }}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <Typography variant="h5" paragraph noWrap={false}>
                        Source Project ID (Optional)
                      </Typography>
                      <TextField
                        name="srcAssistantId"
                        value={this.state.srcAssistantId}
                        onChange={this.handleChange}
                        style={{
                          width: "100%",
                          border: "1px solid ",
                          background: "white",
                        }}
                      />
                    </Grid>
                  </Box>
                  <Grid item xs={12}>
                    <Button
                      onClick={this.migratePhoneNumber}
                      variant="contained"
                      color="primary"
                    >
                      Update
                    </Button>
                  </Grid>
                </Box>
                {!template?.partnerId &&
                  template?.partnerId !== "627ea4876340e14cf7081778" && (
                    <Box py={2} px={2} my={2} className={classes.container}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Migrate Project to Partner
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        Transfer this project from{" "}
                        {isTenant ? tenantDetails.name : "AiSensy"} to the
                        Partner
                      </Typography>
                      <Box
                        my={2}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Grid item xs={4}>
                          <Typography variant="h5" paragraph noWrap={false}>
                            Enter the ID of the Partner
                          </Typography>
                          <TextField
                            name="partnerId"
                            value={this.state.partnerId}
                            onChange={this.handleChange}
                            style={{
                              width: "80%",
                              border: "1px solid ",
                              background: "white",
                            }}
                          />
                        </Grid>

                        <Grid item xs={4}>
                          <Typography variant="h5" paragraph noWrap={false}>
                            Plan(Required for Whitelabel Partner)
                          </Typography>
                          <Autocomplete
                            options={PARTNER_PLANS.map((option) => option)}
                            onChange={(e, value, reason) =>
                              this.handleAutoComplete(
                                "defaultPlan",
                                value,
                                reason
                              )
                            }
                            value={this.state.defaultPlan}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                className={classes.textField}
                                InputProps={{ ...params.InputProps }}
                                placeholder="Select Plan"
                                style={{
                                  border: "1px solid ",
                                  background: "white",
                                  marginRight: 10,
                                }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <Typography variant="h5" paragraph noWrap={false}>
                            Activation Date
                          </Typography>
                          <TextField
                            name="activationDate"
                            defaultValue={(
                              this.state.activationDate || moment()
                            ).format("YYYY-MM-DD")}
                            type="date"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            style={{
                              width: "80%",
                              border: "1px solid ",
                              background: "white",
                            }}
                            onChange={(e) =>
                              this.setState({
                                activationDate: moment(e.target.value),
                              })
                            }
                          />
                        </Grid>
                      </Box>
                      <Grid item xs={12}>
                        <Button
                          onClick={this.migrateProjectToPartner}
                          variant="contained"
                          color="primary"
                        >
                          Update
                        </Button>
                      </Grid>
                    </Box>
                  )}
                {template?.partnerId &&
                  template?.partnerId !== "627ea4876340e14cf7081778" && (
                    <Box py={2} px={2} my={2} className={classes.container}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Migrate Partner Project to{" "}
                        {isTenant ? tenantDetails.name : "AiSensy"}
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        Transfer this project of the partner to{" "}
                        {isTenant ? tenantDetails.name : "AiSensy"}
                      </Typography>
                      <Grid item xs={12}>
                        <Button
                          onClick={this.migratePartnerProjectToAisensy}
                          variant="contained"
                          color="primary"
                        >
                          Update
                        </Button>
                      </Grid>
                      <Dialog
                        open={this.state.migrateAllProjectsDialog}
                        onClose={this.closeMigrateAllProjectsDialog}
                        aria-labelledby="migrate-all-dialog-title"
                        aria-describedby="migrate-all-dialog-description"
                      >
                        <DialogTitle id="migrate-all-dialog-title">
                          Multiple Projects Found
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText id="migrate-all-dialog-description">
                            Multiple projects are associated with this business.
                            Would you like to migrate all linked projects?
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={this.closeMigrateAllProjectsDialog}
                            color="primary"
                          >
                            Close
                          </Button>
                          <Button
                            onClick={() =>
                              this.migratePartnerProjectToAisensy(true)
                            }
                            color="primary"
                            variant="contained"
                          >
                            Migrate All Linked Projects
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Box>
                  )}
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    gutterBottom
                    variant="body1"
                    style={{ fontWeight: "bold" }}
                  >
                    Migrate Templates
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Migrate Templates Across Projects
                  </Typography>
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Grid>
                      <TextField
                        name="migrateTemplatesFrom"
                        placeholder="Source Project Id"
                        onChange={this.handleNumberInput}
                        value={this.state.migrateTemplatesFrom}
                        style={{
                          width: "15rem",
                          border: "1px solid ",
                          background: "white",
                        }}
                      />
                    </Grid>
                    <Grid>
                      <Typography
                        gutterBottom
                        variant="body1"
                        style={{ fontWeight: "bold", margin: "0 1rem" }}
                      >
                        To
                      </Typography>
                    </Grid>
                    <Grid>
                      <TextField
                        name="migrateTemplatesTo"
                        onChange={this.handleNumberInput}
                        placeholder="Destination Project Id"
                        value={this.state.migrateTemplatesTo}
                        style={{
                          width: "15rem",
                          background: "white",
                          border: "1px solid ",
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: "1rem" }}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.migrateTemplates}
                    >
                      Migrate
                    </Button>
                  </Grid>
                </Box>

                {(this.props.templates[this.props.templateIndex]?.partnerId ===
                  "63fdbd4b136c0b191dcaafa7" ||
                  this.props.templates[this.props.templateIndex]?.partnerId ===
                    "690c53e87fa2c70d608d7d69") && (
                  <Box py={2} px={2} my={2} className={classes.container}>
                    <Typography
                      gutterBottom
                      variant="body1"
                      style={{ fontWeight: "bold" }}
                    >
                      Smartping Migration
                    </Typography>
                    <Grid item xs={12} style={{ marginTop: "1rem" }}>
                      {this.props.templates[this.props.templateIndex]?.partnerId ===
                        "63fdbd4b136c0b191dcaafa7" && (
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={() => this.initiateSmartpingMigration("BSP")}
                        >
                          Migrate TO BSP
                        </Button>
                      )}
                      {this.props.templates[this.props.templateIndex]?.partnerId ===
                        "690c53e87fa2c70d608d7d69" && (
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={() => this.initiateSmartpingMigration("TSP")}
                        >
                          Migrate TO TSP
                        </Button>
                      )}
                    </Grid>
                  </Box>
                )}

                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    gutterBottom
                    variant="body1"
                    style={{ fontWeight: "bold" }}
                  >
                    Enable CTWA Affiliate Funnel
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Please specify the affiliateId & the adId on AiSensy
                  </Typography>
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Grid>
                      <TextField
                        name="affiliateId"
                        placeholder="Affiliate Id"
                        onChange={(e) =>
                          this.handleObjectKeyInput("ctwaFunnel", e)
                        }
                        value={this.state.ctwaFunnel?.affiliateId}
                        style={{
                          width: "15rem",
                          border: "1px solid ",
                          background: "white",
                        }}
                      />
                    </Grid>
                    <Grid>
                      <Typography
                        gutterBottom
                        variant="body1"
                        style={{ fontWeight: "bold", margin: "0 1rem" }}
                      >
                        -
                      </Typography>
                    </Grid>
                    <Grid>
                      <TextField
                        name="adId"
                        onChange={(e) =>
                          this.handleObjectKeyInput("ctwaFunnel", e)
                        }
                        placeholder="Ad Id"
                        value={this.state.ctwaFunnel?.adId}
                        style={{
                          width: "15rem",
                          background: "white",
                          border: "1px solid ",
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: "1rem" }}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.enableCtwaFunnel}
                    >
                      Enable
                    </Button>
                  </Grid>
                </Box>

                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    gutterBottom
                    variant="body1"
                    style={{ fontWeight: "bold" }}
                  >
                    Get Campaign Error cURL
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Please specify the campaignId & the userNumber
                  </Typography>
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Grid>
                      <TextField
                        name="campaignId"
                        placeholder="Campaign ID"
                        onChange={(e) =>
                          this.handleObjectKeyInput("campaignErrorCurl", e)
                        }
                        value={this.state.campaignErrorCurl?.campaignId}
                        style={{
                          width: "15rem",
                          border: "1px solid ",
                          background: "white",
                        }}
                      />
                    </Grid>
                    <Grid>
                      <Typography
                        gutterBottom
                        variant="body1"
                        style={{ fontWeight: "bold", margin: "0 1rem" }}
                      >
                        -
                      </Typography>
                    </Grid>
                    <Grid>
                      <TextField
                        name="userNumber"
                        onChange={(e) =>
                          this.handleObjectKeyInput("campaignErrorCurl", e)
                        }
                        placeholder="User Number"
                        value={this.state.campaignErrorCurl?.userNumber}
                        style={{
                          width: "15rem",
                          background: "white",
                          border: "1px solid ",
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: "1rem" }}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.getCampaignErrorCurl}
                    >
                      Get cURL
                    </Button>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    gutterBottom
                    variant="body1"
                    style={{ fontWeight: "bold" }}
                  >
                    MM Lite Dashboard Lock
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Reset the MM Lite upgrade-popup lock for this project. Clears
                    the Redis key so the dashboard is no longer blocked; the
                    5-day countdown re-arms on the customer's next dashboard
                    visit.
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Current status: <b>{this.getMmliteLockStatusText()}</b>
                  </Typography>
                  <Grid item xs={12} style={{ marginTop: "1rem" }}>
                    <Button
                      color="default"
                      variant="contained"
                      onClick={this.checkMmliteLockStatus}
                      style={{ marginRight: "1rem" }}
                    >
                      Check Status
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.resetMmliteLock}
                    >
                      Reset MM Lite Lock
                    </Button>
                  </Grid>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    gutterBottom
                    variant="body1"
                    style={{ fontWeight: "bold" }}
                  >
                    {this.state.isDashboardLocked
                      ? "Unlock Dashboard"
                      : "Configure Dashboard"}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {this.state.isDashboardLocked
                      ? "Click on the below button to unlock the dashboard"
                      : "Click on the below button to lock the dashboard"}
                  </Typography>

                  <Grid item xs={12} style={{ marginTop: "1rem" }}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={
                        this.state.isDashboardLocked
                          ? this.handleUnlockDashboard
                          : this.openDashboardLockModal
                      }
                    >
                      {this.state.isDashboardLocked
                        ? "Unlock Dashboard"
                        : "Configure Dashboard"}
                    </Button>
                    {!this.state.isDashboardLocked &&
                      (this.state.dashboardLockConfig?.acknowledgeCount ?? 0) > 0 && (
                        <Typography

                          variant="body2"
                          style={{ color: "#d32f2f", marginTop: "0.5rem" }}
                        >
                          Previous Warning Limit Exhausted
                        </Typography>
                      )}
                  </Grid>
                </Box>

                {isGlobalAdmin(this.props.agent?.permissions) && (
                  <Box py={2} px={2} my={2} className={classes.container}>
                    <Typography
                      gutterBottom
                      variant="body1"
                      style={{ fontWeight: "bold" }}
                    >
                      Number Masking
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      Hides customer phone numbers and names from every non-owner
                      agent (power &lt; 2) in the selected scope.
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      New agents on this account are auto-masked:{" "}
                      <strong>
                        {this.state.accountMaskingEnabled ? "ON" : "OFF"}
                      </strong>
                    </Typography>

                    <RadioGroup
                      row
                      name="numberMaskingScope"
                      value={this.state.numberMaskingScope}
                      onChange={(e) =>
                        this.setState({ numberMaskingScope: e.target.value })
                      }
                    >
                      <FormControlLabel
                        value="project"
                        control={<Radio color="primary" />}
                        label="This project only"
                      />
                      <FormControlLabel
                        value="account"
                        control={<Radio color="primary" />}
                        label="Entire account"
                      />
                    </RadioGroup>

                    <Grid item xs={12} style={{ marginTop: "1rem" }}>
                      <Button
                        color="primary"
                        variant="contained"
                        disabled={this.state.numberMaskingInProgress}
                        onClick={() => this.updateNumberMasking(true)}
                      >
                        Enable Masking
                      </Button>
                      <Button
                        color="secondary"
                        variant="contained"
                        style={{ marginLeft: "1rem" }}
                        disabled={this.state.numberMaskingInProgress}
                        onClick={() => this.updateNumberMasking(false)}
                      >
                        Disable Masking
                      </Button>
                    </Grid>
                  </Box>
                )}
              </Box>
            </fieldset>
          );
        },
      },
      {
        label: "Integrations",
        key: "integrations",
        render: () => (
          <IntegrationsPanel
            assistantId={this.props.templates[this.props.templateIndex]?._id}
            onSnackbar={(msg, type) =>
              this.setState({ alertType: type, alertMsg: msg })
            }
          />
        ),
      },
      {
        label: "Logs",
        key: "logs",
        render: () => {
          const {
            webhookNamespace,
            webhookSubType,
            webhookStartTime,
            webhookEndTime,
            webhookFilterValues,
            webhookLogs,
            webhookLogsPage,
            webhookLogsHasMore,
            webhookLogsLoading,
            webhookLogsFetched,
            webhookFiltersOpen,
            applied,
          } = this.state;

          const getActiveFilterFields = () => {
            if (!webhookNamespace) return [];
            const nsFilters = WEBHOOK_NAMESPACE_FILTERS[webhookNamespace];
            if (!nsFilters) return [];
            if (webhookNamespace === "DirectApiWebhook") {
              return webhookSubType ? nsFilters[webhookSubType] || [] : [];
            }
            return nsFilters;
          };

          const activeFilterFields = getActiveFilterFields();

          const statusColor = (log) => {
            if (log.succededAt) return "#2E7D32";
            if (log.failedAt) return "#C62828";
            return "#F57F17";
          };

          return (
            <Box py={2} px={2} my={2} className={classes.outerContainer}>

              {/* ── E-COMMERCE APP STORE LOGS (Shopify / WooCommerce) ── */}
              <Grid container spacing={2}>
                {(template.ecomAppStore === "shopify" ||
                  template.ecomAppStore === "woocommerce") && (
                    <>
                      <Grid item xs={3}>
                        <Box py={2} px={2} my={2} className={classes.container}>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{
                              fontWeight: "bold",
                              marginBottom: "10px",
                            }}
                          >
                            E-Commerce App Store
                          </Typography>
                          <Typography variant="body1" gutterBottom>
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={() => this.handleEcomDrawerOpen(template)}
                            >
                              {template.ecomAppStore === "shopify"
                                ? "Shopify Logs"
                                : "Woo Commerce Logs"}
                            </Button>
                          </Typography>
                        </Box>
                      </Grid>
                      <div>
                        <Drawer
                          anchor="right"
                          open={isEcomDrawerOpen}
                          onClose={this.handleEcomDrawerClose}
                          className={classes.ecomDrawerWidth}
                        >
                          <Box style={{ padding: "16px" }}>
                            <Typography
                              variant="h5"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                height: "50px",
                                alignItems: "center",
                                marginBottom: "20px",
                                background: "#EBF5F3",
                              }}
                            >
                              {template.ecomAppStore === "shopify"
                                ? "Shopify Logs"
                                : "Woo Commerce Logs"}
                            </Typography>
                            {template.ecomAppStore === "woocommerce" ? (
                              <>
                                <Tabs
                                  value={selectedWooCommerceTab}
                                  onChange={this.handleWooCommerceTabChange}
                                  indicatorColor="primary"
                                  textColor="primary"
                                  variant="fullWidth"
                                  style={{ marginBottom: "20px" }}
                                >
                                  <Tab label="Orders" />
                                  <Tab label="Abandoned Orders" />
                                </Tabs>
                                {selectedWooCommerceTab === 0 &&
                                  (wooCommerceLogs.WooComOrderEvents.length === 0
                                    ? "No Logs found"
                                    : wooCommerceLogs.WooComOrderEvents.map(
                                      (log, index) => {
                                        const createdAtDate = new Date(
                                          log.dateCreated
                                        );
                                        const formattedDate = `${createdAtDate.toLocaleDateString()}`;
                                        const formattedTime = `${createdAtDate.toLocaleTimeString()}`;
                                        return (
                                          <div
                                            key={log._id}
                                            style={{
                                              borderBottom: "1px solid #ccc",
                                              marginBottom: "15px",
                                            }}
                                          >
                                            <Box
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Grid container spacing={2}>
                                                <Grid item xs={4}>
                                                  <Typography variant="body1">
                                                    {formattedDate}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                  <Typography variant="body1">
                                                    {formattedTime}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                              <IconButton
                                                onClick={() =>
                                                  this.handleToggleCollapse(
                                                    index,
                                                    "expandedWooCommerceLogIndex"
                                                  )
                                                }
                                              >
                                                <ExpandMore />
                                              </IconButton>
                                            </Box>
                                            <Collapse
                                              in={
                                                expandedWooCommerceLogIndex ===
                                                index
                                              }
                                              timeout="auto"
                                              unmountOnExit
                                            >
                                              <div
                                                style={{
                                                  marginBottom: "10px",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                <ReactJson
                                                  src={log}
                                                  collapsed={1}
                                                  displayDataTypes={false}
                                                  displayObjectSize={false}
                                                  enableClipboard={false}
                                                  name="Payload"
                                                />
                                              </div>
                                            </Collapse>
                                          </div>
                                        );
                                      }
                                    ))}
                                {selectedWooCommerceTab === 1 &&
                                  (wooCommerceLogs.WooComAbandonedEvents
                                    .length === 0
                                    ? "No Logs found"
                                    : wooCommerceLogs.WooComAbandonedEvents.map(
                                      (log, index) => {
                                        const createdAtDate = new Date(
                                          log.dateCreated
                                        );
                                        const formattedDate = `${createdAtDate.toLocaleDateString()}`;
                                        const formattedTime = `${createdAtDate.toLocaleTimeString()}`;
                                        return (
                                          <div
                                            key={log._id}
                                            style={{
                                              borderBottom: "1px solid #ccc",
                                              marginBottom: "15px",
                                            }}
                                          >
                                            <Box
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                  <Typography variant="body1">
                                                    {formattedDate}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                  <Typography variant="body1">
                                                    {formattedTime}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                              <IconButton
                                                onClick={() =>
                                                  this.handleToggleCollapse(
                                                    index,
                                                    "expandedWooCommerceLogIndex"
                                                  )
                                                }
                                              >
                                                <ExpandMore />
                                              </IconButton>
                                            </Box>
                                            <Collapse
                                              in={
                                                expandedWooCommerceLogIndex ===
                                                index
                                              }
                                              timeout="auto"
                                              unmountOnExit
                                            >
                                              <div
                                                style={{
                                                  marginBottom: "10px",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                <ReactJson
                                                  src={log}
                                                  collapsed={1}
                                                  displayDataTypes={false}
                                                  displayObjectSize={false}
                                                  enableClipboard={false}
                                                  name="Payload"
                                                />
                                              </div>
                                            </Collapse>
                                          </div>
                                        );
                                      }
                                    ))}
                              </>
                            ) : shopifyLogs.length === 0 ? (
                              "No Logs found"
                            ) : (
                              shopifyLogs.map((log, index) => {
                                const createdAtDate = new Date(log.createdAt);
                                const formattedDate = `${createdAtDate.toLocaleDateString()}`;
                                const formattedTime = `${createdAtDate.toLocaleTimeString()}`;
                                return (
                                  <div
                                    key={log._id}
                                    style={{
                                      borderBottom: "1px solid #ccc",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    <Box
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                          <Typography variant="body1">
                                            {log.jobType}
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                          <Typography variant="body1">
                                            {formattedDate}
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                          <Typography variant="body1">
                                            {formattedTime}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                      <IconButton
                                        onClick={() =>
                                          this.handleToggleCollapse(
                                            index,
                                            "expandedLogIndex"
                                          )
                                        }
                                      >
                                        <ExpandMore />
                                      </IconButton>
                                    </Box>
                                    <Collapse
                                      in={expandedLogIndex === index}
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <div
                                        style={{
                                          marginBottom: "10px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        <ReactJson
                                          src={log.payload}
                                          collapsed={1}
                                          displayDataTypes={false}
                                          displayObjectSize={false}
                                          enableClipboard={false}
                                          name="Payload"
                                        />
                                      </div>
                                    </Collapse>
                                  </div>
                                );
                              })
                            )}
                          </Box>
                        </Drawer>
                      </div>
                    </>
                  )}
              </Grid>

              {/* ── WEBHOOK TYPE CARD ── */}
              <Box py={2} px={2} my={2} className={classes.container}>
                <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 32 }}>
                  <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                    <Typography variant="body1" style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                      Select Log Type :
                    </Typography>
                    <FormControl
                      variant="outlined"
                      size="small"
                      style={{ minWidth: 220, background: "white", borderRadius: 4 }}
                    >
                      <Select
                        value={webhookNamespace}
                        displayEmpty
                        onChange={(e) => this.resetWebhookFilters(e.target.value)}
                      >
                        <MenuItem value=""><em>Select Type</em></MenuItem>
                        {WEBHOOK_NAMESPACES.map((ns) => (
                          <MenuItem key={ns.value} value={ns.value}>{ns.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                </Box>
              </Box>

              {/* ── ADDITIONAL FILTERS CARD ── */}
              {webhookNamespace && (
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Box
                    display="flex"
                    alignItems="center"
                    onClick={() => this.setState({ webhookFiltersOpen: !webhookFiltersOpen })}
                    style={{ cursor: "pointer", userSelect: "none", width: "fit-content" }}
                  >
                    <Typography variant="body1" style={{ fontWeight: "bold" }}>
                      Additional Filters
                    </Typography>
                    <ExpandMore
                      fontSize="small"
                      style={{
                        marginLeft: 6,
                        transition: "transform 0.2s",
                        transform: webhookFiltersOpen ? "rotate(180deg)" : "rotate(0deg)",
                      }}
                    />
                  </Box>

                  <Collapse in={webhookFiltersOpen}>
                    <Box
                      style={{
                        background: "white",
                        borderRadius: 8,
                        padding: "20px 16px",
                        marginTop: 16,
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      {/* Sub Type row — DirectApiWebhook only */}
                      {webhookNamespace === "DirectApiWebhook" && (
                        <Box display="flex" alignItems="center" style={{ gap: 16, marginBottom: 20 }}>
                          <Typography
                            variant="body2"
                            style={{ fontWeight: "bold", minWidth: 110, color: "#444" }}
                          >
                            Sub Type :
                          </Typography>
                          <FormControl
                            variant="outlined"
                            size="small"
                            style={{ minWidth: 200, background: "white", borderRadius: 4 }}
                          >
                            <Select
                              value={webhookSubType}
                              displayEmpty
                              onChange={(e) =>
                                this.setState({
                                  webhookSubType: e.target.value,
                                  webhookFilterValues: {},
                                  webhookLogsCache: {},
                                })
                              }
                            >
                              <MenuItem value=""><em>Select Sub Type</em></MenuItem>
                              {DIRECT_API_SUBTYPES.map((st) => (
                                <MenuItem key={st.value} value={st.value}>{st.label}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Box>
                      )}

                      {/* Date row */}
                      <Box display="flex" alignItems="center" style={{ gap: 16, marginBottom: 20 }}>
                        <Typography
                          variant="body2"
                          style={{ fontWeight: "bold", minWidth: 110, color: "#444" }}
                        >
                          Date :
                        </Typography>
                        <Box style={{ background: "white" }}>
                          <DateFilter
                            filterKey="webhookDelivery"
                            filterName=""
                            classes={classes}
                            applied={applied}
                            setDate={this.setDate}
                            setFocus={this.setFocus}
                            checkDateInput={() => { }}
                            clearDate={this.clearDate}
                            isOutsideRange={(day) =>
                              day.isAfter(moment(), "day") ||
                              day.isBefore(moment().subtract(3, "months"), "day")
                            }
                          />
                        </Box>
                        {applied.webhookDelivery.startDate && (
                          <>
                            <Typography
                              variant="body2"
                              style={{ color: "#666", whiteSpace: "nowrap" }}
                            >
                              From
                            </Typography>
                            <TextField
                              type="time"
                              size="small"
                              variant="outlined"
                              value={webhookStartTime}
                              onChange={(e) =>
                                this.setState({
                                  webhookStartTime: e.target.value,
                                  webhookLogsCache: {},
                                })
                              }
                              inputProps={{ step: 1 }}
                              InputLabelProps={{ shrink: true }}
                              style={{ width: 140, background: "white" }}
                            />
                            <Typography
                              variant="body2"
                              style={{ color: "#666", whiteSpace: "nowrap" }}
                            >
                              To
                            </Typography>
                            <TextField
                              type="time"
                              size="small"
                              variant="outlined"
                              value={webhookEndTime}
                              onChange={(e) =>
                                this.setState({
                                  webhookEndTime: e.target.value,
                                  webhookLogsCache: {},
                                })
                              }
                              inputProps={{ step: 1 }}
                              InputLabelProps={{ shrink: true }}
                              style={{ width: 140, background: "white" }}
                            />
                            <Typography
                              variant="caption"
                              style={{ color: "#888", whiteSpace: "nowrap" }}
                            >
                              blank = whole day
                            </Typography>
                            <Tooltip title="Clear date and time">
                              <IconButton
                                size="small"
                                onClick={() => {
                                  this.clearDate("webhookDelivery");
                                  this.setState({
                                    webhookStartTime: "",
                                    webhookEndTime: "",
                                    webhookLogsCache: {},
                                  });
                                }}
                              >
                                <Clear fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </>
                        )}
                      </Box>

                      {/* Dynamic fields — 2 columns */}
                      {activeFilterFields.length > 0 && (
                        <Grid container spacing={2}>
                          {activeFilterFields.map((field) => (
                            <Grid item xs={12} sm={6} key={field.key}>
                              <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                                <Typography
                                  variant="body2"
                                  style={{ fontWeight: "bold", minWidth: 90, flexShrink: 0, color: "#444" }}
                                >
                                  {field.label} :
                                </Typography>
                                <TextField
                                  value={webhookFilterValues[field.key] || ""}
                                  onChange={(e) =>
                                    this.setState({
                                      webhookFilterValues: {
                                        ...webhookFilterValues,
                                        [field.key]: e.target.value,
                                      },
                                    })
                                  }
                                  style={{ flex: 0.75, minWidth: 140, border: "1px solid", background: "white" }}
                                />
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      )}
                    </Box>
                  </Collapse>
                </Box>
              )}

              {/* ── ACTIONS ── */}
              <Box px={2} my={2} display="flex" style={{ gap: 12 }}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={webhookLogsLoading || !webhookNamespace}
                  onClick={() =>
                    this.setState({ webhookLogsCache: {} }, () =>
                      this.loadWebhookLogs(0, true)
                    )
                  }
                >
                  Apply
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={this.resetAllWebhookFilters}
                >
                  Reset
                </Button>
              </Box>

              {/* ── LOGS ── */}
              {webhookLogsLoading ? (
                <Box display="flex" justifyContent="center" mt={6}>
                  <CircularProgress size={32} />
                </Box>
              ) : !webhookLogsFetched ? (
                <Box display="flex" justifyContent="center" mt={6}>
                  <Typography variant="body2" style={{ color: "#888" }}>
                    Select a webhook type and click Apply to load logs
                  </Typography>
                </Box>
              ) : webhookLogs.length === 0 ? (
                <Box display="flex" justifyContent="center" mt={6}>
                  <Typography variant="body2" style={{ color: "#888" }}>
                    No Logs found
                  </Typography>
                </Box>
              ) : (
                <Box py={2} px={2} mt={6} mb={2} className={classes.container}>
                  <Box
                    style={{
                      background: "white",
                      borderRadius: 10,
                      padding: "16px",
                    }}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mb={2}
                    >
                      <Typography variant="body2" style={{ color: "#666" }}>
                        Showing {webhookLogs.length} log{webhookLogs.length !== 1 ? "s" : ""}
                      </Typography>
                      <Button
                        variant="outlined"
                        size="small"
                        color="primary"
                        startIcon={<GetApp />}
                        onClick={this.exportWebhookLogsToCSV}
                      >
                        Export CSV
                      </Button>
                    </Box>
                    {webhookLogs.map((log, index) => {
                      return (
                        <div
                          key={index}
                          style={{ borderBottom: "1px solid #ccc", marginBottom: "15px" }}
                        >
                          <div style={{ marginBottom: "10px", fontSize: "12px", background: "white" }}>
                            <Box display="flex" alignItems="center" mb={0.5}>
                              <Typography style={{ fontWeight: 600, fontSize: 12, color: "#333" }}>
                                {`Log ${webhookLogsPage * this.state.limit + index + 1}`}
                              </Typography>
                              <Tooltip title="Copy log">
                                <IconButton
                                  size="small"
                                  style={{ color: "#1976d2", padding: 2, marginLeft: 4 }}
                                  onClick={() =>
                                    navigator.clipboard
                                      .writeText(JSON.stringify(log, null, 2))
                                      .then(() =>
                                        this.setState({
                                          alert: true,
                                          alertMsg: "Log copied to clipboard!",
                                          alertSeverity: "success",
                                        })
                                      )
                                  }
                                >
                                  <FileCopyIcon style={{ fontSize: 14 }} />
                                </IconButton>
                              </Tooltip>
                            </Box>
                            <ReactJson
                              src={log}
                              displayDataTypes={false}
                              displayObjectSize={false}
                              enableClipboard={false}
                              collapsed={true}
                              name={false}
                            />
                            <Typography variant="body1">
                              Status:{" "}
                              <span style={{ color: statusColor(log), fontWeight: 600 }}>
                                {webhookStatusLabel(log)}
                              </span>
                            </Typography>
                            <Typography variant="body1">
                              Date:{" "}
                              {log.createdAt
                                ? new Date(log.createdAt).toLocaleString()
                                : "—"}
                            </Typography>
                          </div>
                        </div>
                      );
                    })}
                    {webhookLogs.length > 0 && (
                      <Box display="flex" justifyContent="center">
                        <TablePagination
                          component="div"
                          count={
                            webhookLogsHasMore
                              ? (webhookLogsPage + 1) * this.state.limit + this.state.limit
                              : webhookLogsPage * this.state.limit + webhookLogs.length
                          }
                          page={webhookLogsPage}
                          rowsPerPage={this.state.limit}
                          rowsPerPageOptions={[10, 25, 50, 100]}
                          onRowsPerPageChange={(e) => {
                            const newLimit = parseInt(e.target.value, 10);
                            this.setState(
                              { limit: newLimit, webhookLogsCache: {} },
                              () => this.loadWebhookLogs(0)
                            );
                          }}
                          onPageChange={(_, newPage) =>
                            this.loadWebhookLogs(newPage)
                          }
                        />
                      </Box>
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          );
        },
      },
      {
        label: "Meta Ads",
        key: "metaAds",
        render: () => {
          const hasWriteAccess = verifySubRouteAccess(
            subRoutes,
            "metaAds",
            "write"
          );
          return (
            <fieldset
              disabled={!hasWriteAccess}
              style={{ border: "none", padding: 0, margin: 0 }}
            >
              <Box py={2} px={2} my={2} className={classes.outerContainer}>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography variant="h5">
                    <b>Meta Ad Account ID :</b>{" "}
                    {templates[templateIndex].selectedMetaAdAccountId}
                  </Typography>
                  <Typography variant="h5">
                    <b>Meta User ID :</b>{" "}
                    {templates[templateIndex].selectedMetaUserId}
                  </Typography>
                  <Typography variant="h5">
                    <b>Meta Page ID :</b>{" "}
                    {templates[templateIndex].selectedMetaPageId}
                  </Typography>
                </Box>
                <Box py={2} px={2} my={2} className={classes.container}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Meta Ads Credit (v2 & v3) - Enter amount in +/-
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Current Balance - {`${template.currency} `}
                    {template.metaAdsCredit
                      ? template.metaAdsCredit / 100000
                      : 0}
                  </Typography>
                  <Box my={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          style={{
                            width: "48%",
                            border: "1px solid ",
                            background: "white",
                            marginRight: 10,
                          }}
                          name="metaAdsCredit"
                          type="number"
                          onChange={this.handleInput}
                          value={this.state.metaAdsCredit}
                        />
                        <TextField
                          style={{
                            width: "48%",
                            border: "1px solid ",
                            background: "white",
                          }}
                          name="metaCreditRemarks"
                          onChange={this.handleNumberInput}
                          placeholder="Enter Remarks"
                          value={this.state.metaCreditRemarks}
                          required
                        />
                      </Grid>
                      <Grid item>
                        <Tooltip
                          title={
                            !this.state.metaCreditRemarks
                              ? "Please enter payment remarks"
                              : ""
                          }
                        >
                          <span>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                this.updateMetaCredit();
                                this.setState({
                                  metaCreditRemarks: undefined,
                                });
                              }}
                              disabled={!this.state.metaCreditRemarks}
                            >
                              Update Meta Credit
                            </Button>
                          </span>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
                {this.state.isAdsMangerSetupPresent &&
                  !this.state.fbConnectedAssistantId && (
                    <Box py={2} px={2} my={2} className={classes.container}>
                      <Typography
                        gutterBottom
                        variant="body1"
                        style={{ fontWeight: "bold" }}
                      >
                        Remove Ads Manager Setup
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        Remove Ads Manager Setup associated with this project
                      </Typography>

                      <Grid item xs={12} style={{ marginTop: "1rem" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={this.checkCampaignStatus}
                            disabled={
                              this.state.fetchCampaignStatusLoader &&
                              !this.state.setCampaignStatusLoader
                            }
                          >
                            Remove Ads Manager Setup
                          </Button>

                          {this.state.fetchCampaignStatusLoader &&
                            !this.state.setCampaignStatusLoader && (
                              <CircularProgress
                                size={24}
                                style={{ marginLeft: 16 }}
                              />
                            )}
                          <Dialog
                            open={this.state.removeAdsSetupManagerDialog}
                            onClose={() =>
                              this.setState({
                                removeAdsSetupManagerDialog: false,
                              })
                            }
                          >
                            {/* <DialogTitle>Confirm Delete</DialogTitle> */}
                            <DialogContent>
                              <DialogContentText>
                                Are you sure you want to Remove Ads Manager
                                Setup?
                              </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                              <Button
                                onClick={() =>
                                  this.setState({
                                    removeAdsSetupManagerDialog: false,
                                  })
                                }
                                color="primary"
                              >
                                Cancel
                              </Button>
                              <Button
                                onClick={this.removeAdsSetupManager}
                                color="primary"
                                autoFocus
                                disabled={this.state.adsSetupDeletionInProgress}
                              >
                                {this.state.adsSetupDeletionInProgress
                                  ? "Deleting..."
                                  : "Delete"}
                              </Button>
                            </DialogActions>
                          </Dialog>

                          <Dialog
                            open={this.state.pauseAllCampaignsDialog}
                            onClose={() =>
                              this.setState({
                                pauseAllCampaignsDialog: false,
                              })
                            }
                          >
                            {/* <DialogTitle>Confirm Delete</DialogTitle> */}
                            <IconButton
                              onClick={() =>
                                this.setState({
                                  pauseAllCampaignsDialog: false,
                                })
                              }
                              style={{
                                marginLeft: "auto",
                              }}
                            >
                              <Close />
                            </IconButton>
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "space-around",
                              }}
                            >
                              <p>Status: {this.state.allCampaignStatus}</p>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {this.state.setCampaignStatusLoader && (
                                  <CircularProgress
                                    size={20}
                                    style={{ marginRight: "10px" }}
                                  />
                                )}
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={
                                        this.state.allCampaignStatus ===
                                        "ACTIVE"
                                      }
                                      onChange={() =>
                                        this.setAllCampaignStatus()
                                      }
                                      color="primary"
                                      disabled={
                                        this.state.setCampaignStatusLoader
                                      }
                                    />
                                  }
                                  label={
                                    this.state.allCampaignStatus === "ACTIVE"
                                      ? "Active"
                                      : "Paused"
                                  }
                                />
                              </div>
                            </div>
                            <p
                              style={{
                                margin: 0,
                                marginLeft: "40px",
                                fontSize: "11px",
                              }}
                            >
                              Total Campaigns: {this.state.campaigns.length}
                            </p>
                            <DialogContent>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  maxHeight: "500px",
                                  width: "350px",
                                  overflow: "scroll",
                                }}
                              >
                                {this.state.campaigns.map((campaign) => (
                                  <div
                                    style={{
                                      padding: "5px",
                                      margin: "4px 0",
                                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      borderRadius: "4px",
                                      backgroundColor: "#fff",
                                      border: "1px solid #e0e0e0",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <p style={{ margin: 0 }}>
                                        {" "}
                                        {campaign.name}
                                      </p>
                                      <p style={{ margin: 0 }}>
                                        {campaign.status}
                                      </p>
                                    </div>
                                    <p style={{ margin: 0, fontSize: "11px" }}>
                                      id: {campaign.id}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            </DialogContent>
                          </Dialog>
                        </div>
                      </Grid>
                    </Box>
                  )}

                {this.state.fbConnectedAssistantId && (
                  <Box
                    py={2}
                    px={2}
                    my={2}
                    className={classes.container}
                    style={{ display: "flex" }}
                  >
                    <Typography
                      gutterBottom
                      variant="body1"
                      style={{ fontWeight: "bold" }}
                    >
                      Project Id with Ads Setup:{" "}
                      {this.state.fbConnectedAssistantId}
                    </Typography>

                    <IconButton
                      onClick={() => {
                        navigator.clipboard.writeText(
                          this.state.fbConnectedAssistantId
                        );
                        this.setState({
                          alert: true,
                          alertMsg: "Project ID copied successfully",
                          alertSeverity: "success",
                        });
                      }}
                      size="small"
                      style={{
                        marginLeft: 8,
                        backgroundColor: "#d6d6d6",
                      }}
                    >
                      <FileCopyIcon
                        style={{
                          fontSize: "15px",
                        }}
                      />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </fieldset>
          );
        },
      },
      {
        label: "Forms",
        key: "forms",
        render: () => {
          const hasWriteAccess = verifySubRouteAccess(
            subRoutes,
            "forms",
            "write"
          );
          return (
            <fieldset
              disabled={!hasWriteAccess}
              style={{ border: "none", padding: 0, margin: 0 }}
            >
              <Box py={2} px={2} my={2} className={classes.outerContainer}>
                <Flows
                  assistantDetails={
                    this.props.templates[this.props.templateIndex]
                  }
                />
              </Box>
            </fieldset>
          );
        },
      },
      {
        label: "Google Ads",
        key: "googleAds",
        render: () => {

          if (this.state.googleAdsConfigLoading) {
            return <CircularProgress />;
          }

          const hasWriteAccess = verifySubRouteAccess(subRoutes, "googleAds", "write");

          const isConversionConfigured = this.state.googleAdsConversionSaved || this.state.googleAdsConversionFetchFailed;
          const isWidgetConfigured = this.state.widgetLinkSaved || this.state.widgetLinkFetchFailed;
          const isFullyConfigured = isConversionConfigured && isWidgetConfigured;
          const hasFetchError = this.state.googleAdsConversionFetchFailed || this.state.widgetLinkFetchFailed;

          return (
            <fieldset
              disabled={!hasWriteAccess}
              style={{ border: "none", padding: 0, margin: 0 }}
            >
              <Box py={2} px={2} my={2} className={classes.outerContainer}>

                {hasFetchError ? (
                  <Box py={2} px={2} my={2} className={classes.container}>
                    <Typography variant="body2" style={{ color: "red" }}>
                      Failed to load configuration. Please refresh or contact support.
                    </Typography>
                  </Box>
                ) : (
                  <>
                    {/* Current saved values display */}
                    <Box py={2} px={2} my={2} className={classes.container}>
                      <Typography variant="h5">
                        <b>Ad Account ID :</b> {this.state.savedGoogleAdAccountId || "-"}
                      </Typography>
                      <Typography variant="h5">
                        <b>Widget ID :</b> {this.state.savedWidgetId || "-"}
                      </Typography>
                      <Typography variant="h5">
                        <b>Click Conversion ID :</b> {this.state.savedGoogleClickConversionId || "-"}
                      </Typography>
                      <Typography variant="h5">
                        <b>Conversation Initiated ID :</b> {this.state.savedGoogleConversationInitiatedId || "-"}
                      </Typography>
                    </Box>

                    {/* Input fields */}
                    <Box py={2} px={2} my={2} className={classes.container}>
                      {isFullyConfigured && (
                        <Typography
                          variant="body2"
                          style={{ color: "grey", marginBottom: "1rem" }}
                        >
                          Note: Configuration has been set. Contact support to make changes.
                        </Typography>
                      )}
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography variant="body1" gutterBottom style={{ fontWeight: "bold" }}>
                            Ad Account ID
                          </Typography>
                          <TextField
                            name="googleAdAccountId"
                            value={this.state.googleAdAccountId}
                            onChange={this.handleNumberInput}
                            disabled={isConversionConfigured}
                            style={{
                              width: "100%",
                              border: "1px solid",
                              background: isConversionConfigured ? "#f5f5f5" : "white",
                            }}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <Typography variant="body1" gutterBottom style={{ fontWeight: "bold" }}>
                            Widget ID
                          </Typography>
                          <TextField
                            name="widgetId"
                            value={this.state.widgetId}
                            onChange={this.handleNumberInput}
                            disabled={isWidgetConfigured}
                            style={{
                              width: "100%",
                              border: "1px solid",
                              background: isWidgetConfigured ? "#f5f5f5" : "white",
                            }}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <Typography variant="body1" gutterBottom style={{ fontWeight: "bold" }}>
                            Click Conversion ID
                          </Typography>
                          <TextField
                            name="googleClickConversionId"
                            value={this.state.googleClickConversionId}
                            onChange={this.handleNumberInput}
                            disabled={isConversionConfigured}
                            style={{
                              width: "100%",
                              border: "1px solid",
                              background: isConversionConfigured ? "#f5f5f5" : "white",
                            }}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <Typography variant="body1" gutterBottom style={{ fontWeight: "bold" }}>
                            Conversation Initiated ID
                          </Typography>
                          <TextField
                            name="googleConversationInitiatedId"
                            value={this.state.googleConversationInitiatedId}
                            onChange={this.handleNumberInput}
                            disabled={isConversionConfigured}
                            style={{
                              width: "100%",
                              border: "1px solid",
                              background: isConversionConfigured ? "#f5f5f5" : "white",
                            }}
                          />
                        </Grid>

                        {/* Save button — hide only when both are fully configured */}
                        {!isFullyConfigured && (
                          <Grid item xs={12}>
                            <Tooltip
                              title={
                                (!isConversionConfigured && (
                                  !this.state.googleAdAccountId ||
                                  !this.state.googleClickConversionId ||
                                  !this.state.googleConversationInitiatedId
                                )) ||
                                  (!isWidgetConfigured && !this.state.widgetId)
                                  ? "Please fill all required fields"
                                  : ""
                              }
                            >
                              <span>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={this.updateGoogleAdsConfig}
                                  disabled={
                                    (!isConversionConfigured && (
                                      !this.state.googleAdAccountId ||
                                      !this.state.googleClickConversionId ||
                                      !this.state.googleConversationInitiatedId
                                    )) ||
                                    (!isWidgetConfigured && !this.state.widgetId)
                                  }
                                >
                                  Save
                                </Button>
                              </span>
                            </Tooltip>
                          </Grid>
                        )}
                      </Grid>
                    </Box>
                  </>
                )}
                <Box py={2} px={2} my={2} className={classes.container}>
                  <ConversionEventsTable assistantId={template._id} />
                </Box>
              </Box>
            </fieldset>
          );
        },
      },
    ];

    const visibleTabs = tabConfigs.filter((tab) => {
      if (tab.key === "googleAds" && TENANT_ID) return false;
      //  Integrations tears down a customer's live connections, so it is
      //  full-access only rather than role driven. Must be the RAW acl —
      //  state.login.permissions is the expanded tree, which a role with every
      //  box ticked is indistinguishable from.
      if (tab.key === "integrations") {
        return isGlobalAdmin(this.props.agent?.permissions);
      }
      return verifySubRouteAccess(subRoutes, tab.key, "read");
    });

    return (
      <>
        <div className={classes.root}>
          <Box style={{ display: "flex" }}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={tabValue}
              onChange={this.handleTabs}
              aria-label="Vertical tabs"
              style={{
                width: "15%",
                position: "fixed",
                top: "0",
                marginTop: "6%",
                zIndex: "2",
              }}
              classes={{ indicator: classes.indicator }}
            >
              {visibleTabs.map((tab, idx) => (
                <Tab
                  key={tab.label}
                  label={tab.label}
                  style={
                    tabValue === idx
                      ? { backgroundColor: "rgb(237 226 252 / 37%)" }
                      : {}
                  }
                />
              ))}
            </Tabs>
          </Box>
          <Box
            px={2}
            className={classes.dialogContainer}
            style={{ marginTop: "-20px" }}
          >
            <Grid
              container
              alignItems="center"
              className={classes.dialogTopbar}
            >
              <Grid item>
                <IconButton onClick={toggleDialog} style={{ marginTop: "8px" }}>
                  <ArrowBackOutlined />
                </IconButton>
              </Grid>
              <Grid item style={{ flexGrow: 1, marginTop: "10px" }}>
                {template.assistantName}
                {hasWriteAccess && (
                  <IconButton
                    onClick={() => {
                      this.openAssistantNameDialog();
                    }}
                  >
                    <Edit fontSize="small" />
                  </IconButton>
                )}
              </Grid>

              {/* Assistant Name change Dialog */}

              <div>
                <Dialog
                  open={this.state.assistantNameDialog}
                  onClose={this.closeAssistantNameDialog}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  PaperProps={{
                    style: { height: "20%", width: "35%" },
                  }}
                >
                  <DialogContent>
                    <DialogContentText>
                      Enter new project name:
                    </DialogContentText>
                    <TextField
                      name="changeAssistantName"
                      value={this.state.changeAssistantName}
                      onChange={this.handleChange}
                      style={{
                        width: "80%",
                        border: "1px solid ",
                        background: "white",
                      }}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={this.closeAssistantNameDialog}
                      color="primary"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={() => {
                        this.closeAssistantNameDialog();
                        this.openConfirmNameDialog();
                      }}
                      color="primary"
                      disabled={!this.state.changeAssistantName}
                    >
                      Confirm
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
              <div>
                <Dialog
                  open={this.state.nameConfirmationDialog}
                  onClose={this.closeConfirmNameDialog}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  PaperProps={{
                    style: { height: "18%", width: "35%" },
                  }}
                >
                  <DialogContent>
                    <Typography
                      variant="body1"
                      style={{
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "16px",
                      }}
                    >
                      Are you sure you want to change project name from <br />
                      <b>{template.assistantName}</b> to{" "}
                      <b>{this.state.changeAssistantName}</b>?
                    </Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={this.closeConfirmNameDialog}
                      color="primary"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={() => {
                        this.updateAssistantName();
                        this.closeConfirmNameDialog();
                      }}
                      color="primary"
                    >
                      Yes
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>

              <Grid item>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "8px",
                  }}
                >
                  {this.props.templates[this.props.templateIndex].partnerId ? (
                    <Typography
                      variant="h5"
                      align="center"
                      style={{ marginTop: "10px", marginRight: "10px" }}
                    >
                      Partner ID:
                      {" " +
                        this.props.templates[this.props.templateIndex]
                          .partnerId}
                    </Typography>
                  ) : this.props.templates[this.props.templateIndex]
                    .affiliateId ? (
                    <Typography
                      variant="h5"
                      align="center"
                      style={{ marginTop: "10px", marginRight: "10px" }}
                    >
                      Affiliate ID:
                      {" " +
                        this.props.templates[this.props.templateIndex]
                          .affiliateId}
                    </Typography>
                  ) : (
                    <></>
                  )}
                  {/* View Logs Button */}
                  {(TENANT_ID && this.props.agent.power >= 10) ||
                    this.props.agent.power >= 12 ? (
                    <>
                      {/* <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleDrawerOpen}
                      >
                        View Logs
                      </Button> */}
                    </>
                  ) : (
                    <></>
                  )}

                  {/* Owner Login Button */}
                  {hasLoginAccess && (
                    <>
                      {this.props.templates[this.props.templateIndex]
                        .partnerId ? (
                        <>
                          <ButtonGroup
                            variant="contained"
                            color="primary"
                            style={{ marginRight: "7px" }}
                            ref={this.anchorRef}
                            aria-label="Button group with a nested menu"
                          >
                            <Button onClick={this.handleHoverOpen}>
                              {ownerLoginLabel("Login", ownerLogin)}
                            </Button>
                            <Button
                              size="small"
                              aria-controls={
                                open ? "split-button-menu" : undefined
                              }
                              aria-expanded={open ? "true" : undefined}
                              aria-label="select action"
                              aria-haspopup="menu"
                              onClick={this.handleHoverOpen}
                            >
                              <ArrowDropDown onClick={this.handleHoverOpen} />
                            </Button>
                          </ButtonGroup>
                          <Popper
                            sx={{ zIndex: 1 }}
                            open={open}
                            anchorEl={this.anchorRef.current}
                            role={undefined}
                            transition
                            disablePortal
                            placement="bottom-start"
                            // onMouseEnter={this.handleHoverOpen}
                            // onMouseLeave={this.handleHoverClose}
                            ref={this.setPopperNode}
                          >
                            {({ TransitionProps, placement }) => (
                              <Grow
                                {...TransitionProps}
                                style={{
                                  transformOrigin:
                                    placement === "bottom"
                                      ? "center top"
                                      : "center bottom",
                                }}
                              >
                                <Paper onMouseLeave={this.handleHoverClose}>
                                  <MenuList
                                    id="split-button-menu"
                                    autoFocusItem
                                  >
                                    {ownerLoginMenu(options, {
                                      mode: ownerLogin,
                                      partnerId:
                                        this.props.templates[
                                          this.props.templateIndex
                                        ].partnerId,
                                      vyapaarPartnerId:
                                        "674de8270c6de80c169481b8",
                                    }).map(({ label, index }) => (
                                      <MenuItem
                                        key={label}
                                        onClick={(event) =>
                                          this.handleMenuItemClick(event, index)
                                        }
                                      >
                                        {label}
                                      </MenuItem>
                                    ))}
                                  </MenuList>
                                </Paper>
                              </Grow>
                            )}
                          </Popper>
                        </>
                      ) : (
                        <>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={() => this.loginAsOwner("owner")}
                            style={{ marginRight: "10px" }}
                          >
                            {ownerLoginLabel("Login", ownerLogin)}
                          </Button>
                          <Button
                            color="primary"
                            variant="contained"
                            style={{ marginRight: "10px" }}
                            onClick={() => this.loginAsOwner("copy")}
                          >
                            {ownerLoginLabel("Copy Login URL", ownerLogin)}
                          </Button>
                        </>
                      )}
                    </>
                  )}
                  {(TENANT_ID && this.props.agent.power >= 10) ||
                    hasViewLogsAccess ? (
                    <>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleDrawerOpen}
                      >
                        View Logs
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </Grid>
            </Grid>
            <div>
              <Drawer
                anchor="right"
                open={this.state.isDrawerOpen}
                onClose={this.handleDrawerClose}
                className={classes.drawerWidth}
              >
                <Box style={{ padding: "16px" }}>
                  <Typography
                    variant="h5"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      height: "50px",
                      alignItems: "center",
                      marginBottom: "20px",
                      background: "#EBF5F3",
                    }}
                  >
                    Admin Logs
                  </Typography>
                  {this.state.logs.length === 0
                    ? "No Logs found"
                    : this.state.logs.map((log, index) => {
                      const createdAtDate = new Date(log.createdAt);
                      const formattedDate = `${createdAtDate.toLocaleDateString()}`;
                      const formattedTime = `${createdAtDate.toLocaleTimeString()}`;
                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            borderBottom: "1px solid #ccc",
                            paddingBottom: "10px",
                            marginBottom: "15px",
                          }}
                        >
                          <div>
                            <div
                              style={{
                                marginBottom: "10px",
                                fontSize: "12px",
                              }}
                            >
                              <ReactJson
                                src={log.body}
                                displayDataTypes={false}
                                displayObjectSize={false}
                                enableClipboard={false}
                                name="Changes"
                              />
                            </div>
                            <Typography variant="body1">
                              Name: {log.displayName}
                            </Typography>
                            <Typography variant="body1">
                              Date: {formattedDate}
                            </Typography>
                            <Typography variant="body1">
                              Time: {formattedTime}
                            </Typography>
                            <Typography variant="body1">
                              <Typography
                                variant="body1"
                                style={{
                                  color: "#666",
                                  fontFamily: "monospace",
                                  backgroundColor: "#f5f5f5",
                                  padding: "0px 4px",
                                  borderRadius: "4px",
                                  display: "inline-block",
                                }}
                              >
                                Route: {log.endPoint}
                              </Typography>
                            </Typography>
                          </div>
                          {log?.body?.fields?.templateCredit && (
                            <Typography
                              variant="body1"
                              style={{
                                width: "43%",
                                color: "#0a474c",
                                fontWeight: "bold",
                              }}
                            >
                              Template Credit: {`${template.currency} `}
                              {log.body.fields.templateCredit /
                                Math.pow(10, 5)}
                            </Typography>
                          )}
                        </div>
                      );
                    })}
                </Box>
              </Drawer>
            </div>
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                paddingLeft: "5%",
                paddingRight: "3%",
                width: "100%",
                marginLeft: "13%",
              }}
            >
              {visibleTabs[tabValue]?.render()}
            </Box>
            <div className={classes.root}>
              <Grid container justify="center">
                <Grid item xs={12} md={8}>
                  <Box py={2} px={2} my={2}>
                    <Grid
                      container
                      justify="space-between"
                      alignItems="center"
                    ></Grid>
                  </Box>

                  {/* <Box py={2} px={2} my={2} className={classes.container}>
                {this.props.agent.power <= 10 ? (
                  <></>
                ) : (
                  <>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ fontWeight: "bold" }}
                    >
                      Login as owner
                    </Typography>
                    <Box
                      my={2}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={this.loginAsOwner}
                      >
                        Login
                      </Button>
                    </Box>
                  </>
                )}
              </Box> */}
                  {/* <Box py={2} px={2} my={2} className={classes.container}>
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ fontWeight: "bold" }}
                >
                  Sync Channel Status
                </Typography>
                <Grid container>
                  <Grid item>
                    <Typography variant="body1" gutterBottom>
                      <Button
                        style={{ marginLeft: 10 }}
                        color="primary"
                        variant="contained"
                        onClick={this.syncChannelStatus}
                      >
                        Sync Channel Status
                      </Button>
                    </Typography>
                  </Grid>
                </Grid>
              </Box> */}
                </Grid>
              </Grid>
            </div>
            {this.state.wabaInfo &&
              this.props.templates[this.props.templateIndex]
                ?.isWhatsappVerified === true &&
              this.props.templates[this.props.templateIndex]?.wabaProgressStep ===
              9 ? (
              <Fab
                color="primary"
                onClick={() => this.handleOpenWhatsAppLink(this.state.wabaInfo)}
                style={{
                  padding: "2rem",
                  position: "fixed",
                  bottom: "2rem",
                  right: "2rem",
                }}
              >
                <WhatsApp style={{ fontSize: "2.5rem" }} size="large" />
              </Fab>
            ) : null}

            <Snackbar
              open={this.state.alert}
              autoHideDuration={4000}
              onClose={this.closeSnackbar}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert
                onClose={this.closeSnackbar}
                severity={this.state.alertSeverity}
              >
                {this.state.alertMsg}
              </Alert>
            </Snackbar>

            {/* WhatsApp Verification Reason Dialog */}
            <Dialog
              open={this.state.verificationReasonDialog}
              onClose={() =>
                this.setState({ verificationReasonDialog: false })
              }
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle>Reason for Verification Status Change</DialogTitle>
              <DialogContent>
                <TextField
                  label="Reason"
                  value={this.state.verificationReason}
                  onChange={(e) =>
                    this.setState({ verificationReason: e.target.value })
                  }
                  multiline
                  rows={3}
                  fullWidth
                  variant="outlined"
                  autoFocus
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() =>
                    this.setState({ verificationReasonDialog: false })
                  }
                >
                  Cancel
                </Button>
                <Button
                  onClick={this.confirmVerificationStatusUpdate}
                  color="primary"
                  variant="contained"
                  disabled={!this.state.verificationReason.trim()}
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>

            {/* Dashboard Lock Modal */}
            <Dialog
              open={this.state.dashboardLockModalOpen}
              onClose={this.closeDashboardLockModal}
              maxWidth="md"
              fullWidth
            >
              <DashboardLockModal
                onClose={this.closeDashboardLockModal}
                onSuccess={this.handleDashboardLockSuccess}
                onError={this.handleDashboardLockError}
                assistantId={this.props.templates[this.props.templateIndex]?._id}
              />
            </Dialog>
          </Box>
        </div>
      </>
    );
  }
}

// function getFormattedDate(date) {
//   const d = new Date(date);
//   const options = { year: "numeric", month: "long", day: "numeric" };
//   return d.toLocaleDateString("en-US", options);
// }

function DateFilter({
  filterKey,
  applied,
  setFocus,
  setDate,
  checkDateInput,
  clearDate,
  isOutsideRange,
  ...props
}) {
  const { classes, filterName } = props;
  const A = applied[filterKey];
  return (
    <div className={classes.datePickerPosition}>
      <Grid item xs style={{ display: "flex", justifyContent: "flex-start" }}>
        <DateRangePicker
          startDatePlaceholderText="From"
          endDatePlaceholderText="To"
          onClose={() => checkDateInput(filterKey)}
          startDateId="startDate"
          endDateId="endDate"
          startDate={A.startDate}
          endDate={A.endDate}
          onDatesChange={({ startDate, endDate }) =>
            setDate(filterKey, startDate, endDate)
          }
          onFocusChange={(focusedInput) => setFocus(filterKey, focusedInput)}
          navPosition="navPositionTop"
          numberOfMonths={1}
          hideKeyboardShortcutsPanel
          customArrowIcon={true}
          screenReaderInputMessage={" "}
          small
          readOnly
          isOutsideRange={isOutsideRange || (() => false)}
          maxDate={moment(new Date())}
          minDate={moment("2023-04-25T12:31:17.617+00:00")}
          minimumNights={0}
          focusedInput={A.focusedInput}
        />
      </Grid>
    </div>
  );
}

const styles = (theme) => ({
  root: {
    // width: "100%",
    paddingTop: 20,
    overflowX: "hidden",
  },
  dialogContainer: {
    overflowX: "hidden",
    height: "100%",
    position: "relative",
    color: "black",
  },
  dialogTopbar: {
    position: "sticky",
    top: 0,
    left: 0,
    background: "white",
    zIndex: 100,
  },
  codeBox: {
    backgroundColor: "#eee",
    padding: "1rem",
    borderRadius: "12px",
    overflow: "auto",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
  },
  indicator: {
    backgroundColor: "rgb(70 20 134)",
  },
  outerContainer: {
    background: "#EBF5F3",
    borderRadius: "15px",
    width: "80%",
  },
  container: {
    background: "#EBF5F3",
    borderRadius: "15px",
  },
  disabledContainer: {
    background: "#dcdcdc",
    borderRadius: "15px",
  },
  textField: {
    width: 200,
  },
  drawerWidth: {
    "& .MuiDrawer-paper": {
      width: "32%",
    },
  },
  ecomDrawerWidth: {
    "& .MuiDrawer-paper": {
      width: "40%",
    },
  },
  wabaBilling: {
    background: "#EBF5F3",
    borderRadius: "15px",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gridGap: 14,
  },
  wabaInfo: {
    border: "1px solid #b0b0b0",
    width: "100%",
    padding: "16px",
    borderRadius: "8px",
    background: "#e9e9e9",
    margin: "10px 0px",
  },
  itemBox: {
    flex: "1 1 calc(50% - 16px)",
    margin: "8px",
    boxSizing: "border-box",
  },
  itemContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  selectFieldInput: {
    borderRadius: "8px",
    backgroundColor: "white",
    border: "1px solid black",
    padding: "12px",
  },
});
const connectedAssistant = connect((state) => ({
  agent: state.login.user,
  tenantDetails: state.tenant.tenant,
  permissions: state.login.permissions,
}))(Assistant);
export default withStyles(styles)(connectedAssistant);
